/* eslint-disable */
// This code was auto-generated by running
// npm run generate:types 
// Please do not modify this code by hand.


'use strict';
exports.validateWebApp = validate10;
const schema11 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'WebApp.json',
  title: 'WebApp',
  type: 'object',
  oneOf: [
    { $ref: 'AcceptTermsData.json' },
    { $ref: 'DropboxManagedCheckResponse.json' },
    { $ref: 'ErrorShape.json' },
    { $ref: 'SamlCheckResponse.json' },
    { $ref: 'SignInResponse.json' },
    { $ref: 'SignUpData.json' },
    { $ref: 'SignUpResponse.json' },
    { $ref: 'WebAppAccount.json' },
    { $ref: 'WebAppAccountSettings.json' },
    { $ref: 'WebAppSpaListing.json' },
  ],
};
const schema12 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'AcceptTermsData.json',
  type: 'object',
  title: 'AcceptTermsData',
  properties: {
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    emailAddress: { type: 'string' },
  },
  required: ['emailAddress'],
};
const schema14 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'ErrorShape.json',
  type: 'object',
  title: 'ErrorShape',
  properties: { code: { type: 'string' }, message: { type: 'string' } },
  required: ['message', 'code'],
};
const schema16 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SamlCheckResponse.json',
  type: 'object',
  title: 'SamlCheckResponse',
  properties: {
    saml: { type: 'boolean' },
    login_url: { type: 'string' },
    disable_arkose: { type: 'boolean' },
  },
  required: ['saml', 'login_url', 'disable_arkose'],
};
const schema45 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'WebAppSpaListing.json',
  type: 'object',
  title: 'WebAppSpaListing',
  properties: {
    data: { type: 'array' },
    numPages: { type: 'integer' },
    numResults: { type: 'integer' },
    numResultsTotal: { type: 'integer' },
    pageSize: { type: 'integer' },
    success: { type: 'boolean' },
  },
  required: ['success'],
};
const schema13 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'DropboxManagedCheckResponse.json',
  type: 'object',
  title: 'DropboxManagedCheckResponse',
  properties: {
    error: { oneOf: [{ $ref: 'ErrorShape.json' }, { type: 'null' }] },
  },
};
function validate11(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="DropboxManagedCheckResponse.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.error !== undefined) {
        let data0 = data.error;
        const _errs2 = errors;
        let valid1 = false;
        let passing0 = null;
        const _errs3 = errors;
        const _errs4 = errors;
        if (errors === _errs4) {
          if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
            let missing0;
            if (
              (data0.message === undefined && (missing0 = 'message')) ||
              (data0.code === undefined && (missing0 = 'code'))
            ) {
              const err0 = {
                instancePath: instancePath + '/error',
                schemaPath: 'ErrorShape.json/required',
                keyword: 'required',
                params: { missingProperty: missing0 },
                message: "must have required property '" + missing0 + "'",
              };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            } else {
              if (data0.code !== undefined) {
                const _errs6 = errors;
                if (typeof data0.code !== 'string') {
                  const err1 = {
                    instancePath: instancePath + '/error/code',
                    schemaPath: 'ErrorShape.json/properties/code/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var valid3 = _errs6 === errors;
              } else {
                var valid3 = true;
              }
              if (valid3) {
                if (data0.message !== undefined) {
                  const _errs8 = errors;
                  if (typeof data0.message !== 'string') {
                    const err2 = {
                      instancePath: instancePath + '/error/message',
                      schemaPath: 'ErrorShape.json/properties/message/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                  var valid3 = _errs8 === errors;
                } else {
                  var valid3 = true;
                }
              }
            }
          } else {
            const err3 = {
              instancePath: instancePath + '/error',
              schemaPath: 'ErrorShape.json/type',
              keyword: 'type',
              params: { type: 'object' },
              message: 'must be object',
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
        }
        var _valid0 = _errs3 === errors;
        if (_valid0) {
          valid1 = true;
          passing0 = 0;
        }
        const _errs10 = errors;
        if (data0 !== null) {
          const err4 = {
            instancePath: instancePath + '/error',
            schemaPath: '#/properties/error/oneOf/1/type',
            keyword: 'type',
            params: { type: 'null' },
            message: 'must be null',
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
        var _valid0 = _errs10 === errors;
        if (_valid0 && valid1) {
          valid1 = false;
          passing0 = [passing0, 1];
        } else {
          if (_valid0) {
            valid1 = true;
            passing0 = 1;
          }
        }
        if (!valid1) {
          const err5 = {
            instancePath: instancePath + '/error',
            schemaPath: '#/properties/error/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
          validate11.errors = vErrors;
          return false;
        } else {
          errors = _errs2;
          if (vErrors !== null) {
            if (_errs2) {
              vErrors.length = _errs2;
            } else {
              vErrors = null;
            }
          }
        }
      }
    } else {
      validate11.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate11.errors = vErrors;
  return errors === 0;
}
const schema17 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SignInResponse.json',
  type: 'object',
  title: 'SignInResponse',
  properties: {
    success: { type: 'boolean' },
    email: { type: 'string' },
    on_error_redirect_url: { anyOf: [{ type: 'string' }, { type: 'null' }] },
    on_login_redirect_url: { type: 'string' },
    notification: {
      $comment: 'The code cares whether this exists, but does NOT use it',
      anyOf: [
        {
          type: 'object',
          properties: { message: { type: 'string' }, type: { type: 'string' } },
        },
        { type: 'null' },
      ],
    },
    error: { oneOf: [{ $ref: 'ErrorShape.json' }, { type: 'null' }] },
  },
};
function validate13(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="SignInResponse.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.success !== undefined) {
        const _errs1 = errors;
        if (typeof data.success !== 'boolean') {
          validate13.errors = [
            {
              instancePath: instancePath + '/success',
              schemaPath: '#/properties/success/type',
              keyword: 'type',
              params: { type: 'boolean' },
              message: 'must be boolean',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.email !== undefined) {
          const _errs3 = errors;
          if (typeof data.email !== 'string') {
            validate13.errors = [
              {
                instancePath: instancePath + '/email',
                schemaPath: '#/properties/email/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.on_error_redirect_url !== undefined) {
            let data2 = data.on_error_redirect_url;
            const _errs5 = errors;
            const _errs6 = errors;
            let valid1 = false;
            const _errs7 = errors;
            if (typeof data2 !== 'string') {
              const err0 = {
                instancePath: instancePath + '/on_error_redirect_url',
                schemaPath: '#/properties/on_error_redirect_url/anyOf/0/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            }
            var _valid0 = _errs7 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const _errs9 = errors;
              if (data2 !== null) {
                const err1 = {
                  instancePath: instancePath + '/on_error_redirect_url',
                  schemaPath: '#/properties/on_error_redirect_url/anyOf/1/type',
                  keyword: 'type',
                  params: { type: 'null' },
                  message: 'must be null',
                };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var _valid0 = _errs9 === errors;
              valid1 = valid1 || _valid0;
            }
            if (!valid1) {
              const err2 = {
                instancePath: instancePath + '/on_error_redirect_url',
                schemaPath: '#/properties/on_error_redirect_url/anyOf',
                keyword: 'anyOf',
                params: {},
                message: 'must match a schema in anyOf',
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
              validate13.errors = vErrors;
              return false;
            } else {
              errors = _errs6;
              if (vErrors !== null) {
                if (_errs6) {
                  vErrors.length = _errs6;
                } else {
                  vErrors = null;
                }
              }
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.on_login_redirect_url !== undefined) {
              const _errs11 = errors;
              if (typeof data.on_login_redirect_url !== 'string') {
                validate13.errors = [
                  {
                    instancePath: instancePath + '/on_login_redirect_url',
                    schemaPath: '#/properties/on_login_redirect_url/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs11 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.notification !== undefined) {
                let data4 = data.notification;
                const _errs13 = errors;
                const _errs15 = errors;
                let valid2 = false;
                const _errs16 = errors;
                if (errors === _errs16) {
                  if (
                    data4 &&
                    typeof data4 == 'object' &&
                    !Array.isArray(data4)
                  ) {
                    if (data4.message !== undefined) {
                      const _errs18 = errors;
                      if (typeof data4.message !== 'string') {
                        const err3 = {
                          instancePath: instancePath + '/notification/message',
                          schemaPath:
                            '#/properties/notification/anyOf/0/properties/message/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        };
                        if (vErrors === null) {
                          vErrors = [err3];
                        } else {
                          vErrors.push(err3);
                        }
                        errors++;
                      }
                      var valid3 = _errs18 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data4.type !== undefined) {
                        const _errs20 = errors;
                        if (typeof data4.type !== 'string') {
                          const err4 = {
                            instancePath: instancePath + '/notification/type',
                            schemaPath:
                              '#/properties/notification/anyOf/0/properties/type/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          };
                          if (vErrors === null) {
                            vErrors = [err4];
                          } else {
                            vErrors.push(err4);
                          }
                          errors++;
                        }
                        var valid3 = _errs20 === errors;
                      } else {
                        var valid3 = true;
                      }
                    }
                  } else {
                    const err5 = {
                      instancePath: instancePath + '/notification',
                      schemaPath: '#/properties/notification/anyOf/0/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  }
                }
                var _valid1 = _errs16 === errors;
                valid2 = valid2 || _valid1;
                if (!valid2) {
                  const _errs22 = errors;
                  if (data4 !== null) {
                    const err6 = {
                      instancePath: instancePath + '/notification',
                      schemaPath: '#/properties/notification/anyOf/1/type',
                      keyword: 'type',
                      params: { type: 'null' },
                      message: 'must be null',
                    };
                    if (vErrors === null) {
                      vErrors = [err6];
                    } else {
                      vErrors.push(err6);
                    }
                    errors++;
                  }
                  var _valid1 = _errs22 === errors;
                  valid2 = valid2 || _valid1;
                }
                if (!valid2) {
                  const err7 = {
                    instancePath: instancePath + '/notification',
                    schemaPath: '#/properties/notification/anyOf',
                    keyword: 'anyOf',
                    params: {},
                    message: 'must match a schema in anyOf',
                  };
                  if (vErrors === null) {
                    vErrors = [err7];
                  } else {
                    vErrors.push(err7);
                  }
                  errors++;
                  validate13.errors = vErrors;
                  return false;
                } else {
                  errors = _errs15;
                  if (vErrors !== null) {
                    if (_errs15) {
                      vErrors.length = _errs15;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs13 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.error !== undefined) {
                  let data7 = data.error;
                  const _errs24 = errors;
                  const _errs25 = errors;
                  let valid4 = false;
                  let passing0 = null;
                  const _errs26 = errors;
                  const _errs27 = errors;
                  if (errors === _errs27) {
                    if (
                      data7 &&
                      typeof data7 == 'object' &&
                      !Array.isArray(data7)
                    ) {
                      let missing0;
                      if (
                        (data7.message === undefined &&
                          (missing0 = 'message')) ||
                        (data7.code === undefined && (missing0 = 'code'))
                      ) {
                        const err8 = {
                          instancePath: instancePath + '/error',
                          schemaPath: 'ErrorShape.json/required',
                          keyword: 'required',
                          params: { missingProperty: missing0 },
                          message:
                            "must have required property '" + missing0 + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      } else {
                        if (data7.code !== undefined) {
                          const _errs29 = errors;
                          if (typeof data7.code !== 'string') {
                            const err9 = {
                              instancePath: instancePath + '/error/code',
                              schemaPath:
                                'ErrorShape.json/properties/code/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            };
                            if (vErrors === null) {
                              vErrors = [err9];
                            } else {
                              vErrors.push(err9);
                            }
                            errors++;
                          }
                          var valid6 = _errs29 === errors;
                        } else {
                          var valid6 = true;
                        }
                        if (valid6) {
                          if (data7.message !== undefined) {
                            const _errs31 = errors;
                            if (typeof data7.message !== 'string') {
                              const err10 = {
                                instancePath: instancePath + '/error/message',
                                schemaPath:
                                  'ErrorShape.json/properties/message/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              };
                              if (vErrors === null) {
                                vErrors = [err10];
                              } else {
                                vErrors.push(err10);
                              }
                              errors++;
                            }
                            var valid6 = _errs31 === errors;
                          } else {
                            var valid6 = true;
                          }
                        }
                      }
                    } else {
                      const err11 = {
                        instancePath: instancePath + '/error',
                        schemaPath: 'ErrorShape.json/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      };
                      if (vErrors === null) {
                        vErrors = [err11];
                      } else {
                        vErrors.push(err11);
                      }
                      errors++;
                    }
                  }
                  var _valid2 = _errs26 === errors;
                  if (_valid2) {
                    valid4 = true;
                    passing0 = 0;
                  }
                  const _errs33 = errors;
                  if (data7 !== null) {
                    const err12 = {
                      instancePath: instancePath + '/error',
                      schemaPath: '#/properties/error/oneOf/1/type',
                      keyword: 'type',
                      params: { type: 'null' },
                      message: 'must be null',
                    };
                    if (vErrors === null) {
                      vErrors = [err12];
                    } else {
                      vErrors.push(err12);
                    }
                    errors++;
                  }
                  var _valid2 = _errs33 === errors;
                  if (_valid2 && valid4) {
                    valid4 = false;
                    passing0 = [passing0, 1];
                  } else {
                    if (_valid2) {
                      valid4 = true;
                      passing0 = 1;
                    }
                  }
                  if (!valid4) {
                    const err13 = {
                      instancePath: instancePath + '/error',
                      schemaPath: '#/properties/error/oneOf',
                      keyword: 'oneOf',
                      params: { passingSchemas: passing0 },
                      message: 'must match exactly one schema in oneOf',
                    };
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                    validate13.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs25;
                    if (vErrors !== null) {
                      if (_errs25) {
                        vErrors.length = _errs25;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid0 = _errs24 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate13.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate13.errors = vErrors;
  return errors === 0;
}
const schema19 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SignUpData.json',
  type: 'object',
  title: 'SignUpData',
  properties: {
    tosUrl: { type: 'string' },
    privacyPolicyUrl: { type: 'string' },
    emailAddress: { type: 'string' },
    googleSignInClientId: { type: 'string' },
    logInUrl: { type: 'string' },
    signupSource: { type: 'string' },
    initialCountryCode: { type: 'string' },
    isOfficeAddIn: { type: 'boolean' },
    arkoseSignUpPublicKey: { type: 'string' },
    arkoseSignInPublicKey: { type: 'string' },
    arkoseEnabled: { type: 'boolean' },
    redirectUrl: { oneOf: [{ type: 'string' }, { type: 'null' }] },
    teamInvite: { $ref: '#/definitions/TeamInvite' },
    signUpToken: { type: 'string' },
    hubspotVersion: { oneOf: [{ type: 'string' }, { type: 'null' }] },
    allowSamlLogin: { type: 'boolean' },
  },
  required: [
    'tosUrl',
    'privacyPolicyUrl',
    'googleSignInClientId',
    'logInUrl',
    'initialCountryCode',
    'isOfficeAddIn',
    'arkoseSignUpPublicKey',
    'arkoseSignInPublicKey',
    'arkoseEnabled',
    'allowSamlLogin',
  ],
  definitions: {
    TeamInvite: {
      type: 'object',
      properties: {
        senderEmail: { type: 'string' },
        teamName: { type: 'string' },
        teamGuid: { type: 'string' },
      },
      required: ['senderEmail', 'teamName', 'teamGuid'],
    },
  },
};
const schema20 = {
  type: 'object',
  properties: {
    senderEmail: { type: 'string' },
    teamName: { type: 'string' },
    teamGuid: { type: 'string' },
  },
  required: ['senderEmail', 'teamName', 'teamGuid'],
};
function validate15(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="SignUpData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.tosUrl === undefined && (missing0 = 'tosUrl')) ||
        (data.privacyPolicyUrl === undefined &&
          (missing0 = 'privacyPolicyUrl')) ||
        (data.googleSignInClientId === undefined &&
          (missing0 = 'googleSignInClientId')) ||
        (data.logInUrl === undefined && (missing0 = 'logInUrl')) ||
        (data.initialCountryCode === undefined &&
          (missing0 = 'initialCountryCode')) ||
        (data.isOfficeAddIn === undefined && (missing0 = 'isOfficeAddIn')) ||
        (data.arkoseSignUpPublicKey === undefined &&
          (missing0 = 'arkoseSignUpPublicKey')) ||
        (data.arkoseSignInPublicKey === undefined &&
          (missing0 = 'arkoseSignInPublicKey')) ||
        (data.arkoseEnabled === undefined && (missing0 = 'arkoseEnabled')) ||
        (data.allowSamlLogin === undefined && (missing0 = 'allowSamlLogin'))
      ) {
        validate15.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.tosUrl !== undefined) {
          const _errs1 = errors;
          if (typeof data.tosUrl !== 'string') {
            validate15.errors = [
              {
                instancePath: instancePath + '/tosUrl',
                schemaPath: '#/properties/tosUrl/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.privacyPolicyUrl !== undefined) {
            const _errs3 = errors;
            if (typeof data.privacyPolicyUrl !== 'string') {
              validate15.errors = [
                {
                  instancePath: instancePath + '/privacyPolicyUrl',
                  schemaPath: '#/properties/privacyPolicyUrl/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.emailAddress !== undefined) {
              const _errs5 = errors;
              if (typeof data.emailAddress !== 'string') {
                validate15.errors = [
                  {
                    instancePath: instancePath + '/emailAddress',
                    schemaPath: '#/properties/emailAddress/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.googleSignInClientId !== undefined) {
                const _errs7 = errors;
                if (typeof data.googleSignInClientId !== 'string') {
                  validate15.errors = [
                    {
                      instancePath: instancePath + '/googleSignInClientId',
                      schemaPath: '#/properties/googleSignInClientId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.logInUrl !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.logInUrl !== 'string') {
                    validate15.errors = [
                      {
                        instancePath: instancePath + '/logInUrl',
                        schemaPath: '#/properties/logInUrl/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.signupSource !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.signupSource !== 'string') {
                      validate15.errors = [
                        {
                          instancePath: instancePath + '/signupSource',
                          schemaPath: '#/properties/signupSource/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.initialCountryCode !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.initialCountryCode !== 'string') {
                        validate15.errors = [
                          {
                            instancePath: instancePath + '/initialCountryCode',
                            schemaPath: '#/properties/initialCountryCode/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.isOfficeAddIn !== undefined) {
                        const _errs15 = errors;
                        if (typeof data.isOfficeAddIn !== 'boolean') {
                          validate15.errors = [
                            {
                              instancePath: instancePath + '/isOfficeAddIn',
                              schemaPath: '#/properties/isOfficeAddIn/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.arkoseSignUpPublicKey !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.arkoseSignUpPublicKey !== 'string') {
                            validate15.errors = [
                              {
                                instancePath:
                                  instancePath + '/arkoseSignUpPublicKey',
                                schemaPath:
                                  '#/properties/arkoseSignUpPublicKey/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.arkoseSignInPublicKey !== undefined) {
                            const _errs19 = errors;
                            if (
                              typeof data.arkoseSignInPublicKey !== 'string'
                            ) {
                              validate15.errors = [
                                {
                                  instancePath:
                                    instancePath + '/arkoseSignInPublicKey',
                                  schemaPath:
                                    '#/properties/arkoseSignInPublicKey/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.arkoseEnabled !== undefined) {
                              const _errs21 = errors;
                              if (typeof data.arkoseEnabled !== 'boolean') {
                                validate15.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/arkoseEnabled',
                                    schemaPath:
                                      '#/properties/arkoseEnabled/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.redirectUrl !== undefined) {
                                let data11 = data.redirectUrl;
                                const _errs23 = errors;
                                const _errs24 = errors;
                                let valid1 = false;
                                let passing0 = null;
                                const _errs25 = errors;
                                if (typeof data11 !== 'string') {
                                  const err0 = {
                                    instancePath: instancePath + '/redirectUrl',
                                    schemaPath:
                                      '#/properties/redirectUrl/oneOf/0/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err0];
                                  } else {
                                    vErrors.push(err0);
                                  }
                                  errors++;
                                }
                                var _valid0 = _errs25 === errors;
                                if (_valid0) {
                                  valid1 = true;
                                  passing0 = 0;
                                }
                                const _errs27 = errors;
                                if (data11 !== null) {
                                  const err1 = {
                                    instancePath: instancePath + '/redirectUrl',
                                    schemaPath:
                                      '#/properties/redirectUrl/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'null' },
                                    message: 'must be null',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err1];
                                  } else {
                                    vErrors.push(err1);
                                  }
                                  errors++;
                                }
                                var _valid0 = _errs27 === errors;
                                if (_valid0 && valid1) {
                                  valid1 = false;
                                  passing0 = [passing0, 1];
                                } else {
                                  if (_valid0) {
                                    valid1 = true;
                                    passing0 = 1;
                                  }
                                }
                                if (!valid1) {
                                  const err2 = {
                                    instancePath: instancePath + '/redirectUrl',
                                    schemaPath:
                                      '#/properties/redirectUrl/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message:
                                      'must match exactly one schema in oneOf',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err2];
                                  } else {
                                    vErrors.push(err2);
                                  }
                                  errors++;
                                  validate15.errors = vErrors;
                                  return false;
                                } else {
                                  errors = _errs24;
                                  if (vErrors !== null) {
                                    if (_errs24) {
                                      vErrors.length = _errs24;
                                    } else {
                                      vErrors = null;
                                    }
                                  }
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.teamInvite !== undefined) {
                                  let data12 = data.teamInvite;
                                  const _errs29 = errors;
                                  const _errs30 = errors;
                                  if (errors === _errs30) {
                                    if (
                                      data12 &&
                                      typeof data12 == 'object' &&
                                      !Array.isArray(data12)
                                    ) {
                                      let missing1;
                                      if (
                                        (data12.senderEmail === undefined &&
                                          (missing1 = 'senderEmail')) ||
                                        (data12.teamName === undefined &&
                                          (missing1 = 'teamName')) ||
                                        (data12.teamGuid === undefined &&
                                          (missing1 = 'teamGuid'))
                                      ) {
                                        validate15.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/teamInvite',
                                            schemaPath:
                                              '#/definitions/TeamInvite/required',
                                            keyword: 'required',
                                            params: {
                                              missingProperty: missing1,
                                            },
                                            message:
                                              "must have required property '" +
                                              missing1 +
                                              "'",
                                          },
                                        ];
                                        return false;
                                      } else {
                                        if (data12.senderEmail !== undefined) {
                                          const _errs32 = errors;
                                          if (
                                            typeof data12.senderEmail !==
                                            'string'
                                          ) {
                                            validate15.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/teamInvite/senderEmail',
                                                schemaPath:
                                                  '#/definitions/TeamInvite/properties/senderEmail/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid3 = _errs32 === errors;
                                        } else {
                                          var valid3 = true;
                                        }
                                        if (valid3) {
                                          if (data12.teamName !== undefined) {
                                            const _errs34 = errors;
                                            if (
                                              typeof data12.teamName !==
                                              'string'
                                            ) {
                                              validate15.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/teamInvite/teamName',
                                                  schemaPath:
                                                    '#/definitions/TeamInvite/properties/teamName/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid3 = _errs34 === errors;
                                          } else {
                                            var valid3 = true;
                                          }
                                          if (valid3) {
                                            if (data12.teamGuid !== undefined) {
                                              const _errs36 = errors;
                                              if (
                                                typeof data12.teamGuid !==
                                                'string'
                                              ) {
                                                validate15.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/teamInvite/teamGuid',
                                                    schemaPath:
                                                      '#/definitions/TeamInvite/properties/teamGuid/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid3 = _errs36 === errors;
                                            } else {
                                              var valid3 = true;
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      validate15.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/teamInvite',
                                          schemaPath:
                                            '#/definitions/TeamInvite/type',
                                          keyword: 'type',
                                          params: { type: 'object' },
                                          message: 'must be object',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid0 = _errs29 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.signUpToken !== undefined) {
                                    const _errs38 = errors;
                                    if (typeof data.signUpToken !== 'string') {
                                      validate15.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/signUpToken',
                                          schemaPath:
                                            '#/properties/signUpToken/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs38 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.hubspotVersion !== undefined) {
                                      let data17 = data.hubspotVersion;
                                      const _errs40 = errors;
                                      const _errs41 = errors;
                                      let valid4 = false;
                                      let passing1 = null;
                                      const _errs42 = errors;
                                      if (typeof data17 !== 'string') {
                                        const err3 = {
                                          instancePath:
                                            instancePath + '/hubspotVersion',
                                          schemaPath:
                                            '#/properties/hubspotVersion/oneOf/0/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err3];
                                        } else {
                                          vErrors.push(err3);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs42 === errors;
                                      if (_valid1) {
                                        valid4 = true;
                                        passing1 = 0;
                                      }
                                      const _errs44 = errors;
                                      if (data17 !== null) {
                                        const err4 = {
                                          instancePath:
                                            instancePath + '/hubspotVersion',
                                          schemaPath:
                                            '#/properties/hubspotVersion/oneOf/1/type',
                                          keyword: 'type',
                                          params: { type: 'null' },
                                          message: 'must be null',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err4];
                                        } else {
                                          vErrors.push(err4);
                                        }
                                        errors++;
                                      }
                                      var _valid1 = _errs44 === errors;
                                      if (_valid1 && valid4) {
                                        valid4 = false;
                                        passing1 = [passing1, 1];
                                      } else {
                                        if (_valid1) {
                                          valid4 = true;
                                          passing1 = 1;
                                        }
                                      }
                                      if (!valid4) {
                                        const err5 = {
                                          instancePath:
                                            instancePath + '/hubspotVersion',
                                          schemaPath:
                                            '#/properties/hubspotVersion/oneOf',
                                          keyword: 'oneOf',
                                          params: { passingSchemas: passing1 },
                                          message:
                                            'must match exactly one schema in oneOf',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err5];
                                        } else {
                                          vErrors.push(err5);
                                        }
                                        errors++;
                                        validate15.errors = vErrors;
                                        return false;
                                      } else {
                                        errors = _errs41;
                                        if (vErrors !== null) {
                                          if (_errs41) {
                                            vErrors.length = _errs41;
                                          } else {
                                            vErrors = null;
                                          }
                                        }
                                      }
                                      var valid0 = _errs40 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.allowSamlLogin !== undefined) {
                                        const _errs46 = errors;
                                        if (
                                          typeof data.allowSamlLogin !==
                                          'boolean'
                                        ) {
                                          validate15.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/allowSamlLogin',
                                              schemaPath:
                                                '#/properties/allowSamlLogin/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs46 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate15.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate15.errors = vErrors;
  return errors === 0;
}
const schema21 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SignUpResponse.json',
  type: 'object',
  title: 'SignUpResponse',
  $comment:
    'https://github.com/HelloFax/hellosign-web/blob/f2cc954e45fc7b08c073f6eb00c9c94bc0d5a696/src/hellosign/components/auth/sign-up-form.jsx#L141-L196',
  properties: {
    notification: {
      $comment: 'The code cares whether this exists, but does NOT use it',
      anyOf: [
        {
          type: 'object',
          properties: { message: { type: 'string' }, type: { type: 'string' } },
        },
        { type: 'null' },
      ],
    },
    success: { type: 'boolean' },
    redirect_url: { type: 'string' },
    error: { oneOf: [{ $ref: 'ErrorShape.json' }, { type: 'null' }] },
    notification_message: {
      type: 'object',
      $comment: 'The code cares whether this exists, but does NOT use it',
    },
  },
};
function validate17(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="SignUpResponse.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.notification !== undefined) {
        let data0 = data.notification;
        const _errs2 = errors;
        const _errs4 = errors;
        let valid1 = false;
        const _errs5 = errors;
        if (errors === _errs5) {
          if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
            if (data0.message !== undefined) {
              const _errs7 = errors;
              if (typeof data0.message !== 'string') {
                const err0 = {
                  instancePath: instancePath + '/notification/message',
                  schemaPath:
                    '#/properties/notification/anyOf/0/properties/message/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data0.type !== undefined) {
                const _errs9 = errors;
                if (typeof data0.type !== 'string') {
                  const err1 = {
                    instancePath: instancePath + '/notification/type',
                    schemaPath:
                      '#/properties/notification/anyOf/0/properties/type/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
            }
          } else {
            const err2 = {
              instancePath: instancePath + '/notification',
              schemaPath: '#/properties/notification/anyOf/0/type',
              keyword: 'type',
              params: { type: 'object' },
              message: 'must be object',
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
        var _valid0 = _errs5 === errors;
        valid1 = valid1 || _valid0;
        if (!valid1) {
          const _errs11 = errors;
          if (data0 !== null) {
            const err3 = {
              instancePath: instancePath + '/notification',
              schemaPath: '#/properties/notification/anyOf/1/type',
              keyword: 'type',
              params: { type: 'null' },
              message: 'must be null',
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
          var _valid0 = _errs11 === errors;
          valid1 = valid1 || _valid0;
        }
        if (!valid1) {
          const err4 = {
            instancePath: instancePath + '/notification',
            schemaPath: '#/properties/notification/anyOf',
            keyword: 'anyOf',
            params: {},
            message: 'must match a schema in anyOf',
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
          validate17.errors = vErrors;
          return false;
        } else {
          errors = _errs4;
          if (vErrors !== null) {
            if (_errs4) {
              vErrors.length = _errs4;
            } else {
              vErrors = null;
            }
          }
        }
        var valid0 = _errs2 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.success !== undefined) {
          const _errs13 = errors;
          if (typeof data.success !== 'boolean') {
            validate17.errors = [
              {
                instancePath: instancePath + '/success',
                schemaPath: '#/properties/success/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs13 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.redirect_url !== undefined) {
            const _errs15 = errors;
            if (typeof data.redirect_url !== 'string') {
              validate17.errors = [
                {
                  instancePath: instancePath + '/redirect_url',
                  schemaPath: '#/properties/redirect_url/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs15 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.error !== undefined) {
              let data5 = data.error;
              const _errs17 = errors;
              const _errs18 = errors;
              let valid3 = false;
              let passing0 = null;
              const _errs19 = errors;
              const _errs20 = errors;
              if (errors === _errs20) {
                if (
                  data5 &&
                  typeof data5 == 'object' &&
                  !Array.isArray(data5)
                ) {
                  let missing0;
                  if (
                    (data5.message === undefined && (missing0 = 'message')) ||
                    (data5.code === undefined && (missing0 = 'code'))
                  ) {
                    const err5 = {
                      instancePath: instancePath + '/error',
                      schemaPath: 'ErrorShape.json/required',
                      keyword: 'required',
                      params: { missingProperty: missing0 },
                      message: "must have required property '" + missing0 + "'",
                    };
                    if (vErrors === null) {
                      vErrors = [err5];
                    } else {
                      vErrors.push(err5);
                    }
                    errors++;
                  } else {
                    if (data5.code !== undefined) {
                      const _errs22 = errors;
                      if (typeof data5.code !== 'string') {
                        const err6 = {
                          instancePath: instancePath + '/error/code',
                          schemaPath: 'ErrorShape.json/properties/code/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      }
                      var valid5 = _errs22 === errors;
                    } else {
                      var valid5 = true;
                    }
                    if (valid5) {
                      if (data5.message !== undefined) {
                        const _errs24 = errors;
                        if (typeof data5.message !== 'string') {
                          const err7 = {
                            instancePath: instancePath + '/error/message',
                            schemaPath:
                              'ErrorShape.json/properties/message/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          };
                          if (vErrors === null) {
                            vErrors = [err7];
                          } else {
                            vErrors.push(err7);
                          }
                          errors++;
                        }
                        var valid5 = _errs24 === errors;
                      } else {
                        var valid5 = true;
                      }
                    }
                  }
                } else {
                  const err8 = {
                    instancePath: instancePath + '/error',
                    schemaPath: 'ErrorShape.json/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  };
                  if (vErrors === null) {
                    vErrors = [err8];
                  } else {
                    vErrors.push(err8);
                  }
                  errors++;
                }
              }
              var _valid1 = _errs19 === errors;
              if (_valid1) {
                valid3 = true;
                passing0 = 0;
              }
              const _errs26 = errors;
              if (data5 !== null) {
                const err9 = {
                  instancePath: instancePath + '/error',
                  schemaPath: '#/properties/error/oneOf/1/type',
                  keyword: 'type',
                  params: { type: 'null' },
                  message: 'must be null',
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
              var _valid1 = _errs26 === errors;
              if (_valid1 && valid3) {
                valid3 = false;
                passing0 = [passing0, 1];
              } else {
                if (_valid1) {
                  valid3 = true;
                  passing0 = 1;
                }
              }
              if (!valid3) {
                const err10 = {
                  instancePath: instancePath + '/error',
                  schemaPath: '#/properties/error/oneOf',
                  keyword: 'oneOf',
                  params: { passingSchemas: passing0 },
                  message: 'must match exactly one schema in oneOf',
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
                validate17.errors = vErrors;
                return false;
              } else {
                errors = _errs18;
                if (vErrors !== null) {
                  if (_errs18) {
                    vErrors.length = _errs18;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs17 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.notification_message !== undefined) {
                let data8 = data.notification_message;
                const _errs28 = errors;
                if (
                  !(data8 && typeof data8 == 'object' && !Array.isArray(data8))
                ) {
                  validate17.errors = [
                    {
                      instancePath: instancePath + '/notification_message',
                      schemaPath: '#/properties/notification_message/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs28 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate17.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate17.errors = vErrors;
  return errors === 0;
}
const schema23 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'WebAppAccount.json',
  type: 'object',
  title: 'WebAppAccount',
  properties: {
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    email: { type: 'string' },
    locale: { type: 'string' },
    isConfirmed: { type: 'boolean' },
    hasTempPassword: { type: 'boolean' },
    hasPendingSignatures: { type: 'boolean' },
    subscriptionSiteCode: { $ref: 'SiteCode.json' },
    cancelSubscriptionUrl: { type: 'string' },
    currentPassword: {
      type: 'string',
      $comment: 'Used to confirm the temporary password if one is set',
    },
    newPassword: { type: 'string' },
    language: { type: 'string' },
    hsTeam: { $ref: '#/definitions/team' },
    hfTeam: { $ref: '#/definitions/team' },
    permissions: { $ref: '#/definitions/permissions' },
  },
  required: [
    'firstName',
    'lastName',
    'email',
    'locale',
    'isConfirmed',
    'hasTempPassword',
    'permissions',
    'hasPendingSignatures',
    'canChangeEmail',
    'canChangePassword',
    'language',
    'isTeamAdmin',
  ],
  definitions: {
    permissions: {
      type: 'object',
      title: 'permissions',
      properties: {
        canChangeEmail: { type: 'boolean' },
        canChangePassword: { type: 'boolean' },
      },
      required: ['canChangeEmail', 'canChangePassword'],
    },
    team: {
      type: 'object',
      title: 'team',
      properties: { isAdmin: { type: 'boolean' } },
      required: ['isAdmin'],
    },
  },
};
const schema24 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SiteCode.json',
  type: 'string',
  title: 'SiteCode',
  oneOf: [{ const: 'S' }, { const: 'F' }, { const: 'W' }],
};
const schema25 = {
  type: 'object',
  title: 'team',
  properties: { isAdmin: { type: 'boolean' } },
  required: ['isAdmin'],
};
const schema27 = {
  type: 'object',
  title: 'permissions',
  properties: {
    canChangeEmail: { type: 'boolean' },
    canChangePassword: { type: 'boolean' },
  },
  required: ['canChangeEmail', 'canChangePassword'],
};
const func0 = require('ajv/dist/runtime/equal').default;
function validate19(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="WebAppAccount.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.firstName === undefined && (missing0 = 'firstName')) ||
        (data.lastName === undefined && (missing0 = 'lastName')) ||
        (data.email === undefined && (missing0 = 'email')) ||
        (data.locale === undefined && (missing0 = 'locale')) ||
        (data.isConfirmed === undefined && (missing0 = 'isConfirmed')) ||
        (data.hasTempPassword === undefined &&
          (missing0 = 'hasTempPassword')) ||
        (data.permissions === undefined && (missing0 = 'permissions')) ||
        (data.hasPendingSignatures === undefined &&
          (missing0 = 'hasPendingSignatures')) ||
        (data.canChangeEmail === undefined && (missing0 = 'canChangeEmail')) ||
        (data.canChangePassword === undefined &&
          (missing0 = 'canChangePassword')) ||
        (data.language === undefined && (missing0 = 'language')) ||
        (data.isTeamAdmin === undefined && (missing0 = 'isTeamAdmin'))
      ) {
        validate19.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.firstName !== undefined) {
          const _errs1 = errors;
          if (typeof data.firstName !== 'string') {
            validate19.errors = [
              {
                instancePath: instancePath + '/firstName',
                schemaPath: '#/properties/firstName/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.lastName !== undefined) {
            const _errs3 = errors;
            if (typeof data.lastName !== 'string') {
              validate19.errors = [
                {
                  instancePath: instancePath + '/lastName',
                  schemaPath: '#/properties/lastName/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.email !== undefined) {
              const _errs5 = errors;
              if (typeof data.email !== 'string') {
                validate19.errors = [
                  {
                    instancePath: instancePath + '/email',
                    schemaPath: '#/properties/email/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.locale !== undefined) {
                const _errs7 = errors;
                if (typeof data.locale !== 'string') {
                  validate19.errors = [
                    {
                      instancePath: instancePath + '/locale',
                      schemaPath: '#/properties/locale/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.isConfirmed !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.isConfirmed !== 'boolean') {
                    validate19.errors = [
                      {
                        instancePath: instancePath + '/isConfirmed',
                        schemaPath: '#/properties/isConfirmed/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.hasTempPassword !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.hasTempPassword !== 'boolean') {
                      validate19.errors = [
                        {
                          instancePath: instancePath + '/hasTempPassword',
                          schemaPath: '#/properties/hasTempPassword/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.hasPendingSignatures !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.hasPendingSignatures !== 'boolean') {
                        validate19.errors = [
                          {
                            instancePath:
                              instancePath + '/hasPendingSignatures',
                            schemaPath:
                              '#/properties/hasPendingSignatures/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.subscriptionSiteCode !== undefined) {
                        let data7 = data.subscriptionSiteCode;
                        const _errs15 = errors;
                        if (typeof data7 !== 'string') {
                          validate19.errors = [
                            {
                              instancePath:
                                instancePath + '/subscriptionSiteCode',
                              schemaPath: 'SiteCode.json/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        const _errs18 = errors;
                        let valid2 = false;
                        let passing0 = null;
                        const _errs19 = errors;
                        if (!func0(data7, 'S')) {
                          const err0 = {
                            instancePath:
                              instancePath + '/subscriptionSiteCode',
                            schemaPath: 'SiteCode.json/oneOf/0/const',
                            keyword: 'const',
                            params: { allowedValue: 'S' },
                            message: 'must be equal to constant',
                          };
                          if (vErrors === null) {
                            vErrors = [err0];
                          } else {
                            vErrors.push(err0);
                          }
                          errors++;
                        }
                        var _valid0 = _errs19 === errors;
                        if (_valid0) {
                          valid2 = true;
                          passing0 = 0;
                        }
                        const _errs20 = errors;
                        if (!func0(data7, 'F')) {
                          const err1 = {
                            instancePath:
                              instancePath + '/subscriptionSiteCode',
                            schemaPath: 'SiteCode.json/oneOf/1/const',
                            keyword: 'const',
                            params: { allowedValue: 'F' },
                            message: 'must be equal to constant',
                          };
                          if (vErrors === null) {
                            vErrors = [err1];
                          } else {
                            vErrors.push(err1);
                          }
                          errors++;
                        }
                        var _valid0 = _errs20 === errors;
                        if (_valid0 && valid2) {
                          valid2 = false;
                          passing0 = [passing0, 1];
                        } else {
                          if (_valid0) {
                            valid2 = true;
                            passing0 = 1;
                          }
                          const _errs21 = errors;
                          if (!func0(data7, 'W')) {
                            const err2 = {
                              instancePath:
                                instancePath + '/subscriptionSiteCode',
                              schemaPath: 'SiteCode.json/oneOf/2/const',
                              keyword: 'const',
                              params: { allowedValue: 'W' },
                              message: 'must be equal to constant',
                            };
                            if (vErrors === null) {
                              vErrors = [err2];
                            } else {
                              vErrors.push(err2);
                            }
                            errors++;
                          }
                          var _valid0 = _errs21 === errors;
                          if (_valid0 && valid2) {
                            valid2 = false;
                            passing0 = [passing0, 2];
                          } else {
                            if (_valid0) {
                              valid2 = true;
                              passing0 = 2;
                            }
                          }
                        }
                        if (!valid2) {
                          const err3 = {
                            instancePath:
                              instancePath + '/subscriptionSiteCode',
                            schemaPath: 'SiteCode.json/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf',
                          };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                          validate19.errors = vErrors;
                          return false;
                        } else {
                          errors = _errs18;
                          if (vErrors !== null) {
                            if (_errs18) {
                              vErrors.length = _errs18;
                            } else {
                              vErrors = null;
                            }
                          }
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.cancelSubscriptionUrl !== undefined) {
                          const _errs22 = errors;
                          if (typeof data.cancelSubscriptionUrl !== 'string') {
                            validate19.errors = [
                              {
                                instancePath:
                                  instancePath + '/cancelSubscriptionUrl',
                                schemaPath:
                                  '#/properties/cancelSubscriptionUrl/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs22 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.currentPassword !== undefined) {
                            const _errs24 = errors;
                            if (typeof data.currentPassword !== 'string') {
                              validate19.errors = [
                                {
                                  instancePath:
                                    instancePath + '/currentPassword',
                                  schemaPath:
                                    '#/properties/currentPassword/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs24 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.newPassword !== undefined) {
                              const _errs27 = errors;
                              if (typeof data.newPassword !== 'string') {
                                validate19.errors = [
                                  {
                                    instancePath: instancePath + '/newPassword',
                                    schemaPath: '#/properties/newPassword/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs27 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.language !== undefined) {
                                const _errs29 = errors;
                                if (typeof data.language !== 'string') {
                                  validate19.errors = [
                                    {
                                      instancePath: instancePath + '/language',
                                      schemaPath: '#/properties/language/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs29 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.hsTeam !== undefined) {
                                  let data12 = data.hsTeam;
                                  const _errs31 = errors;
                                  const _errs32 = errors;
                                  if (errors === _errs32) {
                                    if (
                                      data12 &&
                                      typeof data12 == 'object' &&
                                      !Array.isArray(data12)
                                    ) {
                                      let missing1;
                                      if (
                                        data12.isAdmin === undefined &&
                                        (missing1 = 'isAdmin')
                                      ) {
                                        validate19.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/hsTeam',
                                            schemaPath:
                                              '#/definitions/team/required',
                                            keyword: 'required',
                                            params: {
                                              missingProperty: missing1,
                                            },
                                            message:
                                              "must have required property '" +
                                              missing1 +
                                              "'",
                                          },
                                        ];
                                        return false;
                                      } else {
                                        if (data12.isAdmin !== undefined) {
                                          if (
                                            typeof data12.isAdmin !== 'boolean'
                                          ) {
                                            validate19.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/hsTeam/isAdmin',
                                                schemaPath:
                                                  '#/definitions/team/properties/isAdmin/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              },
                                            ];
                                            return false;
                                          }
                                        }
                                      }
                                    } else {
                                      validate19.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/hsTeam',
                                          schemaPath: '#/definitions/team/type',
                                          keyword: 'type',
                                          params: { type: 'object' },
                                          message: 'must be object',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid0 = _errs31 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.hfTeam !== undefined) {
                                    let data14 = data.hfTeam;
                                    const _errs36 = errors;
                                    const _errs37 = errors;
                                    if (errors === _errs37) {
                                      if (
                                        data14 &&
                                        typeof data14 == 'object' &&
                                        !Array.isArray(data14)
                                      ) {
                                        let missing2;
                                        if (
                                          data14.isAdmin === undefined &&
                                          (missing2 = 'isAdmin')
                                        ) {
                                          validate19.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/hfTeam',
                                              schemaPath:
                                                '#/definitions/team/required',
                                              keyword: 'required',
                                              params: {
                                                missingProperty: missing2,
                                              },
                                              message:
                                                "must have required property '" +
                                                missing2 +
                                                "'",
                                            },
                                          ];
                                          return false;
                                        } else {
                                          if (data14.isAdmin !== undefined) {
                                            if (
                                              typeof data14.isAdmin !==
                                              'boolean'
                                            ) {
                                              validate19.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/hfTeam/isAdmin',
                                                  schemaPath:
                                                    '#/definitions/team/properties/isAdmin/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                          }
                                        }
                                      } else {
                                        validate19.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/hfTeam',
                                            schemaPath:
                                              '#/definitions/team/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object',
                                          },
                                        ];
                                        return false;
                                      }
                                    }
                                    var valid0 = _errs36 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.permissions !== undefined) {
                                      let data16 = data.permissions;
                                      const _errs41 = errors;
                                      const _errs42 = errors;
                                      if (errors === _errs42) {
                                        if (
                                          data16 &&
                                          typeof data16 == 'object' &&
                                          !Array.isArray(data16)
                                        ) {
                                          let missing3;
                                          if (
                                            (data16.canChangeEmail ===
                                              undefined &&
                                              (missing3 = 'canChangeEmail')) ||
                                            (data16.canChangePassword ===
                                              undefined &&
                                              (missing3 = 'canChangePassword'))
                                          ) {
                                            validate19.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/permissions',
                                                schemaPath:
                                                  '#/definitions/permissions/required',
                                                keyword: 'required',
                                                params: {
                                                  missingProperty: missing3,
                                                },
                                                message:
                                                  "must have required property '" +
                                                  missing3 +
                                                  "'",
                                              },
                                            ];
                                            return false;
                                          } else {
                                            if (
                                              data16.canChangeEmail !==
                                              undefined
                                            ) {
                                              const _errs44 = errors;
                                              if (
                                                typeof data16.canChangeEmail !==
                                                'boolean'
                                              ) {
                                                validate19.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/permissions/canChangeEmail',
                                                    schemaPath:
                                                      '#/definitions/permissions/properties/canChangeEmail/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid8 = _errs44 === errors;
                                            } else {
                                              var valid8 = true;
                                            }
                                            if (valid8) {
                                              if (
                                                data16.canChangePassword !==
                                                undefined
                                              ) {
                                                const _errs46 = errors;
                                                if (
                                                  typeof data16.canChangePassword !==
                                                  'boolean'
                                                ) {
                                                  validate19.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/permissions/canChangePassword',
                                                      schemaPath:
                                                        '#/definitions/permissions/properties/canChangePassword/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid8 = _errs46 === errors;
                                              } else {
                                                var valid8 = true;
                                              }
                                            }
                                          }
                                        } else {
                                          validate19.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/permissions',
                                              schemaPath:
                                                '#/definitions/permissions/type',
                                              keyword: 'type',
                                              params: { type: 'object' },
                                              message: 'must be object',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                      var valid0 = _errs41 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate19.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate19.errors = vErrors;
  return errors === 0;
}
const schema28 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'WebAppAccountSettings.json',
  type: 'object',
  title: 'WebAppAccountSettings',
  properties: {
    customLogoUrl: { type: 'string' },
    isBrandingEnabled: { type: 'boolean' },
    isAccountLogoTeamLogo: { type: 'boolean' },
    hasSubscriptionAccess: { type: 'boolean' },
    isCompanyTaglineEnabled: { type: 'boolean' },
    companyTagline: { type: 'string' },
    isEmailFromEnabled: { type: 'string' },
    emailFrom: { type: 'string' },
    isEmailSignatureEnabled: { type: 'string' },
    emailSignature: { type: 'string' },
    isCustomSigningRedirectEnabled: { type: 'boolean' },
    customSigningRedirectUrl: { type: 'string' },
    signatureTypes: { $ref: '#/definitions/signatureTypes' },
    isShouldIncludeDistinctPdfsEnabled: { type: 'boolean' },
    shouldIncludeDistinctPdfs: { type: 'boolean' },
    isShouldRemoveDocumentIdEnabled: { type: 'boolean' },
    shouldRemoveDocumentId: { type: 'boolean' },
    isInPersonSigningEnabled: { type: 'boolean' },
    inPersonSigning: { type: 'boolean' },
    documentRetention: { $ref: '#/definitions/documentRetention' },
    esignDisclosure: {
      $ref: '#/definitions/esignDisclosure',
      $comment:
        "If the user shouldn't have access to this feature, don't include it in the response",
    },
    dataResidency: { $ref: '#/definitions/dataResidency' },
    company: { type: 'string' },
    industry: { type: 'string' },
    jobTitle: { type: 'string' },
    department: { type: 'string' },
    dateFormat: { type: 'string' },
    canUpdateTimezone: { type: 'boolean' },
    timezone: { type: 'string' },
    timezoneOptions: { type: 'array', items: { $ref: 'Timezone.json' } },
    isAutocompleteEnabled: { type: 'boolean' },
    isTamperproofEnabled: { type: 'boolean' },
    faxNumbers: { type: 'array', items: { type: 'string' } },
    hfBrandName: { type: 'string' },
    hsBrandName: { type: 'string' },
    isOptedIntoMarketingEmails: { type: 'boolean' },
    isSignatureRemindersEnabled: { type: 'boolean' },
    hipaaLock: { $ref: '#/definitions/HipaaLock' },
    notifications: { $ref: '#/definitions/notifications' },
    notificationAttachments: { $ref: '#/definitions/notificationAttachments' },
    '2fa': { $ref: '#/definitions/2fa' },
    onBehalf: { $ref: '#/definitions/onBehalf' },
    billing: { $ref: 'WebAppBillingSettings.json' },
    integrations: {
      type: 'array',
      items: {
        oneOf: [
          { $ref: '#/definitions/editableIntegration' },
          { $ref: '#/definitions/linkedIntegration' },
        ],
      },
    },
  },
  required: [
    'hipaaLock',
    'isBrandingEnabled',
    'isAccountLogoTeamLogo',
    'hasSubscriptionAccess',
    'isCompanyTaglineEnabled',
    'companyTagline',
    'isEmailFromEnabled',
    'emailFrom',
    'isEmailSignatureEnabled',
    'emailSignature',
    'isCustomSigningRedirectEnabled',
    'customSigningRedirectUrl',
    'signatureTypes',
    'isShouldIncludeDistinctPdfsEnabled',
    'shouldIncludeDistinctPdfs',
    'isShouldRemoveDocumentIdEnabled',
    'shouldRemoveDocumentId',
    'isInPersonSigningEnabled',
    'inPersonSigning',
    'documentRetention',
    'company',
    'industry',
    'jobTitle',
    'department',
    'dateFormat',
    'canUpdateTimezone',
    'timezone',
    'timezoneOptions',
    'isAutocompleteEnabled',
    'isTamperproofEnabled',
    'faxNumbers',
    'hfBrandName',
    'hsBrandName',
    'isOptedIntoMarketingEmails',
    'isSignatureRemindersEnabled',
    'notifications',
    'notificationAttachments',
    '2fa',
    'onBehalf',
    'billing',
    'integrations',
  ],
  definitions: {
    signatureTypes: {
      type: 'object',
      title: 'signatureTypes',
      properties: {
        isDrawnEnabled: { type: 'boolean' },
        isTypedEnabled: { type: 'boolean' },
        isUploadedEnabled: { type: 'boolean' },
        isSmartphoneEnabled: { type: 'boolean' },
      },
      required: [
        'isDrawnEnabled',
        'isTypedEnabled',
        'isUploadedEnabled',
        'isSmartphoneEnabled',
      ],
    },
    documentRetention: {
      type: 'object',
      title: 'documentRetention',
      properties: {
        ongoingDeleteDocuments: { type: 'boolean' },
        canSetOngoingDeleteSetting: { type: 'boolean' },
        canSetOneTimeDeleteSetting: { type: 'boolean' },
      },
      required: [
        'ongoingDeleteDocuments',
        'canSetOngoingDeleteSetting',
        'canSetOneTimeDeleteSetting',
      ],
    },
    esignDisclosure: {
      type: 'object',
      title: 'esignDisclosure',
      properties: {
        isEnabled: { type: 'boolean' },
        isAdditionalTextEnabled: { type: 'boolean' },
        additionalText: { type: 'string' },
        businessName: { type: 'string' },
        header: { type: 'string' },
        text: { type: 'string' },
        textJoin: { type: 'string' },
      },
      required: [
        'isEnabled',
        'isAdditionalTextEnabled',
        'additionalText',
        'businessName',
        'header',
        'text',
        'textJoin',
      ],
    },
    dataResidency: {
      type: 'object',
      title: 'dataResidency',
      properties: {
        isEnabled: { type: 'boolean' },
        hfRegion: { type: 'string' },
        hsRegion: { type: 'string' },
      },
      required: ['isEnabled', 'hfRegion', 'hsRegion'],
    },
    HipaaLock: {
      type: 'object',
      title: 'HipaaLock',
      properties: {
        enableIncludePdfOnFaxReceived: { type: 'boolean' },
        includePdfOnFaxSent: { type: 'boolean' },
        includePdfForCcRecipientsOnFaxSent: { type: 'boolean' },
        shouldIncludeReceivedFaxPDFsForOthers: { type: 'boolean' },
        includePdfForCcRecipientsOnDocumentSent: { type: 'boolean' },
        includePdfForCcRecipientsOnDocumentCompleted: { type: 'boolean' },
      },
      required: [
        'enableIncludePdfOnFaxReceived',
        'includePdfOnFaxSent',
        'includePdfForCcRecipientsOnFaxSent',
        'shouldIncludeReceivedFaxPDFsForOthers',
        'includePdfForCcRecipientsOnDocumentSent',
        'includePdfForCcRecipientsOnDocumentCompleted',
      ],
    },
    notifications: {
      type: 'object',
      title: 'notifications',
      properties: {
        hasSMSSignatureDelivery: { type: 'boolean' },
        sendEmailOnDocumentSignedAndSent: { type: 'boolean' },
        sendEmailOnSentDocumentSigned: { type: 'boolean' },
        sendEmailOnSentDocumentOpened: { type: 'boolean' },
        sendEmailOnSelfSignedEmbeddedDocument: { type: 'boolean' },
        sendDailyOutstandingSignatureRequestSummaryEmail: { type: 'boolean' },
        sendEmailOnOrderedSignatureRequestStarted: { type: 'boolean' },
        sendEmailToCcRecipientsOnDocumentSent: { type: 'boolean' },
        sendEmailToCcRecipientsOnDocumentCompleted: { type: 'boolean' },
        sendEmailToCcRecipientsOnDocumentDeclined: { type: 'boolean' },
        sendEmailToCcRecipientsOnDocumentViewed: { type: 'boolean' },
        sendEmailToCcRecipientsOnDocumentDelegated: { type: 'boolean' },
      },
      required: [
        'hasSMSSignatureDelivery',
        'sendEmailOnDocumentSignedAndSent',
        'sendEmailOnSentDocumentSigned',
        'sendEmailOnSentDocumentOpened',
        'sendEmailOnSelfSignedEmbeddedDocument',
        'sendDailyOutstandingSignatureRequestSummaryEmail',
        'sendEmailOnOrderedSignatureRequestStarted',
        'sendEmailToCcRecipientsOnDocumentSent',
        'sendEmailToCcRecipientsOnDocumentCompleted',
        'sendEmailToCcRecipientsOnDocumentDeclined',
        'sendEmailToCcRecipientsOnDocumentViewed',
        'sendEmailToCcRecipientsOnDocumentDelegated',
      ],
    },
    notificationAttachments: {
      type: 'object',
      title: 'notificationAttachments',
      properties: {
        enableIncludePdfOnDocumentCompleted: { type: 'boolean' },
        includePdfOnDocumentCompleted: { type: 'boolean' },
        enableIncludePdfForCcRecipientsOnDocumentCompleted: { type: 'boolean' },
        includePdfForCcRecipientsOnDocumentCompleted: { type: 'boolean' },
        enableIncludePdfOnDocumentSent: { type: 'boolean' },
        includePdfOnDocumentSent: { type: 'boolean' },
        enableIncludePdfForCcRecipientsOnDocumentSent: { type: 'boolean' },
        includePdfForCcRecipientsOnDocumentSent: { type: 'boolean' },
        enableIncludePdfOnFaxReceived: { type: 'boolean' },
        includePdfOnFaxReceived: { type: 'boolean' },
        enableIncludePdfForCcRecipientsOnFaxSent: { type: 'boolean' },
        includePdfForCcRecipientsOnFaxSent: { type: 'boolean' },
        enableIncludePdfOnFaxSent: { type: 'boolean' },
        includePdfOnFaxSent: { type: 'boolean' },
      },
      required: [
        'enableIncludePdfOnDocumentCompleted',
        'includePdfOnDocumentCompleted',
        'enableIncludePdfForCcRecipientsOnDocumentCompleted',
        'includePdfForCcRecipientsOnDocumentCompleted',
        'enableIncludePdfOnDocumentSent',
        'includePdfOnDocumentSent',
        'enableIncludePdfForCcRecipientsOnDocumentSent',
        'includePdfForCcRecipientsOnDocumentSent',
        'enableIncludePdfOnFaxReceived',
        'includePdfOnFaxReceived',
        'enableIncludePdfForCcRecipientsOnFaxSent',
        'includePdfForCcRecipientsOnFaxSent',
        'enableIncludePdfOnFaxSent',
        'includePdfOnFaxSent',
      ],
    },
    '2fa': {
      type: 'object',
      title: '2fa',
      properties: {
        isEnabled: { type: 'boolean' },
        sms: { $ref: '#/definitions/2faSms' },
        googleAuthenticator: { $ref: '#/definitions/2faGoogleAuthenticator' },
      },
      required: ['isEnabled', 'sms', 'googleAuthenticator'],
    },
    '2faSms': {
      type: 'object',
      title: '2faSms',
      properties: {
        isEnabled: { type: 'boolean' },
        isVerified: { type: 'boolean' },
      },
      required: ['isEnabled', 'isVerified'],
    },
    '2faGoogleAuthenticator': {
      type: 'object',
      title: '2faGoogleAuthenticator',
      properties: { isEnabled: { type: 'boolean' } },
      required: ['isEnabled'],
    },
    onBehalf: {
      type: 'object',
      title: 'onBehalf',
      properties: {
        isEmailLocked: { type: 'boolean' },
        isDomainLocked: { type: 'boolean' },
        sendEmailNotificationOnSignatureRequest: { type: 'boolean' },
      },
      required: [
        'isEmailLocked',
        'isDomainLocked',
        'sendEmailNotificationOnSignatureRequest',
      ],
    },
    hfBilling: {
      type: 'object',
      title: 'hfBilling',
      properties: {
        numberFaxPagesPerMonth: { type: 'integer' },
        numberFaxPagesLeft: { type: 'integer' },
        numberBonusFaxPages: { type: 'integer' },
        numberExtraPages: { type: 'integer' },
        isPaid: { type: 'boolean' },
        inviteURL: { type: 'string' },
        promoName: { type: 'string' },
      },
      required: [
        'numberFaxPagesPerMonth',
        'numberFaxPagesLeft',
        'numberBonusFaxPages',
        'numberExtraPages',
        'isPaid',
        'inviteURL',
        'promoName',
      ],
    },
    billingPlan: {
      type: 'object',
      title: 'billingPlan',
      properties: {
        id: { type: 'boolean' },
        name: { type: 'string' },
        isApi: { type: 'boolean' },
        hasApiAccess: { type: 'boolean' },
        changePlanLink: { type: 'string' },
        isCanceled: { type: 'boolean' },
        numSigRequestsPerMonth: { type: 'integer' },
        numSigRequestsUsed: { type: 'integer' },
        endDate: { type: 'string' },
      },
      required: [
        'id',
        'name',
        'isApi',
        'hasApiAccess',
        'changePlanLink',
        'isCanceled',
        'numSigRequestsPerMonth',
        'numSigRequestsUsed',
        'endDate',
      ],
    },
    editableIntegration: {
      type: 'object',
      title: 'editableIntegration',
      properties: {
        name: { type: 'string' },
        serviceTypeCode: { type: 'string' },
        isEnabled: { type: 'boolean' },
        isActive: { type: 'boolean' },
      },
      required: ['name', 'serviceTypeCode', 'isEnabled', 'isActive'],
    },
    linkedIntegration: {
      type: 'object',
      title: 'linkedIntegration',
      properties: {
        name: { type: 'string' },
        link: { type: 'string' },
        isEnabled: { type: 'boolean' },
      },
      required: ['name', 'link', 'isEnabled'],
    },
  },
};
const schema29 = {
  type: 'object',
  title: 'signatureTypes',
  properties: {
    isDrawnEnabled: { type: 'boolean' },
    isTypedEnabled: { type: 'boolean' },
    isUploadedEnabled: { type: 'boolean' },
    isSmartphoneEnabled: { type: 'boolean' },
  },
  required: [
    'isDrawnEnabled',
    'isTypedEnabled',
    'isUploadedEnabled',
    'isSmartphoneEnabled',
  ],
};
const schema30 = {
  type: 'object',
  title: 'documentRetention',
  properties: {
    ongoingDeleteDocuments: { type: 'boolean' },
    canSetOngoingDeleteSetting: { type: 'boolean' },
    canSetOneTimeDeleteSetting: { type: 'boolean' },
  },
  required: [
    'ongoingDeleteDocuments',
    'canSetOngoingDeleteSetting',
    'canSetOneTimeDeleteSetting',
  ],
};
const schema31 = {
  type: 'object',
  title: 'esignDisclosure',
  properties: {
    isEnabled: { type: 'boolean' },
    isAdditionalTextEnabled: { type: 'boolean' },
    additionalText: { type: 'string' },
    businessName: { type: 'string' },
    header: { type: 'string' },
    text: { type: 'string' },
    textJoin: { type: 'string' },
  },
  required: [
    'isEnabled',
    'isAdditionalTextEnabled',
    'additionalText',
    'businessName',
    'header',
    'text',
    'textJoin',
  ],
};
const schema32 = {
  type: 'object',
  title: 'dataResidency',
  properties: {
    isEnabled: { type: 'boolean' },
    hfRegion: { type: 'string' },
    hsRegion: { type: 'string' },
  },
  required: ['isEnabled', 'hfRegion', 'hsRegion'],
};
const schema33 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Timezone.json',
  type: 'object',
  title: 'Timezone',
  properties: {
    offset: { type: 'number' },
    hasDST: { type: 'boolean' },
    displayName: { type: 'string' },
  },
  required: ['offset', 'hasDST', 'displayName'],
};
const schema34 = {
  type: 'object',
  title: 'HipaaLock',
  properties: {
    enableIncludePdfOnFaxReceived: { type: 'boolean' },
    includePdfOnFaxSent: { type: 'boolean' },
    includePdfForCcRecipientsOnFaxSent: { type: 'boolean' },
    shouldIncludeReceivedFaxPDFsForOthers: { type: 'boolean' },
    includePdfForCcRecipientsOnDocumentSent: { type: 'boolean' },
    includePdfForCcRecipientsOnDocumentCompleted: { type: 'boolean' },
  },
  required: [
    'enableIncludePdfOnFaxReceived',
    'includePdfOnFaxSent',
    'includePdfForCcRecipientsOnFaxSent',
    'shouldIncludeReceivedFaxPDFsForOthers',
    'includePdfForCcRecipientsOnDocumentSent',
    'includePdfForCcRecipientsOnDocumentCompleted',
  ],
};
const schema35 = {
  type: 'object',
  title: 'notifications',
  properties: {
    hasSMSSignatureDelivery: { type: 'boolean' },
    sendEmailOnDocumentSignedAndSent: { type: 'boolean' },
    sendEmailOnSentDocumentSigned: { type: 'boolean' },
    sendEmailOnSentDocumentOpened: { type: 'boolean' },
    sendEmailOnSelfSignedEmbeddedDocument: { type: 'boolean' },
    sendDailyOutstandingSignatureRequestSummaryEmail: { type: 'boolean' },
    sendEmailOnOrderedSignatureRequestStarted: { type: 'boolean' },
    sendEmailToCcRecipientsOnDocumentSent: { type: 'boolean' },
    sendEmailToCcRecipientsOnDocumentCompleted: { type: 'boolean' },
    sendEmailToCcRecipientsOnDocumentDeclined: { type: 'boolean' },
    sendEmailToCcRecipientsOnDocumentViewed: { type: 'boolean' },
    sendEmailToCcRecipientsOnDocumentDelegated: { type: 'boolean' },
  },
  required: [
    'hasSMSSignatureDelivery',
    'sendEmailOnDocumentSignedAndSent',
    'sendEmailOnSentDocumentSigned',
    'sendEmailOnSentDocumentOpened',
    'sendEmailOnSelfSignedEmbeddedDocument',
    'sendDailyOutstandingSignatureRequestSummaryEmail',
    'sendEmailOnOrderedSignatureRequestStarted',
    'sendEmailToCcRecipientsOnDocumentSent',
    'sendEmailToCcRecipientsOnDocumentCompleted',
    'sendEmailToCcRecipientsOnDocumentDeclined',
    'sendEmailToCcRecipientsOnDocumentViewed',
    'sendEmailToCcRecipientsOnDocumentDelegated',
  ],
};
const schema36 = {
  type: 'object',
  title: 'notificationAttachments',
  properties: {
    enableIncludePdfOnDocumentCompleted: { type: 'boolean' },
    includePdfOnDocumentCompleted: { type: 'boolean' },
    enableIncludePdfForCcRecipientsOnDocumentCompleted: { type: 'boolean' },
    includePdfForCcRecipientsOnDocumentCompleted: { type: 'boolean' },
    enableIncludePdfOnDocumentSent: { type: 'boolean' },
    includePdfOnDocumentSent: { type: 'boolean' },
    enableIncludePdfForCcRecipientsOnDocumentSent: { type: 'boolean' },
    includePdfForCcRecipientsOnDocumentSent: { type: 'boolean' },
    enableIncludePdfOnFaxReceived: { type: 'boolean' },
    includePdfOnFaxReceived: { type: 'boolean' },
    enableIncludePdfForCcRecipientsOnFaxSent: { type: 'boolean' },
    includePdfForCcRecipientsOnFaxSent: { type: 'boolean' },
    enableIncludePdfOnFaxSent: { type: 'boolean' },
    includePdfOnFaxSent: { type: 'boolean' },
  },
  required: [
    'enableIncludePdfOnDocumentCompleted',
    'includePdfOnDocumentCompleted',
    'enableIncludePdfForCcRecipientsOnDocumentCompleted',
    'includePdfForCcRecipientsOnDocumentCompleted',
    'enableIncludePdfOnDocumentSent',
    'includePdfOnDocumentSent',
    'enableIncludePdfForCcRecipientsOnDocumentSent',
    'includePdfForCcRecipientsOnDocumentSent',
    'enableIncludePdfOnFaxReceived',
    'includePdfOnFaxReceived',
    'enableIncludePdfForCcRecipientsOnFaxSent',
    'includePdfForCcRecipientsOnFaxSent',
    'enableIncludePdfOnFaxSent',
    'includePdfOnFaxSent',
  ],
};
const schema40 = {
  type: 'object',
  title: 'onBehalf',
  properties: {
    isEmailLocked: { type: 'boolean' },
    isDomainLocked: { type: 'boolean' },
    sendEmailNotificationOnSignatureRequest: { type: 'boolean' },
  },
  required: [
    'isEmailLocked',
    'isDomainLocked',
    'sendEmailNotificationOnSignatureRequest',
  ],
};
const schema43 = {
  type: 'object',
  title: 'editableIntegration',
  properties: {
    name: { type: 'string' },
    serviceTypeCode: { type: 'string' },
    isEnabled: { type: 'boolean' },
    isActive: { type: 'boolean' },
  },
  required: ['name', 'serviceTypeCode', 'isEnabled', 'isActive'],
};
const schema44 = {
  type: 'object',
  title: 'linkedIntegration',
  properties: {
    name: { type: 'string' },
    link: { type: 'string' },
    isEnabled: { type: 'boolean' },
  },
  required: ['name', 'link', 'isEnabled'],
};
const schema37 = {
  type: 'object',
  title: '2fa',
  properties: {
    isEnabled: { type: 'boolean' },
    sms: { $ref: '#/definitions/2faSms' },
    googleAuthenticator: { $ref: '#/definitions/2faGoogleAuthenticator' },
  },
  required: ['isEnabled', 'sms', 'googleAuthenticator'],
};
const schema38 = {
  type: 'object',
  title: '2faSms',
  properties: {
    isEnabled: { type: 'boolean' },
    isVerified: { type: 'boolean' },
  },
  required: ['isEnabled', 'isVerified'],
};
const schema39 = {
  type: 'object',
  title: '2faGoogleAuthenticator',
  properties: { isEnabled: { type: 'boolean' } },
  required: ['isEnabled'],
};
function validate22(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.isEnabled === undefined && (missing0 = 'isEnabled')) ||
        (data.sms === undefined && (missing0 = 'sms')) ||
        (data.googleAuthenticator === undefined &&
          (missing0 = 'googleAuthenticator'))
      ) {
        validate22.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.isEnabled !== undefined) {
          const _errs1 = errors;
          if (typeof data.isEnabled !== 'boolean') {
            validate22.errors = [
              {
                instancePath: instancePath + '/isEnabled',
                schemaPath: '#/properties/isEnabled/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.sms !== undefined) {
            let data1 = data.sms;
            const _errs3 = errors;
            const _errs4 = errors;
            if (errors === _errs4) {
              if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                let missing1;
                if (
                  (data1.isEnabled === undefined && (missing1 = 'isEnabled')) ||
                  (data1.isVerified === undefined && (missing1 = 'isVerified'))
                ) {
                  validate22.errors = [
                    {
                      instancePath: instancePath + '/sms',
                      schemaPath: '#/definitions/2faSms/required',
                      keyword: 'required',
                      params: { missingProperty: missing1 },
                      message: "must have required property '" + missing1 + "'",
                    },
                  ];
                  return false;
                } else {
                  if (data1.isEnabled !== undefined) {
                    const _errs6 = errors;
                    if (typeof data1.isEnabled !== 'boolean') {
                      validate22.errors = [
                        {
                          instancePath: instancePath + '/sms/isEnabled',
                          schemaPath:
                            '#/definitions/2faSms/properties/isEnabled/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs6 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.isVerified !== undefined) {
                      const _errs8 = errors;
                      if (typeof data1.isVerified !== 'boolean') {
                        validate22.errors = [
                          {
                            instancePath: instancePath + '/sms/isVerified',
                            schemaPath:
                              '#/definitions/2faSms/properties/isVerified/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs8 === errors;
                    } else {
                      var valid2 = true;
                    }
                  }
                }
              } else {
                validate22.errors = [
                  {
                    instancePath: instancePath + '/sms',
                    schemaPath: '#/definitions/2faSms/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.googleAuthenticator !== undefined) {
              let data4 = data.googleAuthenticator;
              const _errs10 = errors;
              const _errs11 = errors;
              if (errors === _errs11) {
                if (
                  data4 &&
                  typeof data4 == 'object' &&
                  !Array.isArray(data4)
                ) {
                  let missing2;
                  if (
                    data4.isEnabled === undefined &&
                    (missing2 = 'isEnabled')
                  ) {
                    validate22.errors = [
                      {
                        instancePath: instancePath + '/googleAuthenticator',
                        schemaPath:
                          '#/definitions/2faGoogleAuthenticator/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message:
                          "must have required property '" + missing2 + "'",
                      },
                    ];
                    return false;
                  } else {
                    if (data4.isEnabled !== undefined) {
                      if (typeof data4.isEnabled !== 'boolean') {
                        validate22.errors = [
                          {
                            instancePath:
                              instancePath + '/googleAuthenticator/isEnabled',
                            schemaPath:
                              '#/definitions/2faGoogleAuthenticator/properties/isEnabled/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                    }
                  }
                } else {
                  validate22.errors = [
                    {
                      instancePath: instancePath + '/googleAuthenticator',
                      schemaPath: '#/definitions/2faGoogleAuthenticator/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs10 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate22.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate22.errors = vErrors;
  return errors === 0;
}
const schema41 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'WebAppBillingSettings.json',
  type: 'object',
  title: 'WebAappBillingSettings',
  properties: {
    taxIdSupported: { type: 'boolean' },
    taxCountry: { type: 'string' },
    hasSubscriptionAccess: { type: 'boolean' },
    hasBillingInfoAccess: { type: 'boolean' },
    isHf: { type: 'boolean' },
    isDelinquent: { type: 'boolean' },
    billingPlans: {
      type: 'array',
      items: { oneOf: [{ $ref: '#/definitions/BillingPlan' }] },
    },
    businessName: { type: 'string' },
    receiptAddress: { type: 'string' },
    addonSalesforceUsage: { type: 'string' },
    addonSalesforceQuota: { type: 'string' },
    addonOracleCPQUsage: { type: 'string' },
    addonOracleCPQQuota: { type: 'string' },
    addonQESUsage: { type: 'string' },
    addonQESQuota: { type: 'string' },
    addonDisplayNames: { type: 'string' },
    addonSmsDeliveryQuota: { type: 'string' },
    addonSmsDeliveryUsage: { type: 'string' },
    isEIdEnabled: { type: 'boolean' },
  },
  required: [
    'isHf',
    'isDelinquent',
    'taxCountry',
    'billingPlans',
    'hasBillingInfoAccess',
    'hasSubscriptionAccess',
    'taxIdSupported',
    'addonSalesforceUsage',
    'addonSalesforceQuota',
    'addonOracleCPQUsage',
    'addonOracleCPQQuota',
    'addonQESUsage',
    'addonQESQuota',
    'addonDisplayNames',
    'addonSmsDeliveryQuota',
    'addonSmsDeliveryUsage',
    'isEIdEnabled',
  ],
  definitions: {
    BillingPlan: {
      type: 'object',
      title: 'BillingPlan',
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        isApi: { type: 'boolean' },
        hasApiAccess: { type: 'boolean' },
        isCanceled: { type: 'boolean' },
        endDate: { type: 'string' },
        numSigRequestsUsed: { type: 'string' },
        numSigRequestsPerMonth: { type: 'string' },
        changePlanLink: { type: 'string' },
      },
      required: ['id', 'name', 'isApi', 'hasApiAccess', 'changePlanLink'],
    },
  },
};
const schema42 = {
  type: 'object',
  title: 'BillingPlan',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    isApi: { type: 'boolean' },
    hasApiAccess: { type: 'boolean' },
    isCanceled: { type: 'boolean' },
    endDate: { type: 'string' },
    numSigRequestsUsed: { type: 'string' },
    numSigRequestsPerMonth: { type: 'string' },
    changePlanLink: { type: 'string' },
  },
  required: ['id', 'name', 'isApi', 'hasApiAccess', 'changePlanLink'],
};
function validate24(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="WebAppBillingSettings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.isHf === undefined && (missing0 = 'isHf')) ||
        (data.isDelinquent === undefined && (missing0 = 'isDelinquent')) ||
        (data.taxCountry === undefined && (missing0 = 'taxCountry')) ||
        (data.billingPlans === undefined && (missing0 = 'billingPlans')) ||
        (data.hasBillingInfoAccess === undefined &&
          (missing0 = 'hasBillingInfoAccess')) ||
        (data.hasSubscriptionAccess === undefined &&
          (missing0 = 'hasSubscriptionAccess')) ||
        (data.taxIdSupported === undefined && (missing0 = 'taxIdSupported')) ||
        (data.addonSalesforceUsage === undefined &&
          (missing0 = 'addonSalesforceUsage')) ||
        (data.addonSalesforceQuota === undefined &&
          (missing0 = 'addonSalesforceQuota')) ||
        (data.addonOracleCPQUsage === undefined &&
          (missing0 = 'addonOracleCPQUsage')) ||
        (data.addonOracleCPQQuota === undefined &&
          (missing0 = 'addonOracleCPQQuota')) ||
        (data.addonQESUsage === undefined && (missing0 = 'addonQESUsage')) ||
        (data.addonQESQuota === undefined && (missing0 = 'addonQESQuota')) ||
        (data.addonDisplayNames === undefined &&
          (missing0 = 'addonDisplayNames')) ||
        (data.addonSmsDeliveryQuota === undefined &&
          (missing0 = 'addonSmsDeliveryQuota')) ||
        (data.addonSmsDeliveryUsage === undefined &&
          (missing0 = 'addonSmsDeliveryUsage')) ||
        (data.isEIdEnabled === undefined && (missing0 = 'isEIdEnabled'))
      ) {
        validate24.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.taxIdSupported !== undefined) {
          const _errs1 = errors;
          if (typeof data.taxIdSupported !== 'boolean') {
            validate24.errors = [
              {
                instancePath: instancePath + '/taxIdSupported',
                schemaPath: '#/properties/taxIdSupported/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.taxCountry !== undefined) {
            const _errs3 = errors;
            if (typeof data.taxCountry !== 'string') {
              validate24.errors = [
                {
                  instancePath: instancePath + '/taxCountry',
                  schemaPath: '#/properties/taxCountry/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.hasSubscriptionAccess !== undefined) {
              const _errs5 = errors;
              if (typeof data.hasSubscriptionAccess !== 'boolean') {
                validate24.errors = [
                  {
                    instancePath: instancePath + '/hasSubscriptionAccess',
                    schemaPath: '#/properties/hasSubscriptionAccess/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.hasBillingInfoAccess !== undefined) {
                const _errs7 = errors;
                if (typeof data.hasBillingInfoAccess !== 'boolean') {
                  validate24.errors = [
                    {
                      instancePath: instancePath + '/hasBillingInfoAccess',
                      schemaPath: '#/properties/hasBillingInfoAccess/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.isHf !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.isHf !== 'boolean') {
                    validate24.errors = [
                      {
                        instancePath: instancePath + '/isHf',
                        schemaPath: '#/properties/isHf/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.isDelinquent !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.isDelinquent !== 'boolean') {
                      validate24.errors = [
                        {
                          instancePath: instancePath + '/isDelinquent',
                          schemaPath: '#/properties/isDelinquent/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.billingPlans !== undefined) {
                      let data6 = data.billingPlans;
                      const _errs13 = errors;
                      if (errors === _errs13) {
                        if (Array.isArray(data6)) {
                          var valid1 = true;
                          const len0 = data6.length;
                          for (let i0 = 0; i0 < len0; i0++) {
                            let data7 = data6[i0];
                            const _errs15 = errors;
                            const _errs16 = errors;
                            let valid2 = false;
                            let passing0 = null;
                            const _errs17 = errors;
                            const _errs18 = errors;
                            if (errors === _errs18) {
                              if (
                                data7 &&
                                typeof data7 == 'object' &&
                                !Array.isArray(data7)
                              ) {
                                let missing1;
                                if (
                                  (data7.id === undefined &&
                                    (missing1 = 'id')) ||
                                  (data7.name === undefined &&
                                    (missing1 = 'name')) ||
                                  (data7.isApi === undefined &&
                                    (missing1 = 'isApi')) ||
                                  (data7.hasApiAccess === undefined &&
                                    (missing1 = 'hasApiAccess')) ||
                                  (data7.changePlanLink === undefined &&
                                    (missing1 = 'changePlanLink'))
                                ) {
                                  const err0 = {
                                    instancePath:
                                      instancePath + '/billingPlans/' + i0,
                                    schemaPath:
                                      '#/definitions/BillingPlan/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing1 },
                                    message:
                                      "must have required property '" +
                                      missing1 +
                                      "'",
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err0];
                                  } else {
                                    vErrors.push(err0);
                                  }
                                  errors++;
                                } else {
                                  if (data7.id !== undefined) {
                                    const _errs20 = errors;
                                    if (typeof data7.id !== 'string') {
                                      const err1 = {
                                        instancePath:
                                          instancePath +
                                          '/billingPlans/' +
                                          i0 +
                                          '/id',
                                        schemaPath:
                                          '#/definitions/BillingPlan/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err1];
                                      } else {
                                        vErrors.push(err1);
                                      }
                                      errors++;
                                    }
                                    var valid4 = _errs20 === errors;
                                  } else {
                                    var valid4 = true;
                                  }
                                  if (valid4) {
                                    if (data7.name !== undefined) {
                                      const _errs22 = errors;
                                      if (typeof data7.name !== 'string') {
                                        const err2 = {
                                          instancePath:
                                            instancePath +
                                            '/billingPlans/' +
                                            i0 +
                                            '/name',
                                          schemaPath:
                                            '#/definitions/BillingPlan/properties/name/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err2];
                                        } else {
                                          vErrors.push(err2);
                                        }
                                        errors++;
                                      }
                                      var valid4 = _errs22 === errors;
                                    } else {
                                      var valid4 = true;
                                    }
                                    if (valid4) {
                                      if (data7.isApi !== undefined) {
                                        const _errs24 = errors;
                                        if (typeof data7.isApi !== 'boolean') {
                                          const err3 = {
                                            instancePath:
                                              instancePath +
                                              '/billingPlans/' +
                                              i0 +
                                              '/isApi',
                                            schemaPath:
                                              '#/definitions/BillingPlan/properties/isApi/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err3];
                                          } else {
                                            vErrors.push(err3);
                                          }
                                          errors++;
                                        }
                                        var valid4 = _errs24 === errors;
                                      } else {
                                        var valid4 = true;
                                      }
                                      if (valid4) {
                                        if (data7.hasApiAccess !== undefined) {
                                          const _errs26 = errors;
                                          if (
                                            typeof data7.hasApiAccess !==
                                            'boolean'
                                          ) {
                                            const err4 = {
                                              instancePath:
                                                instancePath +
                                                '/billingPlans/' +
                                                i0 +
                                                '/hasApiAccess',
                                              schemaPath:
                                                '#/definitions/BillingPlan/properties/hasApiAccess/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err4];
                                            } else {
                                              vErrors.push(err4);
                                            }
                                            errors++;
                                          }
                                          var valid4 = _errs26 === errors;
                                        } else {
                                          var valid4 = true;
                                        }
                                        if (valid4) {
                                          if (data7.isCanceled !== undefined) {
                                            const _errs28 = errors;
                                            if (
                                              typeof data7.isCanceled !==
                                              'boolean'
                                            ) {
                                              const err5 = {
                                                instancePath:
                                                  instancePath +
                                                  '/billingPlans/' +
                                                  i0 +
                                                  '/isCanceled',
                                                schemaPath:
                                                  '#/definitions/BillingPlan/properties/isCanceled/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err5];
                                              } else {
                                                vErrors.push(err5);
                                              }
                                              errors++;
                                            }
                                            var valid4 = _errs28 === errors;
                                          } else {
                                            var valid4 = true;
                                          }
                                          if (valid4) {
                                            if (data7.endDate !== undefined) {
                                              const _errs30 = errors;
                                              if (
                                                typeof data7.endDate !==
                                                'string'
                                              ) {
                                                const err6 = {
                                                  instancePath:
                                                    instancePath +
                                                    '/billingPlans/' +
                                                    i0 +
                                                    '/endDate',
                                                  schemaPath:
                                                    '#/definitions/BillingPlan/properties/endDate/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err6];
                                                } else {
                                                  vErrors.push(err6);
                                                }
                                                errors++;
                                              }
                                              var valid4 = _errs30 === errors;
                                            } else {
                                              var valid4 = true;
                                            }
                                            if (valid4) {
                                              if (
                                                data7.numSigRequestsUsed !==
                                                undefined
                                              ) {
                                                const _errs32 = errors;
                                                if (
                                                  typeof data7.numSigRequestsUsed !==
                                                  'string'
                                                ) {
                                                  const err7 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/billingPlans/' +
                                                      i0 +
                                                      '/numSigRequestsUsed',
                                                    schemaPath:
                                                      '#/definitions/BillingPlan/properties/numSigRequestsUsed/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err7];
                                                  } else {
                                                    vErrors.push(err7);
                                                  }
                                                  errors++;
                                                }
                                                var valid4 = _errs32 === errors;
                                              } else {
                                                var valid4 = true;
                                              }
                                              if (valid4) {
                                                if (
                                                  data7.numSigRequestsPerMonth !==
                                                  undefined
                                                ) {
                                                  const _errs34 = errors;
                                                  if (
                                                    typeof data7.numSigRequestsPerMonth !==
                                                    'string'
                                                  ) {
                                                    const err8 = {
                                                      instancePath:
                                                        instancePath +
                                                        '/billingPlans/' +
                                                        i0 +
                                                        '/numSigRequestsPerMonth',
                                                      schemaPath:
                                                        '#/definitions/BillingPlan/properties/numSigRequestsPerMonth/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err8];
                                                    } else {
                                                      vErrors.push(err8);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid4 =
                                                    _errs34 === errors;
                                                } else {
                                                  var valid4 = true;
                                                }
                                                if (valid4) {
                                                  if (
                                                    data7.changePlanLink !==
                                                    undefined
                                                  ) {
                                                    const _errs36 = errors;
                                                    if (
                                                      typeof data7.changePlanLink !==
                                                      'string'
                                                    ) {
                                                      const err9 = {
                                                        instancePath:
                                                          instancePath +
                                                          '/billingPlans/' +
                                                          i0 +
                                                          '/changePlanLink',
                                                        schemaPath:
                                                          '#/definitions/BillingPlan/properties/changePlanLink/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err9];
                                                      } else {
                                                        vErrors.push(err9);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid4 =
                                                      _errs36 === errors;
                                                  } else {
                                                    var valid4 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                const err10 = {
                                  instancePath:
                                    instancePath + '/billingPlans/' + i0,
                                  schemaPath: '#/definitions/BillingPlan/type',
                                  keyword: 'type',
                                  params: { type: 'object' },
                                  message: 'must be object',
                                };
                                if (vErrors === null) {
                                  vErrors = [err10];
                                } else {
                                  vErrors.push(err10);
                                }
                                errors++;
                              }
                            }
                            var _valid0 = _errs17 === errors;
                            if (_valid0) {
                              valid2 = true;
                              passing0 = 0;
                            }
                            if (!valid2) {
                              const err11 = {
                                instancePath:
                                  instancePath + '/billingPlans/' + i0,
                                schemaPath:
                                  '#/properties/billingPlans/items/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing0 },
                                message:
                                  'must match exactly one schema in oneOf',
                              };
                              if (vErrors === null) {
                                vErrors = [err11];
                              } else {
                                vErrors.push(err11);
                              }
                              errors++;
                              validate24.errors = vErrors;
                              return false;
                            } else {
                              errors = _errs16;
                              if (vErrors !== null) {
                                if (_errs16) {
                                  vErrors.length = _errs16;
                                } else {
                                  vErrors = null;
                                }
                              }
                            }
                            var valid1 = _errs15 === errors;
                            if (!valid1) {
                              break;
                            }
                          }
                        } else {
                          validate24.errors = [
                            {
                              instancePath: instancePath + '/billingPlans',
                              schemaPath: '#/properties/billingPlans/type',
                              keyword: 'type',
                              params: { type: 'array' },
                              message: 'must be array',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.businessName !== undefined) {
                        const _errs38 = errors;
                        if (typeof data.businessName !== 'string') {
                          validate24.errors = [
                            {
                              instancePath: instancePath + '/businessName',
                              schemaPath: '#/properties/businessName/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs38 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.receiptAddress !== undefined) {
                          const _errs40 = errors;
                          if (typeof data.receiptAddress !== 'string') {
                            validate24.errors = [
                              {
                                instancePath: instancePath + '/receiptAddress',
                                schemaPath: '#/properties/receiptAddress/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs40 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.addonSalesforceUsage !== undefined) {
                            const _errs42 = errors;
                            if (typeof data.addonSalesforceUsage !== 'string') {
                              validate24.errors = [
                                {
                                  instancePath:
                                    instancePath + '/addonSalesforceUsage',
                                  schemaPath:
                                    '#/properties/addonSalesforceUsage/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs42 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.addonSalesforceQuota !== undefined) {
                              const _errs44 = errors;
                              if (
                                typeof data.addonSalesforceQuota !== 'string'
                              ) {
                                validate24.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/addonSalesforceQuota',
                                    schemaPath:
                                      '#/properties/addonSalesforceQuota/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs44 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.addonOracleCPQUsage !== undefined) {
                                const _errs46 = errors;
                                if (
                                  typeof data.addonOracleCPQUsage !== 'string'
                                ) {
                                  validate24.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/addonOracleCPQUsage',
                                      schemaPath:
                                        '#/properties/addonOracleCPQUsage/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs46 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.addonOracleCPQQuota !== undefined) {
                                  const _errs48 = errors;
                                  if (
                                    typeof data.addonOracleCPQQuota !== 'string'
                                  ) {
                                    validate24.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/addonOracleCPQQuota',
                                        schemaPath:
                                          '#/properties/addonOracleCPQQuota/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs48 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.addonQESUsage !== undefined) {
                                    const _errs50 = errors;
                                    if (
                                      typeof data.addonQESUsage !== 'string'
                                    ) {
                                      validate24.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/addonQESUsage',
                                          schemaPath:
                                            '#/properties/addonQESUsage/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs50 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.addonQESQuota !== undefined) {
                                      const _errs52 = errors;
                                      if (
                                        typeof data.addonQESQuota !== 'string'
                                      ) {
                                        validate24.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/addonQESQuota',
                                            schemaPath:
                                              '#/properties/addonQESQuota/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs52 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (
                                        data.addonDisplayNames !== undefined
                                      ) {
                                        const _errs54 = errors;
                                        if (
                                          typeof data.addonDisplayNames !==
                                          'string'
                                        ) {
                                          validate24.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/addonDisplayNames',
                                              schemaPath:
                                                '#/properties/addonDisplayNames/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs54 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.addonSmsDeliveryQuota !==
                                          undefined
                                        ) {
                                          const _errs56 = errors;
                                          if (
                                            typeof data.addonSmsDeliveryQuota !==
                                            'string'
                                          ) {
                                            validate24.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/addonSmsDeliveryQuota',
                                                schemaPath:
                                                  '#/properties/addonSmsDeliveryQuota/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs56 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (
                                            data.addonSmsDeliveryUsage !==
                                            undefined
                                          ) {
                                            const _errs58 = errors;
                                            if (
                                              typeof data.addonSmsDeliveryUsage !==
                                              'string'
                                            ) {
                                              validate24.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/addonSmsDeliveryUsage',
                                                  schemaPath:
                                                    '#/properties/addonSmsDeliveryUsage/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs58 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (
                                              data.isEIdEnabled !== undefined
                                            ) {
                                              const _errs60 = errors;
                                              if (
                                                typeof data.isEIdEnabled !==
                                                'boolean'
                                              ) {
                                                validate24.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/isEIdEnabled',
                                                    schemaPath:
                                                      '#/properties/isEIdEnabled/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs60 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate24.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate24.errors = vErrors;
  return errors === 0;
}
function validate21(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="WebAppAccountSettings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.hipaaLock === undefined && (missing0 = 'hipaaLock')) ||
        (data.isBrandingEnabled === undefined &&
          (missing0 = 'isBrandingEnabled')) ||
        (data.isAccountLogoTeamLogo === undefined &&
          (missing0 = 'isAccountLogoTeamLogo')) ||
        (data.hasSubscriptionAccess === undefined &&
          (missing0 = 'hasSubscriptionAccess')) ||
        (data.isCompanyTaglineEnabled === undefined &&
          (missing0 = 'isCompanyTaglineEnabled')) ||
        (data.companyTagline === undefined && (missing0 = 'companyTagline')) ||
        (data.isEmailFromEnabled === undefined &&
          (missing0 = 'isEmailFromEnabled')) ||
        (data.emailFrom === undefined && (missing0 = 'emailFrom')) ||
        (data.isEmailSignatureEnabled === undefined &&
          (missing0 = 'isEmailSignatureEnabled')) ||
        (data.emailSignature === undefined && (missing0 = 'emailSignature')) ||
        (data.isCustomSigningRedirectEnabled === undefined &&
          (missing0 = 'isCustomSigningRedirectEnabled')) ||
        (data.customSigningRedirectUrl === undefined &&
          (missing0 = 'customSigningRedirectUrl')) ||
        (data.signatureTypes === undefined && (missing0 = 'signatureTypes')) ||
        (data.isShouldIncludeDistinctPdfsEnabled === undefined &&
          (missing0 = 'isShouldIncludeDistinctPdfsEnabled')) ||
        (data.shouldIncludeDistinctPdfs === undefined &&
          (missing0 = 'shouldIncludeDistinctPdfs')) ||
        (data.isShouldRemoveDocumentIdEnabled === undefined &&
          (missing0 = 'isShouldRemoveDocumentIdEnabled')) ||
        (data.shouldRemoveDocumentId === undefined &&
          (missing0 = 'shouldRemoveDocumentId')) ||
        (data.isInPersonSigningEnabled === undefined &&
          (missing0 = 'isInPersonSigningEnabled')) ||
        (data.inPersonSigning === undefined &&
          (missing0 = 'inPersonSigning')) ||
        (data.documentRetention === undefined &&
          (missing0 = 'documentRetention')) ||
        (data.company === undefined && (missing0 = 'company')) ||
        (data.industry === undefined && (missing0 = 'industry')) ||
        (data.jobTitle === undefined && (missing0 = 'jobTitle')) ||
        (data.department === undefined && (missing0 = 'department')) ||
        (data.dateFormat === undefined && (missing0 = 'dateFormat')) ||
        (data.canUpdateTimezone === undefined &&
          (missing0 = 'canUpdateTimezone')) ||
        (data.timezone === undefined && (missing0 = 'timezone')) ||
        (data.timezoneOptions === undefined &&
          (missing0 = 'timezoneOptions')) ||
        (data.isAutocompleteEnabled === undefined &&
          (missing0 = 'isAutocompleteEnabled')) ||
        (data.isTamperproofEnabled === undefined &&
          (missing0 = 'isTamperproofEnabled')) ||
        (data.faxNumbers === undefined && (missing0 = 'faxNumbers')) ||
        (data.hfBrandName === undefined && (missing0 = 'hfBrandName')) ||
        (data.hsBrandName === undefined && (missing0 = 'hsBrandName')) ||
        (data.isOptedIntoMarketingEmails === undefined &&
          (missing0 = 'isOptedIntoMarketingEmails')) ||
        (data.isSignatureRemindersEnabled === undefined &&
          (missing0 = 'isSignatureRemindersEnabled')) ||
        (data.notifications === undefined && (missing0 = 'notifications')) ||
        (data.notificationAttachments === undefined &&
          (missing0 = 'notificationAttachments')) ||
        (data['2fa'] === undefined && (missing0 = '2fa')) ||
        (data.onBehalf === undefined && (missing0 = 'onBehalf')) ||
        (data.billing === undefined && (missing0 = 'billing')) ||
        (data.integrations === undefined && (missing0 = 'integrations'))
      ) {
        validate21.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.customLogoUrl !== undefined) {
          const _errs1 = errors;
          if (typeof data.customLogoUrl !== 'string') {
            validate21.errors = [
              {
                instancePath: instancePath + '/customLogoUrl',
                schemaPath: '#/properties/customLogoUrl/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.isBrandingEnabled !== undefined) {
            const _errs3 = errors;
            if (typeof data.isBrandingEnabled !== 'boolean') {
              validate21.errors = [
                {
                  instancePath: instancePath + '/isBrandingEnabled',
                  schemaPath: '#/properties/isBrandingEnabled/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.isAccountLogoTeamLogo !== undefined) {
              const _errs5 = errors;
              if (typeof data.isAccountLogoTeamLogo !== 'boolean') {
                validate21.errors = [
                  {
                    instancePath: instancePath + '/isAccountLogoTeamLogo',
                    schemaPath: '#/properties/isAccountLogoTeamLogo/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.hasSubscriptionAccess !== undefined) {
                const _errs7 = errors;
                if (typeof data.hasSubscriptionAccess !== 'boolean') {
                  validate21.errors = [
                    {
                      instancePath: instancePath + '/hasSubscriptionAccess',
                      schemaPath: '#/properties/hasSubscriptionAccess/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.isCompanyTaglineEnabled !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.isCompanyTaglineEnabled !== 'boolean') {
                    validate21.errors = [
                      {
                        instancePath: instancePath + '/isCompanyTaglineEnabled',
                        schemaPath: '#/properties/isCompanyTaglineEnabled/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.companyTagline !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.companyTagline !== 'string') {
                      validate21.errors = [
                        {
                          instancePath: instancePath + '/companyTagline',
                          schemaPath: '#/properties/companyTagline/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.isEmailFromEnabled !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.isEmailFromEnabled !== 'string') {
                        validate21.errors = [
                          {
                            instancePath: instancePath + '/isEmailFromEnabled',
                            schemaPath: '#/properties/isEmailFromEnabled/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.emailFrom !== undefined) {
                        const _errs15 = errors;
                        if (typeof data.emailFrom !== 'string') {
                          validate21.errors = [
                            {
                              instancePath: instancePath + '/emailFrom',
                              schemaPath: '#/properties/emailFrom/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isEmailSignatureEnabled !== undefined) {
                          const _errs17 = errors;
                          if (
                            typeof data.isEmailSignatureEnabled !== 'string'
                          ) {
                            validate21.errors = [
                              {
                                instancePath:
                                  instancePath + '/isEmailSignatureEnabled',
                                schemaPath:
                                  '#/properties/isEmailSignatureEnabled/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.emailSignature !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.emailSignature !== 'string') {
                              validate21.errors = [
                                {
                                  instancePath:
                                    instancePath + '/emailSignature',
                                  schemaPath:
                                    '#/properties/emailSignature/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (
                              data.isCustomSigningRedirectEnabled !== undefined
                            ) {
                              const _errs21 = errors;
                              if (
                                typeof data.isCustomSigningRedirectEnabled !==
                                'boolean'
                              ) {
                                validate21.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/isCustomSigningRedirectEnabled',
                                    schemaPath:
                                      '#/properties/isCustomSigningRedirectEnabled/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.customSigningRedirectUrl !== undefined) {
                                const _errs23 = errors;
                                if (
                                  typeof data.customSigningRedirectUrl !==
                                  'string'
                                ) {
                                  validate21.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/customSigningRedirectUrl',
                                      schemaPath:
                                        '#/properties/customSigningRedirectUrl/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.signatureTypes !== undefined) {
                                  let data12 = data.signatureTypes;
                                  const _errs25 = errors;
                                  const _errs26 = errors;
                                  if (errors === _errs26) {
                                    if (
                                      data12 &&
                                      typeof data12 == 'object' &&
                                      !Array.isArray(data12)
                                    ) {
                                      let missing1;
                                      if (
                                        (data12.isDrawnEnabled === undefined &&
                                          (missing1 = 'isDrawnEnabled')) ||
                                        (data12.isTypedEnabled === undefined &&
                                          (missing1 = 'isTypedEnabled')) ||
                                        (data12.isUploadedEnabled ===
                                          undefined &&
                                          (missing1 = 'isUploadedEnabled')) ||
                                        (data12.isSmartphoneEnabled ===
                                          undefined &&
                                          (missing1 = 'isSmartphoneEnabled'))
                                      ) {
                                        validate21.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/signatureTypes',
                                            schemaPath:
                                              '#/definitions/signatureTypes/required',
                                            keyword: 'required',
                                            params: {
                                              missingProperty: missing1,
                                            },
                                            message:
                                              "must have required property '" +
                                              missing1 +
                                              "'",
                                          },
                                        ];
                                        return false;
                                      } else {
                                        if (
                                          data12.isDrawnEnabled !== undefined
                                        ) {
                                          const _errs28 = errors;
                                          if (
                                            typeof data12.isDrawnEnabled !==
                                            'boolean'
                                          ) {
                                            validate21.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/signatureTypes/isDrawnEnabled',
                                                schemaPath:
                                                  '#/definitions/signatureTypes/properties/isDrawnEnabled/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid2 = _errs28 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (
                                            data12.isTypedEnabled !== undefined
                                          ) {
                                            const _errs30 = errors;
                                            if (
                                              typeof data12.isTypedEnabled !==
                                              'boolean'
                                            ) {
                                              validate21.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/signatureTypes/isTypedEnabled',
                                                  schemaPath:
                                                    '#/definitions/signatureTypes/properties/isTypedEnabled/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid2 = _errs30 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (
                                              data12.isUploadedEnabled !==
                                              undefined
                                            ) {
                                              const _errs32 = errors;
                                              if (
                                                typeof data12.isUploadedEnabled !==
                                                'boolean'
                                              ) {
                                                validate21.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/signatureTypes/isUploadedEnabled',
                                                    schemaPath:
                                                      '#/definitions/signatureTypes/properties/isUploadedEnabled/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid2 = _errs32 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (
                                                data12.isSmartphoneEnabled !==
                                                undefined
                                              ) {
                                                const _errs34 = errors;
                                                if (
                                                  typeof data12.isSmartphoneEnabled !==
                                                  'boolean'
                                                ) {
                                                  validate21.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/signatureTypes/isSmartphoneEnabled',
                                                      schemaPath:
                                                        '#/definitions/signatureTypes/properties/isSmartphoneEnabled/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid2 = _errs34 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      validate21.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/signatureTypes',
                                          schemaPath:
                                            '#/definitions/signatureTypes/type',
                                          keyword: 'type',
                                          params: { type: 'object' },
                                          message: 'must be object',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (
                                    data.isShouldIncludeDistinctPdfsEnabled !==
                                    undefined
                                  ) {
                                    const _errs36 = errors;
                                    if (
                                      typeof data.isShouldIncludeDistinctPdfsEnabled !==
                                      'boolean'
                                    ) {
                                      validate21.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/isShouldIncludeDistinctPdfsEnabled',
                                          schemaPath:
                                            '#/properties/isShouldIncludeDistinctPdfsEnabled/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs36 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (
                                      data.shouldIncludeDistinctPdfs !==
                                      undefined
                                    ) {
                                      const _errs38 = errors;
                                      if (
                                        typeof data.shouldIncludeDistinctPdfs !==
                                        'boolean'
                                      ) {
                                        validate21.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/shouldIncludeDistinctPdfs',
                                            schemaPath:
                                              '#/properties/shouldIncludeDistinctPdfs/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs38 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (
                                        data.isShouldRemoveDocumentIdEnabled !==
                                        undefined
                                      ) {
                                        const _errs40 = errors;
                                        if (
                                          typeof data.isShouldRemoveDocumentIdEnabled !==
                                          'boolean'
                                        ) {
                                          validate21.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/isShouldRemoveDocumentIdEnabled',
                                              schemaPath:
                                                '#/properties/isShouldRemoveDocumentIdEnabled/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs40 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.shouldRemoveDocumentId !==
                                          undefined
                                        ) {
                                          const _errs42 = errors;
                                          if (
                                            typeof data.shouldRemoveDocumentId !==
                                            'boolean'
                                          ) {
                                            validate21.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/shouldRemoveDocumentId',
                                                schemaPath:
                                                  '#/properties/shouldRemoveDocumentId/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs42 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (
                                            data.isInPersonSigningEnabled !==
                                            undefined
                                          ) {
                                            const _errs44 = errors;
                                            if (
                                              typeof data.isInPersonSigningEnabled !==
                                              'boolean'
                                            ) {
                                              validate21.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/isInPersonSigningEnabled',
                                                  schemaPath:
                                                    '#/properties/isInPersonSigningEnabled/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs44 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (
                                              data.inPersonSigning !== undefined
                                            ) {
                                              const _errs46 = errors;
                                              if (
                                                typeof data.inPersonSigning !==
                                                'boolean'
                                              ) {
                                                validate21.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/inPersonSigning',
                                                    schemaPath:
                                                      '#/properties/inPersonSigning/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs46 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (
                                                data.documentRetention !==
                                                undefined
                                              ) {
                                                let data23 =
                                                  data.documentRetention;
                                                const _errs48 = errors;
                                                const _errs49 = errors;
                                                if (errors === _errs49) {
                                                  if (
                                                    data23 &&
                                                    typeof data23 == 'object' &&
                                                    !Array.isArray(data23)
                                                  ) {
                                                    let missing2;
                                                    if (
                                                      (data23.ongoingDeleteDocuments ===
                                                        undefined &&
                                                        (missing2 =
                                                          'ongoingDeleteDocuments')) ||
                                                      (data23.canSetOngoingDeleteSetting ===
                                                        undefined &&
                                                        (missing2 =
                                                          'canSetOngoingDeleteSetting')) ||
                                                      (data23.canSetOneTimeDeleteSetting ===
                                                        undefined &&
                                                        (missing2 =
                                                          'canSetOneTimeDeleteSetting'))
                                                    ) {
                                                      validate21.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/documentRetention',
                                                          schemaPath:
                                                            '#/definitions/documentRetention/required',
                                                          keyword: 'required',
                                                          params: {
                                                            missingProperty:
                                                              missing2,
                                                          },
                                                          message:
                                                            "must have required property '" +
                                                            missing2 +
                                                            "'",
                                                        },
                                                      ];
                                                      return false;
                                                    } else {
                                                      if (
                                                        data23.ongoingDeleteDocuments !==
                                                        undefined
                                                      ) {
                                                        const _errs51 = errors;
                                                        if (
                                                          typeof data23.ongoingDeleteDocuments !==
                                                          'boolean'
                                                        ) {
                                                          validate21.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/documentRetention/ongoingDeleteDocuments',
                                                              schemaPath:
                                                                '#/definitions/documentRetention/properties/ongoingDeleteDocuments/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'boolean',
                                                              },
                                                              message:
                                                                'must be boolean',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid4 =
                                                          _errs51 === errors;
                                                      } else {
                                                        var valid4 = true;
                                                      }
                                                      if (valid4) {
                                                        if (
                                                          data23.canSetOngoingDeleteSetting !==
                                                          undefined
                                                        ) {
                                                          const _errs53 =
                                                            errors;
                                                          if (
                                                            typeof data23.canSetOngoingDeleteSetting !==
                                                            'boolean'
                                                          ) {
                                                            validate21.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/documentRetention/canSetOngoingDeleteSetting',
                                                                  schemaPath:
                                                                    '#/definitions/documentRetention/properties/canSetOngoingDeleteSetting/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'boolean',
                                                                  },
                                                                  message:
                                                                    'must be boolean',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid4 =
                                                            _errs53 === errors;
                                                        } else {
                                                          var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                          if (
                                                            data23.canSetOneTimeDeleteSetting !==
                                                            undefined
                                                          ) {
                                                            const _errs55 =
                                                              errors;
                                                            if (
                                                              typeof data23.canSetOneTimeDeleteSetting !==
                                                              'boolean'
                                                            ) {
                                                              validate21.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/documentRetention/canSetOneTimeDeleteSetting',
                                                                    schemaPath:
                                                                      '#/definitions/documentRetention/properties/canSetOneTimeDeleteSetting/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'boolean',
                                                                    },
                                                                    message:
                                                                      'must be boolean',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid4 =
                                                              _errs55 ===
                                                              errors;
                                                          } else {
                                                            var valid4 = true;
                                                          }
                                                        }
                                                      }
                                                    }
                                                  } else {
                                                    validate21.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/documentRetention',
                                                        schemaPath:
                                                          '#/definitions/documentRetention/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'object',
                                                        },
                                                        message:
                                                          'must be object',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                }
                                                var valid0 = _errs48 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.esignDisclosure !==
                                                  undefined
                                                ) {
                                                  let data27 =
                                                    data.esignDisclosure;
                                                  const _errs57 = errors;
                                                  const _errs59 = errors;
                                                  if (errors === _errs59) {
                                                    if (
                                                      data27 &&
                                                      typeof data27 ==
                                                        'object' &&
                                                      !Array.isArray(data27)
                                                    ) {
                                                      let missing3;
                                                      if (
                                                        (data27.isEnabled ===
                                                          undefined &&
                                                          (missing3 =
                                                            'isEnabled')) ||
                                                        (data27.isAdditionalTextEnabled ===
                                                          undefined &&
                                                          (missing3 =
                                                            'isAdditionalTextEnabled')) ||
                                                        (data27.additionalText ===
                                                          undefined &&
                                                          (missing3 =
                                                            'additionalText')) ||
                                                        (data27.businessName ===
                                                          undefined &&
                                                          (missing3 =
                                                            'businessName')) ||
                                                        (data27.header ===
                                                          undefined &&
                                                          (missing3 =
                                                            'header')) ||
                                                        (data27.text ===
                                                          undefined &&
                                                          (missing3 =
                                                            'text')) ||
                                                        (data27.textJoin ===
                                                          undefined &&
                                                          (missing3 =
                                                            'textJoin'))
                                                      ) {
                                                        validate21.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/esignDisclosure',
                                                            schemaPath:
                                                              '#/definitions/esignDisclosure/required',
                                                            keyword: 'required',
                                                            params: {
                                                              missingProperty:
                                                                missing3,
                                                            },
                                                            message:
                                                              "must have required property '" +
                                                              missing3 +
                                                              "'",
                                                          },
                                                        ];
                                                        return false;
                                                      } else {
                                                        if (
                                                          data27.isEnabled !==
                                                          undefined
                                                        ) {
                                                          const _errs61 =
                                                            errors;
                                                          if (
                                                            typeof data27.isEnabled !==
                                                            'boolean'
                                                          ) {
                                                            validate21.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/esignDisclosure/isEnabled',
                                                                  schemaPath:
                                                                    '#/definitions/esignDisclosure/properties/isEnabled/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'boolean',
                                                                  },
                                                                  message:
                                                                    'must be boolean',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid6 =
                                                            _errs61 === errors;
                                                        } else {
                                                          var valid6 = true;
                                                        }
                                                        if (valid6) {
                                                          if (
                                                            data27.isAdditionalTextEnabled !==
                                                            undefined
                                                          ) {
                                                            const _errs63 =
                                                              errors;
                                                            if (
                                                              typeof data27.isAdditionalTextEnabled !==
                                                              'boolean'
                                                            ) {
                                                              validate21.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/esignDisclosure/isAdditionalTextEnabled',
                                                                    schemaPath:
                                                                      '#/definitions/esignDisclosure/properties/isAdditionalTextEnabled/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'boolean',
                                                                    },
                                                                    message:
                                                                      'must be boolean',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid6 =
                                                              _errs63 ===
                                                              errors;
                                                          } else {
                                                            var valid6 = true;
                                                          }
                                                          if (valid6) {
                                                            if (
                                                              data27.additionalText !==
                                                              undefined
                                                            ) {
                                                              const _errs65 =
                                                                errors;
                                                              if (
                                                                typeof data27.additionalText !==
                                                                'string'
                                                              ) {
                                                                validate21.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/esignDisclosure/additionalText',
                                                                      schemaPath:
                                                                        '#/definitions/esignDisclosure/properties/additionalText/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'string',
                                                                      },
                                                                      message:
                                                                        'must be string',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid6 =
                                                                _errs65 ===
                                                                errors;
                                                            } else {
                                                              var valid6 = true;
                                                            }
                                                            if (valid6) {
                                                              if (
                                                                data27.businessName !==
                                                                undefined
                                                              ) {
                                                                const _errs67 =
                                                                  errors;
                                                                if (
                                                                  typeof data27.businessName !==
                                                                  'string'
                                                                ) {
                                                                  validate21.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/esignDisclosure/businessName',
                                                                        schemaPath:
                                                                          '#/definitions/esignDisclosure/properties/businessName/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'string',
                                                                          },
                                                                        message:
                                                                          'must be string',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid6 =
                                                                  _errs67 ===
                                                                  errors;
                                                              } else {
                                                                var valid6 = true;
                                                              }
                                                              if (valid6) {
                                                                if (
                                                                  data27.header !==
                                                                  undefined
                                                                ) {
                                                                  const _errs69 =
                                                                    errors;
                                                                  if (
                                                                    typeof data27.header !==
                                                                    'string'
                                                                  ) {
                                                                    validate21.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/esignDisclosure/header',
                                                                          schemaPath:
                                                                            '#/definitions/esignDisclosure/properties/header/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'string',
                                                                            },
                                                                          message:
                                                                            'must be string',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid6 =
                                                                    _errs69 ===
                                                                    errors;
                                                                } else {
                                                                  var valid6 = true;
                                                                }
                                                                if (valid6) {
                                                                  if (
                                                                    data27.text !==
                                                                    undefined
                                                                  ) {
                                                                    const _errs71 =
                                                                      errors;
                                                                    if (
                                                                      typeof data27.text !==
                                                                      'string'
                                                                    ) {
                                                                      validate21.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/esignDisclosure/text',
                                                                            schemaPath:
                                                                              '#/definitions/esignDisclosure/properties/text/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'string',
                                                                              },
                                                                            message:
                                                                              'must be string',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid6 =
                                                                      _errs71 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid6 = true;
                                                                  }
                                                                  if (valid6) {
                                                                    if (
                                                                      data27.textJoin !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs73 =
                                                                        errors;
                                                                      if (
                                                                        typeof data27.textJoin !==
                                                                        'string'
                                                                      ) {
                                                                        validate21.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/esignDisclosure/textJoin',
                                                                              schemaPath:
                                                                                '#/definitions/esignDisclosure/properties/textJoin/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'string',
                                                                                },
                                                                              message:
                                                                                'must be string',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid6 =
                                                                        _errs73 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid6 = true;
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    } else {
                                                      validate21.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/esignDisclosure',
                                                          schemaPath:
                                                            '#/definitions/esignDisclosure/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'object',
                                                          },
                                                          message:
                                                            'must be object',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                  }
                                                  var valid0 =
                                                    _errs57 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.dataResidency !==
                                                    undefined
                                                  ) {
                                                    let data35 =
                                                      data.dataResidency;
                                                    const _errs75 = errors;
                                                    const _errs76 = errors;
                                                    if (errors === _errs76) {
                                                      if (
                                                        data35 &&
                                                        typeof data35 ==
                                                          'object' &&
                                                        !Array.isArray(data35)
                                                      ) {
                                                        let missing4;
                                                        if (
                                                          (data35.isEnabled ===
                                                            undefined &&
                                                            (missing4 =
                                                              'isEnabled')) ||
                                                          (data35.hfRegion ===
                                                            undefined &&
                                                            (missing4 =
                                                              'hfRegion')) ||
                                                          (data35.hsRegion ===
                                                            undefined &&
                                                            (missing4 =
                                                              'hsRegion'))
                                                        ) {
                                                          validate21.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/dataResidency',
                                                              schemaPath:
                                                                '#/definitions/dataResidency/required',
                                                              keyword:
                                                                'required',
                                                              params: {
                                                                missingProperty:
                                                                  missing4,
                                                              },
                                                              message:
                                                                "must have required property '" +
                                                                missing4 +
                                                                "'",
                                                            },
                                                          ];
                                                          return false;
                                                        } else {
                                                          if (
                                                            data35.isEnabled !==
                                                            undefined
                                                          ) {
                                                            const _errs78 =
                                                              errors;
                                                            if (
                                                              typeof data35.isEnabled !==
                                                              'boolean'
                                                            ) {
                                                              validate21.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/dataResidency/isEnabled',
                                                                    schemaPath:
                                                                      '#/definitions/dataResidency/properties/isEnabled/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'boolean',
                                                                    },
                                                                    message:
                                                                      'must be boolean',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid8 =
                                                              _errs78 ===
                                                              errors;
                                                          } else {
                                                            var valid8 = true;
                                                          }
                                                          if (valid8) {
                                                            if (
                                                              data35.hfRegion !==
                                                              undefined
                                                            ) {
                                                              const _errs80 =
                                                                errors;
                                                              if (
                                                                typeof data35.hfRegion !==
                                                                'string'
                                                              ) {
                                                                validate21.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/dataResidency/hfRegion',
                                                                      schemaPath:
                                                                        '#/definitions/dataResidency/properties/hfRegion/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'string',
                                                                      },
                                                                      message:
                                                                        'must be string',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid8 =
                                                                _errs80 ===
                                                                errors;
                                                            } else {
                                                              var valid8 = true;
                                                            }
                                                            if (valid8) {
                                                              if (
                                                                data35.hsRegion !==
                                                                undefined
                                                              ) {
                                                                const _errs82 =
                                                                  errors;
                                                                if (
                                                                  typeof data35.hsRegion !==
                                                                  'string'
                                                                ) {
                                                                  validate21.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/dataResidency/hsRegion',
                                                                        schemaPath:
                                                                          '#/definitions/dataResidency/properties/hsRegion/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'string',
                                                                          },
                                                                        message:
                                                                          'must be string',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid8 =
                                                                  _errs82 ===
                                                                  errors;
                                                              } else {
                                                                var valid8 = true;
                                                              }
                                                            }
                                                          }
                                                        }
                                                      } else {
                                                        validate21.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/dataResidency',
                                                            schemaPath:
                                                              '#/definitions/dataResidency/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'object',
                                                            },
                                                            message:
                                                              'must be object',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                    }
                                                    var valid0 =
                                                      _errs75 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (
                                                      data.company !== undefined
                                                    ) {
                                                      const _errs84 = errors;
                                                      if (
                                                        typeof data.company !==
                                                        'string'
                                                      ) {
                                                        validate21.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/company',
                                                            schemaPath:
                                                              '#/properties/company/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'string',
                                                            },
                                                            message:
                                                              'must be string',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid0 =
                                                        _errs84 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (
                                                        data.industry !==
                                                        undefined
                                                      ) {
                                                        const _errs86 = errors;
                                                        if (
                                                          typeof data.industry !==
                                                          'string'
                                                        ) {
                                                          validate21.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/industry',
                                                              schemaPath:
                                                                '#/properties/industry/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'string',
                                                              },
                                                              message:
                                                                'must be string',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid0 =
                                                          _errs86 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (
                                                          data.jobTitle !==
                                                          undefined
                                                        ) {
                                                          const _errs88 =
                                                            errors;
                                                          if (
                                                            typeof data.jobTitle !==
                                                            'string'
                                                          ) {
                                                            validate21.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/jobTitle',
                                                                  schemaPath:
                                                                    '#/properties/jobTitle/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'string',
                                                                  },
                                                                  message:
                                                                    'must be string',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid0 =
                                                            _errs88 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                          if (
                                                            data.department !==
                                                            undefined
                                                          ) {
                                                            const _errs90 =
                                                              errors;
                                                            if (
                                                              typeof data.department !==
                                                              'string'
                                                            ) {
                                                              validate21.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/department',
                                                                    schemaPath:
                                                                      '#/properties/department/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'string',
                                                                    },
                                                                    message:
                                                                      'must be string',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid0 =
                                                              _errs90 ===
                                                              errors;
                                                          } else {
                                                            var valid0 = true;
                                                          }
                                                          if (valid0) {
                                                            if (
                                                              data.dateFormat !==
                                                              undefined
                                                            ) {
                                                              const _errs92 =
                                                                errors;
                                                              if (
                                                                typeof data.dateFormat !==
                                                                'string'
                                                              ) {
                                                                validate21.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/dateFormat',
                                                                      schemaPath:
                                                                        '#/properties/dateFormat/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'string',
                                                                      },
                                                                      message:
                                                                        'must be string',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid0 =
                                                                _errs92 ===
                                                                errors;
                                                            } else {
                                                              var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                              if (
                                                                data.canUpdateTimezone !==
                                                                undefined
                                                              ) {
                                                                const _errs94 =
                                                                  errors;
                                                                if (
                                                                  typeof data.canUpdateTimezone !==
                                                                  'boolean'
                                                                ) {
                                                                  validate21.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/canUpdateTimezone',
                                                                        schemaPath:
                                                                          '#/properties/canUpdateTimezone/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'boolean',
                                                                          },
                                                                        message:
                                                                          'must be boolean',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid0 =
                                                                  _errs94 ===
                                                                  errors;
                                                              } else {
                                                                var valid0 = true;
                                                              }
                                                              if (valid0) {
                                                                if (
                                                                  data.timezone !==
                                                                  undefined
                                                                ) {
                                                                  const _errs96 =
                                                                    errors;
                                                                  if (
                                                                    typeof data.timezone !==
                                                                    'string'
                                                                  ) {
                                                                    validate21.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/timezone',
                                                                          schemaPath:
                                                                            '#/properties/timezone/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'string',
                                                                            },
                                                                          message:
                                                                            'must be string',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid0 =
                                                                    _errs96 ===
                                                                    errors;
                                                                } else {
                                                                  var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                  if (
                                                                    data.timezoneOptions !==
                                                                    undefined
                                                                  ) {
                                                                    let data46 =
                                                                      data.timezoneOptions;
                                                                    const _errs98 =
                                                                      errors;
                                                                    if (
                                                                      errors ===
                                                                      _errs98
                                                                    ) {
                                                                      if (
                                                                        Array.isArray(
                                                                          data46
                                                                        )
                                                                      ) {
                                                                        var valid9 = true;
                                                                        const len0 =
                                                                          data46.length;
                                                                        for (
                                                                          let i0 = 0;
                                                                          i0 <
                                                                          len0;
                                                                          i0++
                                                                        ) {
                                                                          let data47 =
                                                                            data46[
                                                                              i0
                                                                            ];
                                                                          const _errs100 =
                                                                            errors;
                                                                          const _errs101 =
                                                                            errors;
                                                                          if (
                                                                            errors ===
                                                                            _errs101
                                                                          ) {
                                                                            if (
                                                                              data47 &&
                                                                              typeof data47 ==
                                                                                'object' &&
                                                                              !Array.isArray(
                                                                                data47
                                                                              )
                                                                            ) {
                                                                              let missing5;
                                                                              if (
                                                                                (data47.offset ===
                                                                                  undefined &&
                                                                                  (missing5 =
                                                                                    'offset')) ||
                                                                                (data47.hasDST ===
                                                                                  undefined &&
                                                                                  (missing5 =
                                                                                    'hasDST')) ||
                                                                                (data47.displayName ===
                                                                                  undefined &&
                                                                                  (missing5 =
                                                                                    'displayName'))
                                                                              ) {
                                                                                validate21.errors =
                                                                                  [
                                                                                    {
                                                                                      instancePath:
                                                                                        instancePath +
                                                                                        '/timezoneOptions/' +
                                                                                        i0,
                                                                                      schemaPath:
                                                                                        'Timezone.json/required',
                                                                                      keyword:
                                                                                        'required',
                                                                                      params:
                                                                                        {
                                                                                          missingProperty:
                                                                                            missing5,
                                                                                        },
                                                                                      message:
                                                                                        "must have required property '" +
                                                                                        missing5 +
                                                                                        "'",
                                                                                    },
                                                                                  ];
                                                                                return false;
                                                                              } else {
                                                                                if (
                                                                                  data47.offset !==
                                                                                  undefined
                                                                                ) {
                                                                                  let data48 =
                                                                                    data47.offset;
                                                                                  const _errs103 =
                                                                                    errors;
                                                                                  if (
                                                                                    !(
                                                                                      typeof data48 ==
                                                                                        'number' &&
                                                                                      isFinite(
                                                                                        data48
                                                                                      )
                                                                                    )
                                                                                  ) {
                                                                                    validate21.errors =
                                                                                      [
                                                                                        {
                                                                                          instancePath:
                                                                                            instancePath +
                                                                                            '/timezoneOptions/' +
                                                                                            i0 +
                                                                                            '/offset',
                                                                                          schemaPath:
                                                                                            'Timezone.json/properties/offset/type',
                                                                                          keyword:
                                                                                            'type',
                                                                                          params:
                                                                                            {
                                                                                              type: 'number',
                                                                                            },
                                                                                          message:
                                                                                            'must be number',
                                                                                        },
                                                                                      ];
                                                                                    return false;
                                                                                  }
                                                                                  var valid11 =
                                                                                    _errs103 ===
                                                                                    errors;
                                                                                } else {
                                                                                  var valid11 = true;
                                                                                }
                                                                                if (
                                                                                  valid11
                                                                                ) {
                                                                                  if (
                                                                                    data47.hasDST !==
                                                                                    undefined
                                                                                  ) {
                                                                                    const _errs105 =
                                                                                      errors;
                                                                                    if (
                                                                                      typeof data47.hasDST !==
                                                                                      'boolean'
                                                                                    ) {
                                                                                      validate21.errors =
                                                                                        [
                                                                                          {
                                                                                            instancePath:
                                                                                              instancePath +
                                                                                              '/timezoneOptions/' +
                                                                                              i0 +
                                                                                              '/hasDST',
                                                                                            schemaPath:
                                                                                              'Timezone.json/properties/hasDST/type',
                                                                                            keyword:
                                                                                              'type',
                                                                                            params:
                                                                                              {
                                                                                                type: 'boolean',
                                                                                              },
                                                                                            message:
                                                                                              'must be boolean',
                                                                                          },
                                                                                        ];
                                                                                      return false;
                                                                                    }
                                                                                    var valid11 =
                                                                                      _errs105 ===
                                                                                      errors;
                                                                                  } else {
                                                                                    var valid11 = true;
                                                                                  }
                                                                                  if (
                                                                                    valid11
                                                                                  ) {
                                                                                    if (
                                                                                      data47.displayName !==
                                                                                      undefined
                                                                                    ) {
                                                                                      const _errs107 =
                                                                                        errors;
                                                                                      if (
                                                                                        typeof data47.displayName !==
                                                                                        'string'
                                                                                      ) {
                                                                                        validate21.errors =
                                                                                          [
                                                                                            {
                                                                                              instancePath:
                                                                                                instancePath +
                                                                                                '/timezoneOptions/' +
                                                                                                i0 +
                                                                                                '/displayName',
                                                                                              schemaPath:
                                                                                                'Timezone.json/properties/displayName/type',
                                                                                              keyword:
                                                                                                'type',
                                                                                              params:
                                                                                                {
                                                                                                  type: 'string',
                                                                                                },
                                                                                              message:
                                                                                                'must be string',
                                                                                            },
                                                                                          ];
                                                                                        return false;
                                                                                      }
                                                                                      var valid11 =
                                                                                        _errs107 ===
                                                                                        errors;
                                                                                    } else {
                                                                                      var valid11 = true;
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            } else {
                                                                              validate21.errors =
                                                                                [
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/timezoneOptions/' +
                                                                                      i0,
                                                                                    schemaPath:
                                                                                      'Timezone.json/type',
                                                                                    keyword:
                                                                                      'type',
                                                                                    params:
                                                                                      {
                                                                                        type: 'object',
                                                                                      },
                                                                                    message:
                                                                                      'must be object',
                                                                                  },
                                                                                ];
                                                                              return false;
                                                                            }
                                                                          }
                                                                          var valid9 =
                                                                            _errs100 ===
                                                                            errors;
                                                                          if (
                                                                            !valid9
                                                                          ) {
                                                                            break;
                                                                          }
                                                                        }
                                                                      } else {
                                                                        validate21.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/timezoneOptions',
                                                                              schemaPath:
                                                                                '#/properties/timezoneOptions/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'array',
                                                                                },
                                                                              message:
                                                                                'must be array',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                    }
                                                                    var valid0 =
                                                                      _errs98 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid0 = true;
                                                                  }
                                                                  if (valid0) {
                                                                    if (
                                                                      data.isAutocompleteEnabled !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs109 =
                                                                        errors;
                                                                      if (
                                                                        typeof data.isAutocompleteEnabled !==
                                                                        'boolean'
                                                                      ) {
                                                                        validate21.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/isAutocompleteEnabled',
                                                                              schemaPath:
                                                                                '#/properties/isAutocompleteEnabled/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'boolean',
                                                                                },
                                                                              message:
                                                                                'must be boolean',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid0 =
                                                                        _errs109 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid0 = true;
                                                                    }
                                                                    if (
                                                                      valid0
                                                                    ) {
                                                                      if (
                                                                        data.isTamperproofEnabled !==
                                                                        undefined
                                                                      ) {
                                                                        const _errs111 =
                                                                          errors;
                                                                        if (
                                                                          typeof data.isTamperproofEnabled !==
                                                                          'boolean'
                                                                        ) {
                                                                          validate21.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/isTamperproofEnabled',
                                                                                schemaPath:
                                                                                  '#/properties/isTamperproofEnabled/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'boolean',
                                                                                  },
                                                                                message:
                                                                                  'must be boolean',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid0 =
                                                                          _errs111 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid0 = true;
                                                                      }
                                                                      if (
                                                                        valid0
                                                                      ) {
                                                                        if (
                                                                          data.faxNumbers !==
                                                                          undefined
                                                                        ) {
                                                                          let data53 =
                                                                            data.faxNumbers;
                                                                          const _errs113 =
                                                                            errors;
                                                                          if (
                                                                            errors ===
                                                                            _errs113
                                                                          ) {
                                                                            if (
                                                                              Array.isArray(
                                                                                data53
                                                                              )
                                                                            ) {
                                                                              var valid12 = true;
                                                                              const len1 =
                                                                                data53.length;
                                                                              for (
                                                                                let i1 = 0;
                                                                                i1 <
                                                                                len1;
                                                                                i1++
                                                                              ) {
                                                                                const _errs115 =
                                                                                  errors;
                                                                                if (
                                                                                  typeof data53[
                                                                                    i1
                                                                                  ] !==
                                                                                  'string'
                                                                                ) {
                                                                                  validate21.errors =
                                                                                    [
                                                                                      {
                                                                                        instancePath:
                                                                                          instancePath +
                                                                                          '/faxNumbers/' +
                                                                                          i1,
                                                                                        schemaPath:
                                                                                          '#/properties/faxNumbers/items/type',
                                                                                        keyword:
                                                                                          'type',
                                                                                        params:
                                                                                          {
                                                                                            type: 'string',
                                                                                          },
                                                                                        message:
                                                                                          'must be string',
                                                                                      },
                                                                                    ];
                                                                                  return false;
                                                                                }
                                                                                var valid12 =
                                                                                  _errs115 ===
                                                                                  errors;
                                                                                if (
                                                                                  !valid12
                                                                                ) {
                                                                                  break;
                                                                                }
                                                                              }
                                                                            } else {
                                                                              validate21.errors =
                                                                                [
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/faxNumbers',
                                                                                    schemaPath:
                                                                                      '#/properties/faxNumbers/type',
                                                                                    keyword:
                                                                                      'type',
                                                                                    params:
                                                                                      {
                                                                                        type: 'array',
                                                                                      },
                                                                                    message:
                                                                                      'must be array',
                                                                                  },
                                                                                ];
                                                                              return false;
                                                                            }
                                                                          }
                                                                          var valid0 =
                                                                            _errs113 ===
                                                                            errors;
                                                                        } else {
                                                                          var valid0 = true;
                                                                        }
                                                                        if (
                                                                          valid0
                                                                        ) {
                                                                          if (
                                                                            data.hfBrandName !==
                                                                            undefined
                                                                          ) {
                                                                            const _errs117 =
                                                                              errors;
                                                                            if (
                                                                              typeof data.hfBrandName !==
                                                                              'string'
                                                                            ) {
                                                                              validate21.errors =
                                                                                [
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/hfBrandName',
                                                                                    schemaPath:
                                                                                      '#/properties/hfBrandName/type',
                                                                                    keyword:
                                                                                      'type',
                                                                                    params:
                                                                                      {
                                                                                        type: 'string',
                                                                                      },
                                                                                    message:
                                                                                      'must be string',
                                                                                  },
                                                                                ];
                                                                              return false;
                                                                            }
                                                                            var valid0 =
                                                                              _errs117 ===
                                                                              errors;
                                                                          } else {
                                                                            var valid0 = true;
                                                                          }
                                                                          if (
                                                                            valid0
                                                                          ) {
                                                                            if (
                                                                              data.hsBrandName !==
                                                                              undefined
                                                                            ) {
                                                                              const _errs119 =
                                                                                errors;
                                                                              if (
                                                                                typeof data.hsBrandName !==
                                                                                'string'
                                                                              ) {
                                                                                validate21.errors =
                                                                                  [
                                                                                    {
                                                                                      instancePath:
                                                                                        instancePath +
                                                                                        '/hsBrandName',
                                                                                      schemaPath:
                                                                                        '#/properties/hsBrandName/type',
                                                                                      keyword:
                                                                                        'type',
                                                                                      params:
                                                                                        {
                                                                                          type: 'string',
                                                                                        },
                                                                                      message:
                                                                                        'must be string',
                                                                                    },
                                                                                  ];
                                                                                return false;
                                                                              }
                                                                              var valid0 =
                                                                                _errs119 ===
                                                                                errors;
                                                                            } else {
                                                                              var valid0 = true;
                                                                            }
                                                                            if (
                                                                              valid0
                                                                            ) {
                                                                              if (
                                                                                data.isOptedIntoMarketingEmails !==
                                                                                undefined
                                                                              ) {
                                                                                const _errs121 =
                                                                                  errors;
                                                                                if (
                                                                                  typeof data.isOptedIntoMarketingEmails !==
                                                                                  'boolean'
                                                                                ) {
                                                                                  validate21.errors =
                                                                                    [
                                                                                      {
                                                                                        instancePath:
                                                                                          instancePath +
                                                                                          '/isOptedIntoMarketingEmails',
                                                                                        schemaPath:
                                                                                          '#/properties/isOptedIntoMarketingEmails/type',
                                                                                        keyword:
                                                                                          'type',
                                                                                        params:
                                                                                          {
                                                                                            type: 'boolean',
                                                                                          },
                                                                                        message:
                                                                                          'must be boolean',
                                                                                      },
                                                                                    ];
                                                                                  return false;
                                                                                }
                                                                                var valid0 =
                                                                                  _errs121 ===
                                                                                  errors;
                                                                              } else {
                                                                                var valid0 = true;
                                                                              }
                                                                              if (
                                                                                valid0
                                                                              ) {
                                                                                if (
                                                                                  data.isSignatureRemindersEnabled !==
                                                                                  undefined
                                                                                ) {
                                                                                  const _errs123 =
                                                                                    errors;
                                                                                  if (
                                                                                    typeof data.isSignatureRemindersEnabled !==
                                                                                    'boolean'
                                                                                  ) {
                                                                                    validate21.errors =
                                                                                      [
                                                                                        {
                                                                                          instancePath:
                                                                                            instancePath +
                                                                                            '/isSignatureRemindersEnabled',
                                                                                          schemaPath:
                                                                                            '#/properties/isSignatureRemindersEnabled/type',
                                                                                          keyword:
                                                                                            'type',
                                                                                          params:
                                                                                            {
                                                                                              type: 'boolean',
                                                                                            },
                                                                                          message:
                                                                                            'must be boolean',
                                                                                        },
                                                                                      ];
                                                                                    return false;
                                                                                  }
                                                                                  var valid0 =
                                                                                    _errs123 ===
                                                                                    errors;
                                                                                } else {
                                                                                  var valid0 = true;
                                                                                }
                                                                                if (
                                                                                  valid0
                                                                                ) {
                                                                                  if (
                                                                                    data.hipaaLock !==
                                                                                    undefined
                                                                                  ) {
                                                                                    let data59 =
                                                                                      data.hipaaLock;
                                                                                    const _errs125 =
                                                                                      errors;
                                                                                    const _errs126 =
                                                                                      errors;
                                                                                    if (
                                                                                      errors ===
                                                                                      _errs126
                                                                                    ) {
                                                                                      if (
                                                                                        data59 &&
                                                                                        typeof data59 ==
                                                                                          'object' &&
                                                                                        !Array.isArray(
                                                                                          data59
                                                                                        )
                                                                                      ) {
                                                                                        let missing6;
                                                                                        if (
                                                                                          (data59.enableIncludePdfOnFaxReceived ===
                                                                                            undefined &&
                                                                                            (missing6 =
                                                                                              'enableIncludePdfOnFaxReceived')) ||
                                                                                          (data59.includePdfOnFaxSent ===
                                                                                            undefined &&
                                                                                            (missing6 =
                                                                                              'includePdfOnFaxSent')) ||
                                                                                          (data59.includePdfForCcRecipientsOnFaxSent ===
                                                                                            undefined &&
                                                                                            (missing6 =
                                                                                              'includePdfForCcRecipientsOnFaxSent')) ||
                                                                                          (data59.shouldIncludeReceivedFaxPDFsForOthers ===
                                                                                            undefined &&
                                                                                            (missing6 =
                                                                                              'shouldIncludeReceivedFaxPDFsForOthers')) ||
                                                                                          (data59.includePdfForCcRecipientsOnDocumentSent ===
                                                                                            undefined &&
                                                                                            (missing6 =
                                                                                              'includePdfForCcRecipientsOnDocumentSent')) ||
                                                                                          (data59.includePdfForCcRecipientsOnDocumentCompleted ===
                                                                                            undefined &&
                                                                                            (missing6 =
                                                                                              'includePdfForCcRecipientsOnDocumentCompleted'))
                                                                                        ) {
                                                                                          validate21.errors =
                                                                                            [
                                                                                              {
                                                                                                instancePath:
                                                                                                  instancePath +
                                                                                                  '/hipaaLock',
                                                                                                schemaPath:
                                                                                                  '#/definitions/HipaaLock/required',
                                                                                                keyword:
                                                                                                  'required',
                                                                                                params:
                                                                                                  {
                                                                                                    missingProperty:
                                                                                                      missing6,
                                                                                                  },
                                                                                                message:
                                                                                                  "must have required property '" +
                                                                                                  missing6 +
                                                                                                  "'",
                                                                                              },
                                                                                            ];
                                                                                          return false;
                                                                                        } else {
                                                                                          if (
                                                                                            data59.enableIncludePdfOnFaxReceived !==
                                                                                            undefined
                                                                                          ) {
                                                                                            const _errs128 =
                                                                                              errors;
                                                                                            if (
                                                                                              typeof data59.enableIncludePdfOnFaxReceived !==
                                                                                              'boolean'
                                                                                            ) {
                                                                                              validate21.errors =
                                                                                                [
                                                                                                  {
                                                                                                    instancePath:
                                                                                                      instancePath +
                                                                                                      '/hipaaLock/enableIncludePdfOnFaxReceived',
                                                                                                    schemaPath:
                                                                                                      '#/definitions/HipaaLock/properties/enableIncludePdfOnFaxReceived/type',
                                                                                                    keyword:
                                                                                                      'type',
                                                                                                    params:
                                                                                                      {
                                                                                                        type: 'boolean',
                                                                                                      },
                                                                                                    message:
                                                                                                      'must be boolean',
                                                                                                  },
                                                                                                ];
                                                                                              return false;
                                                                                            }
                                                                                            var valid14 =
                                                                                              _errs128 ===
                                                                                              errors;
                                                                                          } else {
                                                                                            var valid14 = true;
                                                                                          }
                                                                                          if (
                                                                                            valid14
                                                                                          ) {
                                                                                            if (
                                                                                              data59.includePdfOnFaxSent !==
                                                                                              undefined
                                                                                            ) {
                                                                                              const _errs130 =
                                                                                                errors;
                                                                                              if (
                                                                                                typeof data59.includePdfOnFaxSent !==
                                                                                                'boolean'
                                                                                              ) {
                                                                                                validate21.errors =
                                                                                                  [
                                                                                                    {
                                                                                                      instancePath:
                                                                                                        instancePath +
                                                                                                        '/hipaaLock/includePdfOnFaxSent',
                                                                                                      schemaPath:
                                                                                                        '#/definitions/HipaaLock/properties/includePdfOnFaxSent/type',
                                                                                                      keyword:
                                                                                                        'type',
                                                                                                      params:
                                                                                                        {
                                                                                                          type: 'boolean',
                                                                                                        },
                                                                                                      message:
                                                                                                        'must be boolean',
                                                                                                    },
                                                                                                  ];
                                                                                                return false;
                                                                                              }
                                                                                              var valid14 =
                                                                                                _errs130 ===
                                                                                                errors;
                                                                                            } else {
                                                                                              var valid14 = true;
                                                                                            }
                                                                                            if (
                                                                                              valid14
                                                                                            ) {
                                                                                              if (
                                                                                                data59.includePdfForCcRecipientsOnFaxSent !==
                                                                                                undefined
                                                                                              ) {
                                                                                                const _errs132 =
                                                                                                  errors;
                                                                                                if (
                                                                                                  typeof data59.includePdfForCcRecipientsOnFaxSent !==
                                                                                                  'boolean'
                                                                                                ) {
                                                                                                  validate21.errors =
                                                                                                    [
                                                                                                      {
                                                                                                        instancePath:
                                                                                                          instancePath +
                                                                                                          '/hipaaLock/includePdfForCcRecipientsOnFaxSent',
                                                                                                        schemaPath:
                                                                                                          '#/definitions/HipaaLock/properties/includePdfForCcRecipientsOnFaxSent/type',
                                                                                                        keyword:
                                                                                                          'type',
                                                                                                        params:
                                                                                                          {
                                                                                                            type: 'boolean',
                                                                                                          },
                                                                                                        message:
                                                                                                          'must be boolean',
                                                                                                      },
                                                                                                    ];
                                                                                                  return false;
                                                                                                }
                                                                                                var valid14 =
                                                                                                  _errs132 ===
                                                                                                  errors;
                                                                                              } else {
                                                                                                var valid14 = true;
                                                                                              }
                                                                                              if (
                                                                                                valid14
                                                                                              ) {
                                                                                                if (
                                                                                                  data59.shouldIncludeReceivedFaxPDFsForOthers !==
                                                                                                  undefined
                                                                                                ) {
                                                                                                  const _errs134 =
                                                                                                    errors;
                                                                                                  if (
                                                                                                    typeof data59.shouldIncludeReceivedFaxPDFsForOthers !==
                                                                                                    'boolean'
                                                                                                  ) {
                                                                                                    validate21.errors =
                                                                                                      [
                                                                                                        {
                                                                                                          instancePath:
                                                                                                            instancePath +
                                                                                                            '/hipaaLock/shouldIncludeReceivedFaxPDFsForOthers',
                                                                                                          schemaPath:
                                                                                                            '#/definitions/HipaaLock/properties/shouldIncludeReceivedFaxPDFsForOthers/type',
                                                                                                          keyword:
                                                                                                            'type',
                                                                                                          params:
                                                                                                            {
                                                                                                              type: 'boolean',
                                                                                                            },
                                                                                                          message:
                                                                                                            'must be boolean',
                                                                                                        },
                                                                                                      ];
                                                                                                    return false;
                                                                                                  }
                                                                                                  var valid14 =
                                                                                                    _errs134 ===
                                                                                                    errors;
                                                                                                } else {
                                                                                                  var valid14 = true;
                                                                                                }
                                                                                                if (
                                                                                                  valid14
                                                                                                ) {
                                                                                                  if (
                                                                                                    data59.includePdfForCcRecipientsOnDocumentSent !==
                                                                                                    undefined
                                                                                                  ) {
                                                                                                    const _errs136 =
                                                                                                      errors;
                                                                                                    if (
                                                                                                      typeof data59.includePdfForCcRecipientsOnDocumentSent !==
                                                                                                      'boolean'
                                                                                                    ) {
                                                                                                      validate21.errors =
                                                                                                        [
                                                                                                          {
                                                                                                            instancePath:
                                                                                                              instancePath +
                                                                                                              '/hipaaLock/includePdfForCcRecipientsOnDocumentSent',
                                                                                                            schemaPath:
                                                                                                              '#/definitions/HipaaLock/properties/includePdfForCcRecipientsOnDocumentSent/type',
                                                                                                            keyword:
                                                                                                              'type',
                                                                                                            params:
                                                                                                              {
                                                                                                                type: 'boolean',
                                                                                                              },
                                                                                                            message:
                                                                                                              'must be boolean',
                                                                                                          },
                                                                                                        ];
                                                                                                      return false;
                                                                                                    }
                                                                                                    var valid14 =
                                                                                                      _errs136 ===
                                                                                                      errors;
                                                                                                  } else {
                                                                                                    var valid14 = true;
                                                                                                  }
                                                                                                  if (
                                                                                                    valid14
                                                                                                  ) {
                                                                                                    if (
                                                                                                      data59.includePdfForCcRecipientsOnDocumentCompleted !==
                                                                                                      undefined
                                                                                                    ) {
                                                                                                      const _errs138 =
                                                                                                        errors;
                                                                                                      if (
                                                                                                        typeof data59.includePdfForCcRecipientsOnDocumentCompleted !==
                                                                                                        'boolean'
                                                                                                      ) {
                                                                                                        validate21.errors =
                                                                                                          [
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/hipaaLock/includePdfForCcRecipientsOnDocumentCompleted',
                                                                                                              schemaPath:
                                                                                                                '#/definitions/HipaaLock/properties/includePdfForCcRecipientsOnDocumentCompleted/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'boolean',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be boolean',
                                                                                                            },
                                                                                                          ];
                                                                                                        return false;
                                                                                                      }
                                                                                                      var valid14 =
                                                                                                        _errs138 ===
                                                                                                        errors;
                                                                                                    } else {
                                                                                                      var valid14 = true;
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      } else {
                                                                                        validate21.errors =
                                                                                          [
                                                                                            {
                                                                                              instancePath:
                                                                                                instancePath +
                                                                                                '/hipaaLock',
                                                                                              schemaPath:
                                                                                                '#/definitions/HipaaLock/type',
                                                                                              keyword:
                                                                                                'type',
                                                                                              params:
                                                                                                {
                                                                                                  type: 'object',
                                                                                                },
                                                                                              message:
                                                                                                'must be object',
                                                                                            },
                                                                                          ];
                                                                                        return false;
                                                                                      }
                                                                                    }
                                                                                    var valid0 =
                                                                                      _errs125 ===
                                                                                      errors;
                                                                                  } else {
                                                                                    var valid0 = true;
                                                                                  }
                                                                                  if (
                                                                                    valid0
                                                                                  ) {
                                                                                    if (
                                                                                      data.notifications !==
                                                                                      undefined
                                                                                    ) {
                                                                                      let data66 =
                                                                                        data.notifications;
                                                                                      const _errs140 =
                                                                                        errors;
                                                                                      const _errs141 =
                                                                                        errors;
                                                                                      if (
                                                                                        errors ===
                                                                                        _errs141
                                                                                      ) {
                                                                                        if (
                                                                                          data66 &&
                                                                                          typeof data66 ==
                                                                                            'object' &&
                                                                                          !Array.isArray(
                                                                                            data66
                                                                                          )
                                                                                        ) {
                                                                                          let missing7;
                                                                                          if (
                                                                                            (data66.hasSMSSignatureDelivery ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'hasSMSSignatureDelivery')) ||
                                                                                            (data66.sendEmailOnDocumentSignedAndSent ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailOnDocumentSignedAndSent')) ||
                                                                                            (data66.sendEmailOnSentDocumentSigned ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailOnSentDocumentSigned')) ||
                                                                                            (data66.sendEmailOnSentDocumentOpened ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailOnSentDocumentOpened')) ||
                                                                                            (data66.sendEmailOnSelfSignedEmbeddedDocument ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailOnSelfSignedEmbeddedDocument')) ||
                                                                                            (data66.sendDailyOutstandingSignatureRequestSummaryEmail ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendDailyOutstandingSignatureRequestSummaryEmail')) ||
                                                                                            (data66.sendEmailOnOrderedSignatureRequestStarted ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailOnOrderedSignatureRequestStarted')) ||
                                                                                            (data66.sendEmailToCcRecipientsOnDocumentSent ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailToCcRecipientsOnDocumentSent')) ||
                                                                                            (data66.sendEmailToCcRecipientsOnDocumentCompleted ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailToCcRecipientsOnDocumentCompleted')) ||
                                                                                            (data66.sendEmailToCcRecipientsOnDocumentDeclined ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailToCcRecipientsOnDocumentDeclined')) ||
                                                                                            (data66.sendEmailToCcRecipientsOnDocumentViewed ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailToCcRecipientsOnDocumentViewed')) ||
                                                                                            (data66.sendEmailToCcRecipientsOnDocumentDelegated ===
                                                                                              undefined &&
                                                                                              (missing7 =
                                                                                                'sendEmailToCcRecipientsOnDocumentDelegated'))
                                                                                          ) {
                                                                                            validate21.errors =
                                                                                              [
                                                                                                {
                                                                                                  instancePath:
                                                                                                    instancePath +
                                                                                                    '/notifications',
                                                                                                  schemaPath:
                                                                                                    '#/definitions/notifications/required',
                                                                                                  keyword:
                                                                                                    'required',
                                                                                                  params:
                                                                                                    {
                                                                                                      missingProperty:
                                                                                                        missing7,
                                                                                                    },
                                                                                                  message:
                                                                                                    "must have required property '" +
                                                                                                    missing7 +
                                                                                                    "'",
                                                                                                },
                                                                                              ];
                                                                                            return false;
                                                                                          } else {
                                                                                            if (
                                                                                              data66.hasSMSSignatureDelivery !==
                                                                                              undefined
                                                                                            ) {
                                                                                              const _errs143 =
                                                                                                errors;
                                                                                              if (
                                                                                                typeof data66.hasSMSSignatureDelivery !==
                                                                                                'boolean'
                                                                                              ) {
                                                                                                validate21.errors =
                                                                                                  [
                                                                                                    {
                                                                                                      instancePath:
                                                                                                        instancePath +
                                                                                                        '/notifications/hasSMSSignatureDelivery',
                                                                                                      schemaPath:
                                                                                                        '#/definitions/notifications/properties/hasSMSSignatureDelivery/type',
                                                                                                      keyword:
                                                                                                        'type',
                                                                                                      params:
                                                                                                        {
                                                                                                          type: 'boolean',
                                                                                                        },
                                                                                                      message:
                                                                                                        'must be boolean',
                                                                                                    },
                                                                                                  ];
                                                                                                return false;
                                                                                              }
                                                                                              var valid16 =
                                                                                                _errs143 ===
                                                                                                errors;
                                                                                            } else {
                                                                                              var valid16 = true;
                                                                                            }
                                                                                            if (
                                                                                              valid16
                                                                                            ) {
                                                                                              if (
                                                                                                data66.sendEmailOnDocumentSignedAndSent !==
                                                                                                undefined
                                                                                              ) {
                                                                                                const _errs145 =
                                                                                                  errors;
                                                                                                if (
                                                                                                  typeof data66.sendEmailOnDocumentSignedAndSent !==
                                                                                                  'boolean'
                                                                                                ) {
                                                                                                  validate21.errors =
                                                                                                    [
                                                                                                      {
                                                                                                        instancePath:
                                                                                                          instancePath +
                                                                                                          '/notifications/sendEmailOnDocumentSignedAndSent',
                                                                                                        schemaPath:
                                                                                                          '#/definitions/notifications/properties/sendEmailOnDocumentSignedAndSent/type',
                                                                                                        keyword:
                                                                                                          'type',
                                                                                                        params:
                                                                                                          {
                                                                                                            type: 'boolean',
                                                                                                          },
                                                                                                        message:
                                                                                                          'must be boolean',
                                                                                                      },
                                                                                                    ];
                                                                                                  return false;
                                                                                                }
                                                                                                var valid16 =
                                                                                                  _errs145 ===
                                                                                                  errors;
                                                                                              } else {
                                                                                                var valid16 = true;
                                                                                              }
                                                                                              if (
                                                                                                valid16
                                                                                              ) {
                                                                                                if (
                                                                                                  data66.sendEmailOnSentDocumentSigned !==
                                                                                                  undefined
                                                                                                ) {
                                                                                                  const _errs147 =
                                                                                                    errors;
                                                                                                  if (
                                                                                                    typeof data66.sendEmailOnSentDocumentSigned !==
                                                                                                    'boolean'
                                                                                                  ) {
                                                                                                    validate21.errors =
                                                                                                      [
                                                                                                        {
                                                                                                          instancePath:
                                                                                                            instancePath +
                                                                                                            '/notifications/sendEmailOnSentDocumentSigned',
                                                                                                          schemaPath:
                                                                                                            '#/definitions/notifications/properties/sendEmailOnSentDocumentSigned/type',
                                                                                                          keyword:
                                                                                                            'type',
                                                                                                          params:
                                                                                                            {
                                                                                                              type: 'boolean',
                                                                                                            },
                                                                                                          message:
                                                                                                            'must be boolean',
                                                                                                        },
                                                                                                      ];
                                                                                                    return false;
                                                                                                  }
                                                                                                  var valid16 =
                                                                                                    _errs147 ===
                                                                                                    errors;
                                                                                                } else {
                                                                                                  var valid16 = true;
                                                                                                }
                                                                                                if (
                                                                                                  valid16
                                                                                                ) {
                                                                                                  if (
                                                                                                    data66.sendEmailOnSentDocumentOpened !==
                                                                                                    undefined
                                                                                                  ) {
                                                                                                    const _errs149 =
                                                                                                      errors;
                                                                                                    if (
                                                                                                      typeof data66.sendEmailOnSentDocumentOpened !==
                                                                                                      'boolean'
                                                                                                    ) {
                                                                                                      validate21.errors =
                                                                                                        [
                                                                                                          {
                                                                                                            instancePath:
                                                                                                              instancePath +
                                                                                                              '/notifications/sendEmailOnSentDocumentOpened',
                                                                                                            schemaPath:
                                                                                                              '#/definitions/notifications/properties/sendEmailOnSentDocumentOpened/type',
                                                                                                            keyword:
                                                                                                              'type',
                                                                                                            params:
                                                                                                              {
                                                                                                                type: 'boolean',
                                                                                                              },
                                                                                                            message:
                                                                                                              'must be boolean',
                                                                                                          },
                                                                                                        ];
                                                                                                      return false;
                                                                                                    }
                                                                                                    var valid16 =
                                                                                                      _errs149 ===
                                                                                                      errors;
                                                                                                  } else {
                                                                                                    var valid16 = true;
                                                                                                  }
                                                                                                  if (
                                                                                                    valid16
                                                                                                  ) {
                                                                                                    if (
                                                                                                      data66.sendEmailOnSelfSignedEmbeddedDocument !==
                                                                                                      undefined
                                                                                                    ) {
                                                                                                      const _errs151 =
                                                                                                        errors;
                                                                                                      if (
                                                                                                        typeof data66.sendEmailOnSelfSignedEmbeddedDocument !==
                                                                                                        'boolean'
                                                                                                      ) {
                                                                                                        validate21.errors =
                                                                                                          [
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/notifications/sendEmailOnSelfSignedEmbeddedDocument',
                                                                                                              schemaPath:
                                                                                                                '#/definitions/notifications/properties/sendEmailOnSelfSignedEmbeddedDocument/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'boolean',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be boolean',
                                                                                                            },
                                                                                                          ];
                                                                                                        return false;
                                                                                                      }
                                                                                                      var valid16 =
                                                                                                        _errs151 ===
                                                                                                        errors;
                                                                                                    } else {
                                                                                                      var valid16 = true;
                                                                                                    }
                                                                                                    if (
                                                                                                      valid16
                                                                                                    ) {
                                                                                                      if (
                                                                                                        data66.sendDailyOutstandingSignatureRequestSummaryEmail !==
                                                                                                        undefined
                                                                                                      ) {
                                                                                                        const _errs153 =
                                                                                                          errors;
                                                                                                        if (
                                                                                                          typeof data66.sendDailyOutstandingSignatureRequestSummaryEmail !==
                                                                                                          'boolean'
                                                                                                        ) {
                                                                                                          validate21.errors =
                                                                                                            [
                                                                                                              {
                                                                                                                instancePath:
                                                                                                                  instancePath +
                                                                                                                  '/notifications/sendDailyOutstandingSignatureRequestSummaryEmail',
                                                                                                                schemaPath:
                                                                                                                  '#/definitions/notifications/properties/sendDailyOutstandingSignatureRequestSummaryEmail/type',
                                                                                                                keyword:
                                                                                                                  'type',
                                                                                                                params:
                                                                                                                  {
                                                                                                                    type: 'boolean',
                                                                                                                  },
                                                                                                                message:
                                                                                                                  'must be boolean',
                                                                                                              },
                                                                                                            ];
                                                                                                          return false;
                                                                                                        }
                                                                                                        var valid16 =
                                                                                                          _errs153 ===
                                                                                                          errors;
                                                                                                      } else {
                                                                                                        var valid16 = true;
                                                                                                      }
                                                                                                      if (
                                                                                                        valid16
                                                                                                      ) {
                                                                                                        if (
                                                                                                          data66.sendEmailOnOrderedSignatureRequestStarted !==
                                                                                                          undefined
                                                                                                        ) {
                                                                                                          const _errs155 =
                                                                                                            errors;
                                                                                                          if (
                                                                                                            typeof data66.sendEmailOnOrderedSignatureRequestStarted !==
                                                                                                            'boolean'
                                                                                                          ) {
                                                                                                            validate21.errors =
                                                                                                              [
                                                                                                                {
                                                                                                                  instancePath:
                                                                                                                    instancePath +
                                                                                                                    '/notifications/sendEmailOnOrderedSignatureRequestStarted',
                                                                                                                  schemaPath:
                                                                                                                    '#/definitions/notifications/properties/sendEmailOnOrderedSignatureRequestStarted/type',
                                                                                                                  keyword:
                                                                                                                    'type',
                                                                                                                  params:
                                                                                                                    {
                                                                                                                      type: 'boolean',
                                                                                                                    },
                                                                                                                  message:
                                                                                                                    'must be boolean',
                                                                                                                },
                                                                                                              ];
                                                                                                            return false;
                                                                                                          }
                                                                                                          var valid16 =
                                                                                                            _errs155 ===
                                                                                                            errors;
                                                                                                        } else {
                                                                                                          var valid16 = true;
                                                                                                        }
                                                                                                        if (
                                                                                                          valid16
                                                                                                        ) {
                                                                                                          if (
                                                                                                            data66.sendEmailToCcRecipientsOnDocumentSent !==
                                                                                                            undefined
                                                                                                          ) {
                                                                                                            const _errs157 =
                                                                                                              errors;
                                                                                                            if (
                                                                                                              typeof data66.sendEmailToCcRecipientsOnDocumentSent !==
                                                                                                              'boolean'
                                                                                                            ) {
                                                                                                              validate21.errors =
                                                                                                                [
                                                                                                                  {
                                                                                                                    instancePath:
                                                                                                                      instancePath +
                                                                                                                      '/notifications/sendEmailToCcRecipientsOnDocumentSent',
                                                                                                                    schemaPath:
                                                                                                                      '#/definitions/notifications/properties/sendEmailToCcRecipientsOnDocumentSent/type',
                                                                                                                    keyword:
                                                                                                                      'type',
                                                                                                                    params:
                                                                                                                      {
                                                                                                                        type: 'boolean',
                                                                                                                      },
                                                                                                                    message:
                                                                                                                      'must be boolean',
                                                                                                                  },
                                                                                                                ];
                                                                                                              return false;
                                                                                                            }
                                                                                                            var valid16 =
                                                                                                              _errs157 ===
                                                                                                              errors;
                                                                                                          } else {
                                                                                                            var valid16 = true;
                                                                                                          }
                                                                                                          if (
                                                                                                            valid16
                                                                                                          ) {
                                                                                                            if (
                                                                                                              data66.sendEmailToCcRecipientsOnDocumentCompleted !==
                                                                                                              undefined
                                                                                                            ) {
                                                                                                              const _errs159 =
                                                                                                                errors;
                                                                                                              if (
                                                                                                                typeof data66.sendEmailToCcRecipientsOnDocumentCompleted !==
                                                                                                                'boolean'
                                                                                                              ) {
                                                                                                                validate21.errors =
                                                                                                                  [
                                                                                                                    {
                                                                                                                      instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/notifications/sendEmailToCcRecipientsOnDocumentCompleted',
                                                                                                                      schemaPath:
                                                                                                                        '#/definitions/notifications/properties/sendEmailToCcRecipientsOnDocumentCompleted/type',
                                                                                                                      keyword:
                                                                                                                        'type',
                                                                                                                      params:
                                                                                                                        {
                                                                                                                          type: 'boolean',
                                                                                                                        },
                                                                                                                      message:
                                                                                                                        'must be boolean',
                                                                                                                    },
                                                                                                                  ];
                                                                                                                return false;
                                                                                                              }
                                                                                                              var valid16 =
                                                                                                                _errs159 ===
                                                                                                                errors;
                                                                                                            } else {
                                                                                                              var valid16 = true;
                                                                                                            }
                                                                                                            if (
                                                                                                              valid16
                                                                                                            ) {
                                                                                                              if (
                                                                                                                data66.sendEmailToCcRecipientsOnDocumentDeclined !==
                                                                                                                undefined
                                                                                                              ) {
                                                                                                                const _errs161 =
                                                                                                                  errors;
                                                                                                                if (
                                                                                                                  typeof data66.sendEmailToCcRecipientsOnDocumentDeclined !==
                                                                                                                  'boolean'
                                                                                                                ) {
                                                                                                                  validate21.errors =
                                                                                                                    [
                                                                                                                      {
                                                                                                                        instancePath:
                                                                                                                          instancePath +
                                                                                                                          '/notifications/sendEmailToCcRecipientsOnDocumentDeclined',
                                                                                                                        schemaPath:
                                                                                                                          '#/definitions/notifications/properties/sendEmailToCcRecipientsOnDocumentDeclined/type',
                                                                                                                        keyword:
                                                                                                                          'type',
                                                                                                                        params:
                                                                                                                          {
                                                                                                                            type: 'boolean',
                                                                                                                          },
                                                                                                                        message:
                                                                                                                          'must be boolean',
                                                                                                                      },
                                                                                                                    ];
                                                                                                                  return false;
                                                                                                                }
                                                                                                                var valid16 =
                                                                                                                  _errs161 ===
                                                                                                                  errors;
                                                                                                              } else {
                                                                                                                var valid16 = true;
                                                                                                              }
                                                                                                              if (
                                                                                                                valid16
                                                                                                              ) {
                                                                                                                if (
                                                                                                                  data66.sendEmailToCcRecipientsOnDocumentViewed !==
                                                                                                                  undefined
                                                                                                                ) {
                                                                                                                  const _errs163 =
                                                                                                                    errors;
                                                                                                                  if (
                                                                                                                    typeof data66.sendEmailToCcRecipientsOnDocumentViewed !==
                                                                                                                    'boolean'
                                                                                                                  ) {
                                                                                                                    validate21.errors =
                                                                                                                      [
                                                                                                                        {
                                                                                                                          instancePath:
                                                                                                                            instancePath +
                                                                                                                            '/notifications/sendEmailToCcRecipientsOnDocumentViewed',
                                                                                                                          schemaPath:
                                                                                                                            '#/definitions/notifications/properties/sendEmailToCcRecipientsOnDocumentViewed/type',
                                                                                                                          keyword:
                                                                                                                            'type',
                                                                                                                          params:
                                                                                                                            {
                                                                                                                              type: 'boolean',
                                                                                                                            },
                                                                                                                          message:
                                                                                                                            'must be boolean',
                                                                                                                        },
                                                                                                                      ];
                                                                                                                    return false;
                                                                                                                  }
                                                                                                                  var valid16 =
                                                                                                                    _errs163 ===
                                                                                                                    errors;
                                                                                                                } else {
                                                                                                                  var valid16 = true;
                                                                                                                }
                                                                                                                if (
                                                                                                                  valid16
                                                                                                                ) {
                                                                                                                  if (
                                                                                                                    data66.sendEmailToCcRecipientsOnDocumentDelegated !==
                                                                                                                    undefined
                                                                                                                  ) {
                                                                                                                    const _errs165 =
                                                                                                                      errors;
                                                                                                                    if (
                                                                                                                      typeof data66.sendEmailToCcRecipientsOnDocumentDelegated !==
                                                                                                                      'boolean'
                                                                                                                    ) {
                                                                                                                      validate21.errors =
                                                                                                                        [
                                                                                                                          {
                                                                                                                            instancePath:
                                                                                                                              instancePath +
                                                                                                                              '/notifications/sendEmailToCcRecipientsOnDocumentDelegated',
                                                                                                                            schemaPath:
                                                                                                                              '#/definitions/notifications/properties/sendEmailToCcRecipientsOnDocumentDelegated/type',
                                                                                                                            keyword:
                                                                                                                              'type',
                                                                                                                            params:
                                                                                                                              {
                                                                                                                                type: 'boolean',
                                                                                                                              },
                                                                                                                            message:
                                                                                                                              'must be boolean',
                                                                                                                          },
                                                                                                                        ];
                                                                                                                      return false;
                                                                                                                    }
                                                                                                                    var valid16 =
                                                                                                                      _errs165 ===
                                                                                                                      errors;
                                                                                                                  } else {
                                                                                                                    var valid16 = true;
                                                                                                                  }
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        } else {
                                                                                          validate21.errors =
                                                                                            [
                                                                                              {
                                                                                                instancePath:
                                                                                                  instancePath +
                                                                                                  '/notifications',
                                                                                                schemaPath:
                                                                                                  '#/definitions/notifications/type',
                                                                                                keyword:
                                                                                                  'type',
                                                                                                params:
                                                                                                  {
                                                                                                    type: 'object',
                                                                                                  },
                                                                                                message:
                                                                                                  'must be object',
                                                                                              },
                                                                                            ];
                                                                                          return false;
                                                                                        }
                                                                                      }
                                                                                      var valid0 =
                                                                                        _errs140 ===
                                                                                        errors;
                                                                                    } else {
                                                                                      var valid0 = true;
                                                                                    }
                                                                                    if (
                                                                                      valid0
                                                                                    ) {
                                                                                      if (
                                                                                        data.notificationAttachments !==
                                                                                        undefined
                                                                                      ) {
                                                                                        let data79 =
                                                                                          data.notificationAttachments;
                                                                                        const _errs167 =
                                                                                          errors;
                                                                                        const _errs168 =
                                                                                          errors;
                                                                                        if (
                                                                                          errors ===
                                                                                          _errs168
                                                                                        ) {
                                                                                          if (
                                                                                            data79 &&
                                                                                            typeof data79 ==
                                                                                              'object' &&
                                                                                            !Array.isArray(
                                                                                              data79
                                                                                            )
                                                                                          ) {
                                                                                            let missing8;
                                                                                            if (
                                                                                              (data79.enableIncludePdfOnDocumentCompleted ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'enableIncludePdfOnDocumentCompleted')) ||
                                                                                              (data79.includePdfOnDocumentCompleted ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'includePdfOnDocumentCompleted')) ||
                                                                                              (data79.enableIncludePdfForCcRecipientsOnDocumentCompleted ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'enableIncludePdfForCcRecipientsOnDocumentCompleted')) ||
                                                                                              (data79.includePdfForCcRecipientsOnDocumentCompleted ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'includePdfForCcRecipientsOnDocumentCompleted')) ||
                                                                                              (data79.enableIncludePdfOnDocumentSent ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'enableIncludePdfOnDocumentSent')) ||
                                                                                              (data79.includePdfOnDocumentSent ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'includePdfOnDocumentSent')) ||
                                                                                              (data79.enableIncludePdfForCcRecipientsOnDocumentSent ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'enableIncludePdfForCcRecipientsOnDocumentSent')) ||
                                                                                              (data79.includePdfForCcRecipientsOnDocumentSent ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'includePdfForCcRecipientsOnDocumentSent')) ||
                                                                                              (data79.enableIncludePdfOnFaxReceived ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'enableIncludePdfOnFaxReceived')) ||
                                                                                              (data79.includePdfOnFaxReceived ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'includePdfOnFaxReceived')) ||
                                                                                              (data79.enableIncludePdfForCcRecipientsOnFaxSent ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'enableIncludePdfForCcRecipientsOnFaxSent')) ||
                                                                                              (data79.includePdfForCcRecipientsOnFaxSent ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'includePdfForCcRecipientsOnFaxSent')) ||
                                                                                              (data79.enableIncludePdfOnFaxSent ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'enableIncludePdfOnFaxSent')) ||
                                                                                              (data79.includePdfOnFaxSent ===
                                                                                                undefined &&
                                                                                                (missing8 =
                                                                                                  'includePdfOnFaxSent'))
                                                                                            ) {
                                                                                              validate21.errors =
                                                                                                [
                                                                                                  {
                                                                                                    instancePath:
                                                                                                      instancePath +
                                                                                                      '/notificationAttachments',
                                                                                                    schemaPath:
                                                                                                      '#/definitions/notificationAttachments/required',
                                                                                                    keyword:
                                                                                                      'required',
                                                                                                    params:
                                                                                                      {
                                                                                                        missingProperty:
                                                                                                          missing8,
                                                                                                      },
                                                                                                    message:
                                                                                                      "must have required property '" +
                                                                                                      missing8 +
                                                                                                      "'",
                                                                                                  },
                                                                                                ];
                                                                                              return false;
                                                                                            } else {
                                                                                              if (
                                                                                                data79.enableIncludePdfOnDocumentCompleted !==
                                                                                                undefined
                                                                                              ) {
                                                                                                const _errs170 =
                                                                                                  errors;
                                                                                                if (
                                                                                                  typeof data79.enableIncludePdfOnDocumentCompleted !==
                                                                                                  'boolean'
                                                                                                ) {
                                                                                                  validate21.errors =
                                                                                                    [
                                                                                                      {
                                                                                                        instancePath:
                                                                                                          instancePath +
                                                                                                          '/notificationAttachments/enableIncludePdfOnDocumentCompleted',
                                                                                                        schemaPath:
                                                                                                          '#/definitions/notificationAttachments/properties/enableIncludePdfOnDocumentCompleted/type',
                                                                                                        keyword:
                                                                                                          'type',
                                                                                                        params:
                                                                                                          {
                                                                                                            type: 'boolean',
                                                                                                          },
                                                                                                        message:
                                                                                                          'must be boolean',
                                                                                                      },
                                                                                                    ];
                                                                                                  return false;
                                                                                                }
                                                                                                var valid18 =
                                                                                                  _errs170 ===
                                                                                                  errors;
                                                                                              } else {
                                                                                                var valid18 = true;
                                                                                              }
                                                                                              if (
                                                                                                valid18
                                                                                              ) {
                                                                                                if (
                                                                                                  data79.includePdfOnDocumentCompleted !==
                                                                                                  undefined
                                                                                                ) {
                                                                                                  const _errs172 =
                                                                                                    errors;
                                                                                                  if (
                                                                                                    typeof data79.includePdfOnDocumentCompleted !==
                                                                                                    'boolean'
                                                                                                  ) {
                                                                                                    validate21.errors =
                                                                                                      [
                                                                                                        {
                                                                                                          instancePath:
                                                                                                            instancePath +
                                                                                                            '/notificationAttachments/includePdfOnDocumentCompleted',
                                                                                                          schemaPath:
                                                                                                            '#/definitions/notificationAttachments/properties/includePdfOnDocumentCompleted/type',
                                                                                                          keyword:
                                                                                                            'type',
                                                                                                          params:
                                                                                                            {
                                                                                                              type: 'boolean',
                                                                                                            },
                                                                                                          message:
                                                                                                            'must be boolean',
                                                                                                        },
                                                                                                      ];
                                                                                                    return false;
                                                                                                  }
                                                                                                  var valid18 =
                                                                                                    _errs172 ===
                                                                                                    errors;
                                                                                                } else {
                                                                                                  var valid18 = true;
                                                                                                }
                                                                                                if (
                                                                                                  valid18
                                                                                                ) {
                                                                                                  if (
                                                                                                    data79.enableIncludePdfForCcRecipientsOnDocumentCompleted !==
                                                                                                    undefined
                                                                                                  ) {
                                                                                                    const _errs174 =
                                                                                                      errors;
                                                                                                    if (
                                                                                                      typeof data79.enableIncludePdfForCcRecipientsOnDocumentCompleted !==
                                                                                                      'boolean'
                                                                                                    ) {
                                                                                                      validate21.errors =
                                                                                                        [
                                                                                                          {
                                                                                                            instancePath:
                                                                                                              instancePath +
                                                                                                              '/notificationAttachments/enableIncludePdfForCcRecipientsOnDocumentCompleted',
                                                                                                            schemaPath:
                                                                                                              '#/definitions/notificationAttachments/properties/enableIncludePdfForCcRecipientsOnDocumentCompleted/type',
                                                                                                            keyword:
                                                                                                              'type',
                                                                                                            params:
                                                                                                              {
                                                                                                                type: 'boolean',
                                                                                                              },
                                                                                                            message:
                                                                                                              'must be boolean',
                                                                                                          },
                                                                                                        ];
                                                                                                      return false;
                                                                                                    }
                                                                                                    var valid18 =
                                                                                                      _errs174 ===
                                                                                                      errors;
                                                                                                  } else {
                                                                                                    var valid18 = true;
                                                                                                  }
                                                                                                  if (
                                                                                                    valid18
                                                                                                  ) {
                                                                                                    if (
                                                                                                      data79.includePdfForCcRecipientsOnDocumentCompleted !==
                                                                                                      undefined
                                                                                                    ) {
                                                                                                      const _errs176 =
                                                                                                        errors;
                                                                                                      if (
                                                                                                        typeof data79.includePdfForCcRecipientsOnDocumentCompleted !==
                                                                                                        'boolean'
                                                                                                      ) {
                                                                                                        validate21.errors =
                                                                                                          [
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/notificationAttachments/includePdfForCcRecipientsOnDocumentCompleted',
                                                                                                              schemaPath:
                                                                                                                '#/definitions/notificationAttachments/properties/includePdfForCcRecipientsOnDocumentCompleted/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'boolean',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be boolean',
                                                                                                            },
                                                                                                          ];
                                                                                                        return false;
                                                                                                      }
                                                                                                      var valid18 =
                                                                                                        _errs176 ===
                                                                                                        errors;
                                                                                                    } else {
                                                                                                      var valid18 = true;
                                                                                                    }
                                                                                                    if (
                                                                                                      valid18
                                                                                                    ) {
                                                                                                      if (
                                                                                                        data79.enableIncludePdfOnDocumentSent !==
                                                                                                        undefined
                                                                                                      ) {
                                                                                                        const _errs178 =
                                                                                                          errors;
                                                                                                        if (
                                                                                                          typeof data79.enableIncludePdfOnDocumentSent !==
                                                                                                          'boolean'
                                                                                                        ) {
                                                                                                          validate21.errors =
                                                                                                            [
                                                                                                              {
                                                                                                                instancePath:
                                                                                                                  instancePath +
                                                                                                                  '/notificationAttachments/enableIncludePdfOnDocumentSent',
                                                                                                                schemaPath:
                                                                                                                  '#/definitions/notificationAttachments/properties/enableIncludePdfOnDocumentSent/type',
                                                                                                                keyword:
                                                                                                                  'type',
                                                                                                                params:
                                                                                                                  {
                                                                                                                    type: 'boolean',
                                                                                                                  },
                                                                                                                message:
                                                                                                                  'must be boolean',
                                                                                                              },
                                                                                                            ];
                                                                                                          return false;
                                                                                                        }
                                                                                                        var valid18 =
                                                                                                          _errs178 ===
                                                                                                          errors;
                                                                                                      } else {
                                                                                                        var valid18 = true;
                                                                                                      }
                                                                                                      if (
                                                                                                        valid18
                                                                                                      ) {
                                                                                                        if (
                                                                                                          data79.includePdfOnDocumentSent !==
                                                                                                          undefined
                                                                                                        ) {
                                                                                                          const _errs180 =
                                                                                                            errors;
                                                                                                          if (
                                                                                                            typeof data79.includePdfOnDocumentSent !==
                                                                                                            'boolean'
                                                                                                          ) {
                                                                                                            validate21.errors =
                                                                                                              [
                                                                                                                {
                                                                                                                  instancePath:
                                                                                                                    instancePath +
                                                                                                                    '/notificationAttachments/includePdfOnDocumentSent',
                                                                                                                  schemaPath:
                                                                                                                    '#/definitions/notificationAttachments/properties/includePdfOnDocumentSent/type',
                                                                                                                  keyword:
                                                                                                                    'type',
                                                                                                                  params:
                                                                                                                    {
                                                                                                                      type: 'boolean',
                                                                                                                    },
                                                                                                                  message:
                                                                                                                    'must be boolean',
                                                                                                                },
                                                                                                              ];
                                                                                                            return false;
                                                                                                          }
                                                                                                          var valid18 =
                                                                                                            _errs180 ===
                                                                                                            errors;
                                                                                                        } else {
                                                                                                          var valid18 = true;
                                                                                                        }
                                                                                                        if (
                                                                                                          valid18
                                                                                                        ) {
                                                                                                          if (
                                                                                                            data79.enableIncludePdfForCcRecipientsOnDocumentSent !==
                                                                                                            undefined
                                                                                                          ) {
                                                                                                            const _errs182 =
                                                                                                              errors;
                                                                                                            if (
                                                                                                              typeof data79.enableIncludePdfForCcRecipientsOnDocumentSent !==
                                                                                                              'boolean'
                                                                                                            ) {
                                                                                                              validate21.errors =
                                                                                                                [
                                                                                                                  {
                                                                                                                    instancePath:
                                                                                                                      instancePath +
                                                                                                                      '/notificationAttachments/enableIncludePdfForCcRecipientsOnDocumentSent',
                                                                                                                    schemaPath:
                                                                                                                      '#/definitions/notificationAttachments/properties/enableIncludePdfForCcRecipientsOnDocumentSent/type',
                                                                                                                    keyword:
                                                                                                                      'type',
                                                                                                                    params:
                                                                                                                      {
                                                                                                                        type: 'boolean',
                                                                                                                      },
                                                                                                                    message:
                                                                                                                      'must be boolean',
                                                                                                                  },
                                                                                                                ];
                                                                                                              return false;
                                                                                                            }
                                                                                                            var valid18 =
                                                                                                              _errs182 ===
                                                                                                              errors;
                                                                                                          } else {
                                                                                                            var valid18 = true;
                                                                                                          }
                                                                                                          if (
                                                                                                            valid18
                                                                                                          ) {
                                                                                                            if (
                                                                                                              data79.includePdfForCcRecipientsOnDocumentSent !==
                                                                                                              undefined
                                                                                                            ) {
                                                                                                              const _errs184 =
                                                                                                                errors;
                                                                                                              if (
                                                                                                                typeof data79.includePdfForCcRecipientsOnDocumentSent !==
                                                                                                                'boolean'
                                                                                                              ) {
                                                                                                                validate21.errors =
                                                                                                                  [
                                                                                                                    {
                                                                                                                      instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/notificationAttachments/includePdfForCcRecipientsOnDocumentSent',
                                                                                                                      schemaPath:
                                                                                                                        '#/definitions/notificationAttachments/properties/includePdfForCcRecipientsOnDocumentSent/type',
                                                                                                                      keyword:
                                                                                                                        'type',
                                                                                                                      params:
                                                                                                                        {
                                                                                                                          type: 'boolean',
                                                                                                                        },
                                                                                                                      message:
                                                                                                                        'must be boolean',
                                                                                                                    },
                                                                                                                  ];
                                                                                                                return false;
                                                                                                              }
                                                                                                              var valid18 =
                                                                                                                _errs184 ===
                                                                                                                errors;
                                                                                                            } else {
                                                                                                              var valid18 = true;
                                                                                                            }
                                                                                                            if (
                                                                                                              valid18
                                                                                                            ) {
                                                                                                              if (
                                                                                                                data79.enableIncludePdfOnFaxReceived !==
                                                                                                                undefined
                                                                                                              ) {
                                                                                                                const _errs186 =
                                                                                                                  errors;
                                                                                                                if (
                                                                                                                  typeof data79.enableIncludePdfOnFaxReceived !==
                                                                                                                  'boolean'
                                                                                                                ) {
                                                                                                                  validate21.errors =
                                                                                                                    [
                                                                                                                      {
                                                                                                                        instancePath:
                                                                                                                          instancePath +
                                                                                                                          '/notificationAttachments/enableIncludePdfOnFaxReceived',
                                                                                                                        schemaPath:
                                                                                                                          '#/definitions/notificationAttachments/properties/enableIncludePdfOnFaxReceived/type',
                                                                                                                        keyword:
                                                                                                                          'type',
                                                                                                                        params:
                                                                                                                          {
                                                                                                                            type: 'boolean',
                                                                                                                          },
                                                                                                                        message:
                                                                                                                          'must be boolean',
                                                                                                                      },
                                                                                                                    ];
                                                                                                                  return false;
                                                                                                                }
                                                                                                                var valid18 =
                                                                                                                  _errs186 ===
                                                                                                                  errors;
                                                                                                              } else {
                                                                                                                var valid18 = true;
                                                                                                              }
                                                                                                              if (
                                                                                                                valid18
                                                                                                              ) {
                                                                                                                if (
                                                                                                                  data79.includePdfOnFaxReceived !==
                                                                                                                  undefined
                                                                                                                ) {
                                                                                                                  const _errs188 =
                                                                                                                    errors;
                                                                                                                  if (
                                                                                                                    typeof data79.includePdfOnFaxReceived !==
                                                                                                                    'boolean'
                                                                                                                  ) {
                                                                                                                    validate21.errors =
                                                                                                                      [
                                                                                                                        {
                                                                                                                          instancePath:
                                                                                                                            instancePath +
                                                                                                                            '/notificationAttachments/includePdfOnFaxReceived',
                                                                                                                          schemaPath:
                                                                                                                            '#/definitions/notificationAttachments/properties/includePdfOnFaxReceived/type',
                                                                                                                          keyword:
                                                                                                                            'type',
                                                                                                                          params:
                                                                                                                            {
                                                                                                                              type: 'boolean',
                                                                                                                            },
                                                                                                                          message:
                                                                                                                            'must be boolean',
                                                                                                                        },
                                                                                                                      ];
                                                                                                                    return false;
                                                                                                                  }
                                                                                                                  var valid18 =
                                                                                                                    _errs188 ===
                                                                                                                    errors;
                                                                                                                } else {
                                                                                                                  var valid18 = true;
                                                                                                                }
                                                                                                                if (
                                                                                                                  valid18
                                                                                                                ) {
                                                                                                                  if (
                                                                                                                    data79.enableIncludePdfForCcRecipientsOnFaxSent !==
                                                                                                                    undefined
                                                                                                                  ) {
                                                                                                                    const _errs190 =
                                                                                                                      errors;
                                                                                                                    if (
                                                                                                                      typeof data79.enableIncludePdfForCcRecipientsOnFaxSent !==
                                                                                                                      'boolean'
                                                                                                                    ) {
                                                                                                                      validate21.errors =
                                                                                                                        [
                                                                                                                          {
                                                                                                                            instancePath:
                                                                                                                              instancePath +
                                                                                                                              '/notificationAttachments/enableIncludePdfForCcRecipientsOnFaxSent',
                                                                                                                            schemaPath:
                                                                                                                              '#/definitions/notificationAttachments/properties/enableIncludePdfForCcRecipientsOnFaxSent/type',
                                                                                                                            keyword:
                                                                                                                              'type',
                                                                                                                            params:
                                                                                                                              {
                                                                                                                                type: 'boolean',
                                                                                                                              },
                                                                                                                            message:
                                                                                                                              'must be boolean',
                                                                                                                          },
                                                                                                                        ];
                                                                                                                      return false;
                                                                                                                    }
                                                                                                                    var valid18 =
                                                                                                                      _errs190 ===
                                                                                                                      errors;
                                                                                                                  } else {
                                                                                                                    var valid18 = true;
                                                                                                                  }
                                                                                                                  if (
                                                                                                                    valid18
                                                                                                                  ) {
                                                                                                                    if (
                                                                                                                      data79.includePdfForCcRecipientsOnFaxSent !==
                                                                                                                      undefined
                                                                                                                    ) {
                                                                                                                      const _errs192 =
                                                                                                                        errors;
                                                                                                                      if (
                                                                                                                        typeof data79.includePdfForCcRecipientsOnFaxSent !==
                                                                                                                        'boolean'
                                                                                                                      ) {
                                                                                                                        validate21.errors =
                                                                                                                          [
                                                                                                                            {
                                                                                                                              instancePath:
                                                                                                                                instancePath +
                                                                                                                                '/notificationAttachments/includePdfForCcRecipientsOnFaxSent',
                                                                                                                              schemaPath:
                                                                                                                                '#/definitions/notificationAttachments/properties/includePdfForCcRecipientsOnFaxSent/type',
                                                                                                                              keyword:
                                                                                                                                'type',
                                                                                                                              params:
                                                                                                                                {
                                                                                                                                  type: 'boolean',
                                                                                                                                },
                                                                                                                              message:
                                                                                                                                'must be boolean',
                                                                                                                            },
                                                                                                                          ];
                                                                                                                        return false;
                                                                                                                      }
                                                                                                                      var valid18 =
                                                                                                                        _errs192 ===
                                                                                                                        errors;
                                                                                                                    } else {
                                                                                                                      var valid18 = true;
                                                                                                                    }
                                                                                                                    if (
                                                                                                                      valid18
                                                                                                                    ) {
                                                                                                                      if (
                                                                                                                        data79.enableIncludePdfOnFaxSent !==
                                                                                                                        undefined
                                                                                                                      ) {
                                                                                                                        const _errs194 =
                                                                                                                          errors;
                                                                                                                        if (
                                                                                                                          typeof data79.enableIncludePdfOnFaxSent !==
                                                                                                                          'boolean'
                                                                                                                        ) {
                                                                                                                          validate21.errors =
                                                                                                                            [
                                                                                                                              {
                                                                                                                                instancePath:
                                                                                                                                  instancePath +
                                                                                                                                  '/notificationAttachments/enableIncludePdfOnFaxSent',
                                                                                                                                schemaPath:
                                                                                                                                  '#/definitions/notificationAttachments/properties/enableIncludePdfOnFaxSent/type',
                                                                                                                                keyword:
                                                                                                                                  'type',
                                                                                                                                params:
                                                                                                                                  {
                                                                                                                                    type: 'boolean',
                                                                                                                                  },
                                                                                                                                message:
                                                                                                                                  'must be boolean',
                                                                                                                              },
                                                                                                                            ];
                                                                                                                          return false;
                                                                                                                        }
                                                                                                                        var valid18 =
                                                                                                                          _errs194 ===
                                                                                                                          errors;
                                                                                                                      } else {
                                                                                                                        var valid18 = true;
                                                                                                                      }
                                                                                                                      if (
                                                                                                                        valid18
                                                                                                                      ) {
                                                                                                                        if (
                                                                                                                          data79.includePdfOnFaxSent !==
                                                                                                                          undefined
                                                                                                                        ) {
                                                                                                                          const _errs196 =
                                                                                                                            errors;
                                                                                                                          if (
                                                                                                                            typeof data79.includePdfOnFaxSent !==
                                                                                                                            'boolean'
                                                                                                                          ) {
                                                                                                                            validate21.errors =
                                                                                                                              [
                                                                                                                                {
                                                                                                                                  instancePath:
                                                                                                                                    instancePath +
                                                                                                                                    '/notificationAttachments/includePdfOnFaxSent',
                                                                                                                                  schemaPath:
                                                                                                                                    '#/definitions/notificationAttachments/properties/includePdfOnFaxSent/type',
                                                                                                                                  keyword:
                                                                                                                                    'type',
                                                                                                                                  params:
                                                                                                                                    {
                                                                                                                                      type: 'boolean',
                                                                                                                                    },
                                                                                                                                  message:
                                                                                                                                    'must be boolean',
                                                                                                                                },
                                                                                                                              ];
                                                                                                                            return false;
                                                                                                                          }
                                                                                                                          var valid18 =
                                                                                                                            _errs196 ===
                                                                                                                            errors;
                                                                                                                        } else {
                                                                                                                          var valid18 = true;
                                                                                                                        }
                                                                                                                      }
                                                                                                                    }
                                                                                                                  }
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          } else {
                                                                                            validate21.errors =
                                                                                              [
                                                                                                {
                                                                                                  instancePath:
                                                                                                    instancePath +
                                                                                                    '/notificationAttachments',
                                                                                                  schemaPath:
                                                                                                    '#/definitions/notificationAttachments/type',
                                                                                                  keyword:
                                                                                                    'type',
                                                                                                  params:
                                                                                                    {
                                                                                                      type: 'object',
                                                                                                    },
                                                                                                  message:
                                                                                                    'must be object',
                                                                                                },
                                                                                              ];
                                                                                            return false;
                                                                                          }
                                                                                        }
                                                                                        var valid0 =
                                                                                          _errs167 ===
                                                                                          errors;
                                                                                      } else {
                                                                                        var valid0 = true;
                                                                                      }
                                                                                      if (
                                                                                        valid0
                                                                                      ) {
                                                                                        if (
                                                                                          data[
                                                                                            '2fa'
                                                                                          ] !==
                                                                                          undefined
                                                                                        ) {
                                                                                          const _errs198 =
                                                                                            errors;
                                                                                          if (
                                                                                            !validate22(
                                                                                              data[
                                                                                                '2fa'
                                                                                              ],
                                                                                              {
                                                                                                instancePath:
                                                                                                  instancePath +
                                                                                                  '/2fa',
                                                                                                parentData:
                                                                                                  data,
                                                                                                parentDataProperty:
                                                                                                  '2fa',
                                                                                                rootData,
                                                                                              }
                                                                                            )
                                                                                          ) {
                                                                                            vErrors =
                                                                                              vErrors ===
                                                                                              null
                                                                                                ? validate22.errors
                                                                                                : vErrors.concat(
                                                                                                    validate22.errors
                                                                                                  );
                                                                                            errors =
                                                                                              vErrors.length;
                                                                                          }
                                                                                          var valid0 =
                                                                                            _errs198 ===
                                                                                            errors;
                                                                                        } else {
                                                                                          var valid0 = true;
                                                                                        }
                                                                                        if (
                                                                                          valid0
                                                                                        ) {
                                                                                          if (
                                                                                            data.onBehalf !==
                                                                                            undefined
                                                                                          ) {
                                                                                            let data95 =
                                                                                              data.onBehalf;
                                                                                            const _errs199 =
                                                                                              errors;
                                                                                            const _errs200 =
                                                                                              errors;
                                                                                            if (
                                                                                              errors ===
                                                                                              _errs200
                                                                                            ) {
                                                                                              if (
                                                                                                data95 &&
                                                                                                typeof data95 ==
                                                                                                  'object' &&
                                                                                                !Array.isArray(
                                                                                                  data95
                                                                                                )
                                                                                              ) {
                                                                                                let missing9;
                                                                                                if (
                                                                                                  (data95.isEmailLocked ===
                                                                                                    undefined &&
                                                                                                    (missing9 =
                                                                                                      'isEmailLocked')) ||
                                                                                                  (data95.isDomainLocked ===
                                                                                                    undefined &&
                                                                                                    (missing9 =
                                                                                                      'isDomainLocked')) ||
                                                                                                  (data95.sendEmailNotificationOnSignatureRequest ===
                                                                                                    undefined &&
                                                                                                    (missing9 =
                                                                                                      'sendEmailNotificationOnSignatureRequest'))
                                                                                                ) {
                                                                                                  validate21.errors =
                                                                                                    [
                                                                                                      {
                                                                                                        instancePath:
                                                                                                          instancePath +
                                                                                                          '/onBehalf',
                                                                                                        schemaPath:
                                                                                                          '#/definitions/onBehalf/required',
                                                                                                        keyword:
                                                                                                          'required',
                                                                                                        params:
                                                                                                          {
                                                                                                            missingProperty:
                                                                                                              missing9,
                                                                                                          },
                                                                                                        message:
                                                                                                          "must have required property '" +
                                                                                                          missing9 +
                                                                                                          "'",
                                                                                                      },
                                                                                                    ];
                                                                                                  return false;
                                                                                                } else {
                                                                                                  if (
                                                                                                    data95.isEmailLocked !==
                                                                                                    undefined
                                                                                                  ) {
                                                                                                    const _errs202 =
                                                                                                      errors;
                                                                                                    if (
                                                                                                      typeof data95.isEmailLocked !==
                                                                                                      'boolean'
                                                                                                    ) {
                                                                                                      validate21.errors =
                                                                                                        [
                                                                                                          {
                                                                                                            instancePath:
                                                                                                              instancePath +
                                                                                                              '/onBehalf/isEmailLocked',
                                                                                                            schemaPath:
                                                                                                              '#/definitions/onBehalf/properties/isEmailLocked/type',
                                                                                                            keyword:
                                                                                                              'type',
                                                                                                            params:
                                                                                                              {
                                                                                                                type: 'boolean',
                                                                                                              },
                                                                                                            message:
                                                                                                              'must be boolean',
                                                                                                          },
                                                                                                        ];
                                                                                                      return false;
                                                                                                    }
                                                                                                    var valid20 =
                                                                                                      _errs202 ===
                                                                                                      errors;
                                                                                                  } else {
                                                                                                    var valid20 = true;
                                                                                                  }
                                                                                                  if (
                                                                                                    valid20
                                                                                                  ) {
                                                                                                    if (
                                                                                                      data95.isDomainLocked !==
                                                                                                      undefined
                                                                                                    ) {
                                                                                                      const _errs204 =
                                                                                                        errors;
                                                                                                      if (
                                                                                                        typeof data95.isDomainLocked !==
                                                                                                        'boolean'
                                                                                                      ) {
                                                                                                        validate21.errors =
                                                                                                          [
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/onBehalf/isDomainLocked',
                                                                                                              schemaPath:
                                                                                                                '#/definitions/onBehalf/properties/isDomainLocked/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'boolean',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be boolean',
                                                                                                            },
                                                                                                          ];
                                                                                                        return false;
                                                                                                      }
                                                                                                      var valid20 =
                                                                                                        _errs204 ===
                                                                                                        errors;
                                                                                                    } else {
                                                                                                      var valid20 = true;
                                                                                                    }
                                                                                                    if (
                                                                                                      valid20
                                                                                                    ) {
                                                                                                      if (
                                                                                                        data95.sendEmailNotificationOnSignatureRequest !==
                                                                                                        undefined
                                                                                                      ) {
                                                                                                        const _errs206 =
                                                                                                          errors;
                                                                                                        if (
                                                                                                          typeof data95.sendEmailNotificationOnSignatureRequest !==
                                                                                                          'boolean'
                                                                                                        ) {
                                                                                                          validate21.errors =
                                                                                                            [
                                                                                                              {
                                                                                                                instancePath:
                                                                                                                  instancePath +
                                                                                                                  '/onBehalf/sendEmailNotificationOnSignatureRequest',
                                                                                                                schemaPath:
                                                                                                                  '#/definitions/onBehalf/properties/sendEmailNotificationOnSignatureRequest/type',
                                                                                                                keyword:
                                                                                                                  'type',
                                                                                                                params:
                                                                                                                  {
                                                                                                                    type: 'boolean',
                                                                                                                  },
                                                                                                                message:
                                                                                                                  'must be boolean',
                                                                                                              },
                                                                                                            ];
                                                                                                          return false;
                                                                                                        }
                                                                                                        var valid20 =
                                                                                                          _errs206 ===
                                                                                                          errors;
                                                                                                      } else {
                                                                                                        var valid20 = true;
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              } else {
                                                                                                validate21.errors =
                                                                                                  [
                                                                                                    {
                                                                                                      instancePath:
                                                                                                        instancePath +
                                                                                                        '/onBehalf',
                                                                                                      schemaPath:
                                                                                                        '#/definitions/onBehalf/type',
                                                                                                      keyword:
                                                                                                        'type',
                                                                                                      params:
                                                                                                        {
                                                                                                          type: 'object',
                                                                                                        },
                                                                                                      message:
                                                                                                        'must be object',
                                                                                                    },
                                                                                                  ];
                                                                                                return false;
                                                                                              }
                                                                                            }
                                                                                            var valid0 =
                                                                                              _errs199 ===
                                                                                              errors;
                                                                                          } else {
                                                                                            var valid0 = true;
                                                                                          }
                                                                                          if (
                                                                                            valid0
                                                                                          ) {
                                                                                            if (
                                                                                              data.billing !==
                                                                                              undefined
                                                                                            ) {
                                                                                              const _errs208 =
                                                                                                errors;
                                                                                              if (
                                                                                                !validate24(
                                                                                                  data.billing,
                                                                                                  {
                                                                                                    instancePath:
                                                                                                      instancePath +
                                                                                                      '/billing',
                                                                                                    parentData:
                                                                                                      data,
                                                                                                    parentDataProperty:
                                                                                                      'billing',
                                                                                                    rootData,
                                                                                                  }
                                                                                                )
                                                                                              ) {
                                                                                                vErrors =
                                                                                                  vErrors ===
                                                                                                  null
                                                                                                    ? validate24.errors
                                                                                                    : vErrors.concat(
                                                                                                        validate24.errors
                                                                                                      );
                                                                                                errors =
                                                                                                  vErrors.length;
                                                                                              }
                                                                                              var valid0 =
                                                                                                _errs208 ===
                                                                                                errors;
                                                                                            } else {
                                                                                              var valid0 = true;
                                                                                            }
                                                                                            if (
                                                                                              valid0
                                                                                            ) {
                                                                                              if (
                                                                                                data.integrations !==
                                                                                                undefined
                                                                                              ) {
                                                                                                let data100 =
                                                                                                  data.integrations;
                                                                                                const _errs209 =
                                                                                                  errors;
                                                                                                if (
                                                                                                  errors ===
                                                                                                  _errs209
                                                                                                ) {
                                                                                                  if (
                                                                                                    Array.isArray(
                                                                                                      data100
                                                                                                    )
                                                                                                  ) {
                                                                                                    var valid21 = true;
                                                                                                    const len2 =
                                                                                                      data100.length;
                                                                                                    for (
                                                                                                      let i2 = 0;
                                                                                                      i2 <
                                                                                                      len2;
                                                                                                      i2++
                                                                                                    ) {
                                                                                                      let data101 =
                                                                                                        data100[
                                                                                                          i2
                                                                                                        ];
                                                                                                      const _errs211 =
                                                                                                        errors;
                                                                                                      const _errs212 =
                                                                                                        errors;
                                                                                                      let valid22 = false;
                                                                                                      let passing0 =
                                                                                                        null;
                                                                                                      const _errs213 =
                                                                                                        errors;
                                                                                                      const _errs214 =
                                                                                                        errors;
                                                                                                      if (
                                                                                                        errors ===
                                                                                                        _errs214
                                                                                                      ) {
                                                                                                        if (
                                                                                                          data101 &&
                                                                                                          typeof data101 ==
                                                                                                            'object' &&
                                                                                                          !Array.isArray(
                                                                                                            data101
                                                                                                          )
                                                                                                        ) {
                                                                                                          let missing10;
                                                                                                          if (
                                                                                                            (data101.name ===
                                                                                                              undefined &&
                                                                                                              (missing10 =
                                                                                                                'name')) ||
                                                                                                            (data101.serviceTypeCode ===
                                                                                                              undefined &&
                                                                                                              (missing10 =
                                                                                                                'serviceTypeCode')) ||
                                                                                                            (data101.isEnabled ===
                                                                                                              undefined &&
                                                                                                              (missing10 =
                                                                                                                'isEnabled')) ||
                                                                                                            (data101.isActive ===
                                                                                                              undefined &&
                                                                                                              (missing10 =
                                                                                                                'isActive'))
                                                                                                          ) {
                                                                                                            const err0 =
                                                                                                              {
                                                                                                                instancePath:
                                                                                                                  instancePath +
                                                                                                                  '/integrations/' +
                                                                                                                  i2,
                                                                                                                schemaPath:
                                                                                                                  '#/definitions/editableIntegration/required',
                                                                                                                keyword:
                                                                                                                  'required',
                                                                                                                params:
                                                                                                                  {
                                                                                                                    missingProperty:
                                                                                                                      missing10,
                                                                                                                  },
                                                                                                                message:
                                                                                                                  "must have required property '" +
                                                                                                                  missing10 +
                                                                                                                  "'",
                                                                                                              };
                                                                                                            if (
                                                                                                              vErrors ===
                                                                                                              null
                                                                                                            ) {
                                                                                                              vErrors =
                                                                                                                [
                                                                                                                  err0,
                                                                                                                ];
                                                                                                            } else {
                                                                                                              vErrors.push(
                                                                                                                err0
                                                                                                              );
                                                                                                            }
                                                                                                            errors++;
                                                                                                          } else {
                                                                                                            if (
                                                                                                              data101.name !==
                                                                                                              undefined
                                                                                                            ) {
                                                                                                              const _errs216 =
                                                                                                                errors;
                                                                                                              if (
                                                                                                                typeof data101.name !==
                                                                                                                'string'
                                                                                                              ) {
                                                                                                                const err1 =
                                                                                                                  {
                                                                                                                    instancePath:
                                                                                                                      instancePath +
                                                                                                                      '/integrations/' +
                                                                                                                      i2 +
                                                                                                                      '/name',
                                                                                                                    schemaPath:
                                                                                                                      '#/definitions/editableIntegration/properties/name/type',
                                                                                                                    keyword:
                                                                                                                      'type',
                                                                                                                    params:
                                                                                                                      {
                                                                                                                        type: 'string',
                                                                                                                      },
                                                                                                                    message:
                                                                                                                      'must be string',
                                                                                                                  };
                                                                                                                if (
                                                                                                                  vErrors ===
                                                                                                                  null
                                                                                                                ) {
                                                                                                                  vErrors =
                                                                                                                    [
                                                                                                                      err1,
                                                                                                                    ];
                                                                                                                } else {
                                                                                                                  vErrors.push(
                                                                                                                    err1
                                                                                                                  );
                                                                                                                }
                                                                                                                errors++;
                                                                                                              }
                                                                                                              var valid24 =
                                                                                                                _errs216 ===
                                                                                                                errors;
                                                                                                            } else {
                                                                                                              var valid24 = true;
                                                                                                            }
                                                                                                            if (
                                                                                                              valid24
                                                                                                            ) {
                                                                                                              if (
                                                                                                                data101.serviceTypeCode !==
                                                                                                                undefined
                                                                                                              ) {
                                                                                                                const _errs218 =
                                                                                                                  errors;
                                                                                                                if (
                                                                                                                  typeof data101.serviceTypeCode !==
                                                                                                                  'string'
                                                                                                                ) {
                                                                                                                  const err2 =
                                                                                                                    {
                                                                                                                      instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/integrations/' +
                                                                                                                        i2 +
                                                                                                                        '/serviceTypeCode',
                                                                                                                      schemaPath:
                                                                                                                        '#/definitions/editableIntegration/properties/serviceTypeCode/type',
                                                                                                                      keyword:
                                                                                                                        'type',
                                                                                                                      params:
                                                                                                                        {
                                                                                                                          type: 'string',
                                                                                                                        },
                                                                                                                      message:
                                                                                                                        'must be string',
                                                                                                                    };
                                                                                                                  if (
                                                                                                                    vErrors ===
                                                                                                                    null
                                                                                                                  ) {
                                                                                                                    vErrors =
                                                                                                                      [
                                                                                                                        err2,
                                                                                                                      ];
                                                                                                                  } else {
                                                                                                                    vErrors.push(
                                                                                                                      err2
                                                                                                                    );
                                                                                                                  }
                                                                                                                  errors++;
                                                                                                                }
                                                                                                                var valid24 =
                                                                                                                  _errs218 ===
                                                                                                                  errors;
                                                                                                              } else {
                                                                                                                var valid24 = true;
                                                                                                              }
                                                                                                              if (
                                                                                                                valid24
                                                                                                              ) {
                                                                                                                if (
                                                                                                                  data101.isEnabled !==
                                                                                                                  undefined
                                                                                                                ) {
                                                                                                                  const _errs220 =
                                                                                                                    errors;
                                                                                                                  if (
                                                                                                                    typeof data101.isEnabled !==
                                                                                                                    'boolean'
                                                                                                                  ) {
                                                                                                                    const err3 =
                                                                                                                      {
                                                                                                                        instancePath:
                                                                                                                          instancePath +
                                                                                                                          '/integrations/' +
                                                                                                                          i2 +
                                                                                                                          '/isEnabled',
                                                                                                                        schemaPath:
                                                                                                                          '#/definitions/editableIntegration/properties/isEnabled/type',
                                                                                                                        keyword:
                                                                                                                          'type',
                                                                                                                        params:
                                                                                                                          {
                                                                                                                            type: 'boolean',
                                                                                                                          },
                                                                                                                        message:
                                                                                                                          'must be boolean',
                                                                                                                      };
                                                                                                                    if (
                                                                                                                      vErrors ===
                                                                                                                      null
                                                                                                                    ) {
                                                                                                                      vErrors =
                                                                                                                        [
                                                                                                                          err3,
                                                                                                                        ];
                                                                                                                    } else {
                                                                                                                      vErrors.push(
                                                                                                                        err3
                                                                                                                      );
                                                                                                                    }
                                                                                                                    errors++;
                                                                                                                  }
                                                                                                                  var valid24 =
                                                                                                                    _errs220 ===
                                                                                                                    errors;
                                                                                                                } else {
                                                                                                                  var valid24 = true;
                                                                                                                }
                                                                                                                if (
                                                                                                                  valid24
                                                                                                                ) {
                                                                                                                  if (
                                                                                                                    data101.isActive !==
                                                                                                                    undefined
                                                                                                                  ) {
                                                                                                                    const _errs222 =
                                                                                                                      errors;
                                                                                                                    if (
                                                                                                                      typeof data101.isActive !==
                                                                                                                      'boolean'
                                                                                                                    ) {
                                                                                                                      const err4 =
                                                                                                                        {
                                                                                                                          instancePath:
                                                                                                                            instancePath +
                                                                                                                            '/integrations/' +
                                                                                                                            i2 +
                                                                                                                            '/isActive',
                                                                                                                          schemaPath:
                                                                                                                            '#/definitions/editableIntegration/properties/isActive/type',
                                                                                                                          keyword:
                                                                                                                            'type',
                                                                                                                          params:
                                                                                                                            {
                                                                                                                              type: 'boolean',
                                                                                                                            },
                                                                                                                          message:
                                                                                                                            'must be boolean',
                                                                                                                        };
                                                                                                                      if (
                                                                                                                        vErrors ===
                                                                                                                        null
                                                                                                                      ) {
                                                                                                                        vErrors =
                                                                                                                          [
                                                                                                                            err4,
                                                                                                                          ];
                                                                                                                      } else {
                                                                                                                        vErrors.push(
                                                                                                                          err4
                                                                                                                        );
                                                                                                                      }
                                                                                                                      errors++;
                                                                                                                    }
                                                                                                                    var valid24 =
                                                                                                                      _errs222 ===
                                                                                                                      errors;
                                                                                                                  } else {
                                                                                                                    var valid24 = true;
                                                                                                                  }
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          }
                                                                                                        } else {
                                                                                                          const err5 =
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/integrations/' +
                                                                                                                i2,
                                                                                                              schemaPath:
                                                                                                                '#/definitions/editableIntegration/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'object',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be object',
                                                                                                            };
                                                                                                          if (
                                                                                                            vErrors ===
                                                                                                            null
                                                                                                          ) {
                                                                                                            vErrors =
                                                                                                              [
                                                                                                                err5,
                                                                                                              ];
                                                                                                          } else {
                                                                                                            vErrors.push(
                                                                                                              err5
                                                                                                            );
                                                                                                          }
                                                                                                          errors++;
                                                                                                        }
                                                                                                      }
                                                                                                      var _valid0 =
                                                                                                        _errs213 ===
                                                                                                        errors;
                                                                                                      if (
                                                                                                        _valid0
                                                                                                      ) {
                                                                                                        valid22 = true;
                                                                                                        passing0 = 0;
                                                                                                      }
                                                                                                      const _errs224 =
                                                                                                        errors;
                                                                                                      const _errs225 =
                                                                                                        errors;
                                                                                                      if (
                                                                                                        errors ===
                                                                                                        _errs225
                                                                                                      ) {
                                                                                                        if (
                                                                                                          data101 &&
                                                                                                          typeof data101 ==
                                                                                                            'object' &&
                                                                                                          !Array.isArray(
                                                                                                            data101
                                                                                                          )
                                                                                                        ) {
                                                                                                          let missing11;
                                                                                                          if (
                                                                                                            (data101.name ===
                                                                                                              undefined &&
                                                                                                              (missing11 =
                                                                                                                'name')) ||
                                                                                                            (data101.link ===
                                                                                                              undefined &&
                                                                                                              (missing11 =
                                                                                                                'link')) ||
                                                                                                            (data101.isEnabled ===
                                                                                                              undefined &&
                                                                                                              (missing11 =
                                                                                                                'isEnabled'))
                                                                                                          ) {
                                                                                                            const err6 =
                                                                                                              {
                                                                                                                instancePath:
                                                                                                                  instancePath +
                                                                                                                  '/integrations/' +
                                                                                                                  i2,
                                                                                                                schemaPath:
                                                                                                                  '#/definitions/linkedIntegration/required',
                                                                                                                keyword:
                                                                                                                  'required',
                                                                                                                params:
                                                                                                                  {
                                                                                                                    missingProperty:
                                                                                                                      missing11,
                                                                                                                  },
                                                                                                                message:
                                                                                                                  "must have required property '" +
                                                                                                                  missing11 +
                                                                                                                  "'",
                                                                                                              };
                                                                                                            if (
                                                                                                              vErrors ===
                                                                                                              null
                                                                                                            ) {
                                                                                                              vErrors =
                                                                                                                [
                                                                                                                  err6,
                                                                                                                ];
                                                                                                            } else {
                                                                                                              vErrors.push(
                                                                                                                err6
                                                                                                              );
                                                                                                            }
                                                                                                            errors++;
                                                                                                          } else {
                                                                                                            if (
                                                                                                              data101.name !==
                                                                                                              undefined
                                                                                                            ) {
                                                                                                              const _errs227 =
                                                                                                                errors;
                                                                                                              if (
                                                                                                                typeof data101.name !==
                                                                                                                'string'
                                                                                                              ) {
                                                                                                                const err7 =
                                                                                                                  {
                                                                                                                    instancePath:
                                                                                                                      instancePath +
                                                                                                                      '/integrations/' +
                                                                                                                      i2 +
                                                                                                                      '/name',
                                                                                                                    schemaPath:
                                                                                                                      '#/definitions/linkedIntegration/properties/name/type',
                                                                                                                    keyword:
                                                                                                                      'type',
                                                                                                                    params:
                                                                                                                      {
                                                                                                                        type: 'string',
                                                                                                                      },
                                                                                                                    message:
                                                                                                                      'must be string',
                                                                                                                  };
                                                                                                                if (
                                                                                                                  vErrors ===
                                                                                                                  null
                                                                                                                ) {
                                                                                                                  vErrors =
                                                                                                                    [
                                                                                                                      err7,
                                                                                                                    ];
                                                                                                                } else {
                                                                                                                  vErrors.push(
                                                                                                                    err7
                                                                                                                  );
                                                                                                                }
                                                                                                                errors++;
                                                                                                              }
                                                                                                              var valid26 =
                                                                                                                _errs227 ===
                                                                                                                errors;
                                                                                                            } else {
                                                                                                              var valid26 = true;
                                                                                                            }
                                                                                                            if (
                                                                                                              valid26
                                                                                                            ) {
                                                                                                              if (
                                                                                                                data101.link !==
                                                                                                                undefined
                                                                                                              ) {
                                                                                                                const _errs229 =
                                                                                                                  errors;
                                                                                                                if (
                                                                                                                  typeof data101.link !==
                                                                                                                  'string'
                                                                                                                ) {
                                                                                                                  const err8 =
                                                                                                                    {
                                                                                                                      instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/integrations/' +
                                                                                                                        i2 +
                                                                                                                        '/link',
                                                                                                                      schemaPath:
                                                                                                                        '#/definitions/linkedIntegration/properties/link/type',
                                                                                                                      keyword:
                                                                                                                        'type',
                                                                                                                      params:
                                                                                                                        {
                                                                                                                          type: 'string',
                                                                                                                        },
                                                                                                                      message:
                                                                                                                        'must be string',
                                                                                                                    };
                                                                                                                  if (
                                                                                                                    vErrors ===
                                                                                                                    null
                                                                                                                  ) {
                                                                                                                    vErrors =
                                                                                                                      [
                                                                                                                        err8,
                                                                                                                      ];
                                                                                                                  } else {
                                                                                                                    vErrors.push(
                                                                                                                      err8
                                                                                                                    );
                                                                                                                  }
                                                                                                                  errors++;
                                                                                                                }
                                                                                                                var valid26 =
                                                                                                                  _errs229 ===
                                                                                                                  errors;
                                                                                                              } else {
                                                                                                                var valid26 = true;
                                                                                                              }
                                                                                                              if (
                                                                                                                valid26
                                                                                                              ) {
                                                                                                                if (
                                                                                                                  data101.isEnabled !==
                                                                                                                  undefined
                                                                                                                ) {
                                                                                                                  const _errs231 =
                                                                                                                    errors;
                                                                                                                  if (
                                                                                                                    typeof data101.isEnabled !==
                                                                                                                    'boolean'
                                                                                                                  ) {
                                                                                                                    const err9 =
                                                                                                                      {
                                                                                                                        instancePath:
                                                                                                                          instancePath +
                                                                                                                          '/integrations/' +
                                                                                                                          i2 +
                                                                                                                          '/isEnabled',
                                                                                                                        schemaPath:
                                                                                                                          '#/definitions/linkedIntegration/properties/isEnabled/type',
                                                                                                                        keyword:
                                                                                                                          'type',
                                                                                                                        params:
                                                                                                                          {
                                                                                                                            type: 'boolean',
                                                                                                                          },
                                                                                                                        message:
                                                                                                                          'must be boolean',
                                                                                                                      };
                                                                                                                    if (
                                                                                                                      vErrors ===
                                                                                                                      null
                                                                                                                    ) {
                                                                                                                      vErrors =
                                                                                                                        [
                                                                                                                          err9,
                                                                                                                        ];
                                                                                                                    } else {
                                                                                                                      vErrors.push(
                                                                                                                        err9
                                                                                                                      );
                                                                                                                    }
                                                                                                                    errors++;
                                                                                                                  }
                                                                                                                  var valid26 =
                                                                                                                    _errs231 ===
                                                                                                                    errors;
                                                                                                                } else {
                                                                                                                  var valid26 = true;
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          }
                                                                                                        } else {
                                                                                                          const err10 =
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/integrations/' +
                                                                                                                i2,
                                                                                                              schemaPath:
                                                                                                                '#/definitions/linkedIntegration/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'object',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be object',
                                                                                                            };
                                                                                                          if (
                                                                                                            vErrors ===
                                                                                                            null
                                                                                                          ) {
                                                                                                            vErrors =
                                                                                                              [
                                                                                                                err10,
                                                                                                              ];
                                                                                                          } else {
                                                                                                            vErrors.push(
                                                                                                              err10
                                                                                                            );
                                                                                                          }
                                                                                                          errors++;
                                                                                                        }
                                                                                                      }
                                                                                                      var _valid0 =
                                                                                                        _errs224 ===
                                                                                                        errors;
                                                                                                      if (
                                                                                                        _valid0 &&
                                                                                                        valid22
                                                                                                      ) {
                                                                                                        valid22 = false;
                                                                                                        passing0 =
                                                                                                          [
                                                                                                            passing0,
                                                                                                            1,
                                                                                                          ];
                                                                                                      } else {
                                                                                                        if (
                                                                                                          _valid0
                                                                                                        ) {
                                                                                                          valid22 = true;
                                                                                                          passing0 = 1;
                                                                                                        }
                                                                                                      }
                                                                                                      if (
                                                                                                        !valid22
                                                                                                      ) {
                                                                                                        const err11 =
                                                                                                          {
                                                                                                            instancePath:
                                                                                                              instancePath +
                                                                                                              '/integrations/' +
                                                                                                              i2,
                                                                                                            schemaPath:
                                                                                                              '#/properties/integrations/items/oneOf',
                                                                                                            keyword:
                                                                                                              'oneOf',
                                                                                                            params:
                                                                                                              {
                                                                                                                passingSchemas:
                                                                                                                  passing0,
                                                                                                              },
                                                                                                            message:
                                                                                                              'must match exactly one schema in oneOf',
                                                                                                          };
                                                                                                        if (
                                                                                                          vErrors ===
                                                                                                          null
                                                                                                        ) {
                                                                                                          vErrors =
                                                                                                            [
                                                                                                              err11,
                                                                                                            ];
                                                                                                        } else {
                                                                                                          vErrors.push(
                                                                                                            err11
                                                                                                          );
                                                                                                        }
                                                                                                        errors++;
                                                                                                        validate21.errors =
                                                                                                          vErrors;
                                                                                                        return false;
                                                                                                      } else {
                                                                                                        errors =
                                                                                                          _errs212;
                                                                                                        if (
                                                                                                          vErrors !==
                                                                                                          null
                                                                                                        ) {
                                                                                                          if (
                                                                                                            _errs212
                                                                                                          ) {
                                                                                                            vErrors.length =
                                                                                                              _errs212;
                                                                                                          } else {
                                                                                                            vErrors =
                                                                                                              null;
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                      var valid21 =
                                                                                                        _errs211 ===
                                                                                                        errors;
                                                                                                      if (
                                                                                                        !valid21
                                                                                                      ) {
                                                                                                        break;
                                                                                                      }
                                                                                                    }
                                                                                                  } else {
                                                                                                    validate21.errors =
                                                                                                      [
                                                                                                        {
                                                                                                          instancePath:
                                                                                                            instancePath +
                                                                                                            '/integrations',
                                                                                                          schemaPath:
                                                                                                            '#/properties/integrations/type',
                                                                                                          keyword:
                                                                                                            'type',
                                                                                                          params:
                                                                                                            {
                                                                                                              type: 'array',
                                                                                                            },
                                                                                                          message:
                                                                                                            'must be array',
                                                                                                        },
                                                                                                      ];
                                                                                                    return false;
                                                                                                  }
                                                                                                }
                                                                                                var valid0 =
                                                                                                  _errs209 ===
                                                                                                  errors;
                                                                                              } else {
                                                                                                var valid0 = true;
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate21.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate21.errors = vErrors;
  return errors === 0;
}
function validate10(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="WebApp.json" */ let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate10.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  const _errs3 = errors;
  if (errors === _errs3) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.emailAddress === undefined && (missing0 = 'emailAddress')) {
        const err0 = {
          instancePath,
          schemaPath: 'AcceptTermsData.json/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.firstName !== undefined) {
          const _errs5 = errors;
          if (typeof data.firstName !== 'string') {
            const err1 = {
              instancePath: instancePath + '/firstName',
              schemaPath: 'AcceptTermsData.json/properties/firstName/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
          var valid2 = _errs5 === errors;
        } else {
          var valid2 = true;
        }
        if (valid2) {
          if (data.lastName !== undefined) {
            const _errs7 = errors;
            if (typeof data.lastName !== 'string') {
              const err2 = {
                instancePath: instancePath + '/lastName',
                schemaPath: 'AcceptTermsData.json/properties/lastName/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs7 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.emailAddress !== undefined) {
              const _errs9 = errors;
              if (typeof data.emailAddress !== 'string') {
                const err3 = {
                  instancePath: instancePath + '/emailAddress',
                  schemaPath:
                    'AcceptTermsData.json/properties/emailAddress/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var valid2 = _errs9 === errors;
            } else {
              var valid2 = true;
            }
          }
        }
      }
    } else {
      const err4 = {
        instancePath,
        schemaPath: 'AcceptTermsData.json/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs11 = errors;
  if (
    !validate11(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate11.errors : vErrors.concat(validate11.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs11 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs12 = errors;
    const _errs13 = errors;
    if (errors === _errs13) {
      if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing1;
        if (
          (data.message === undefined && (missing1 = 'message')) ||
          (data.code === undefined && (missing1 = 'code'))
        ) {
          const err5 = {
            instancePath,
            schemaPath: 'ErrorShape.json/required',
            keyword: 'required',
            params: { missingProperty: missing1 },
            message: "must have required property '" + missing1 + "'",
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        } else {
          if (data.code !== undefined) {
            const _errs15 = errors;
            if (typeof data.code !== 'string') {
              const err6 = {
                instancePath: instancePath + '/code',
                schemaPath: 'ErrorShape.json/properties/code/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            var valid4 = _errs15 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.message !== undefined) {
              const _errs17 = errors;
              if (typeof data.message !== 'string') {
                const err7 = {
                  instancePath: instancePath + '/message',
                  schemaPath: 'ErrorShape.json/properties/message/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
              var valid4 = _errs17 === errors;
            } else {
              var valid4 = true;
            }
          }
        }
      } else {
        const err8 = {
          instancePath,
          schemaPath: 'ErrorShape.json/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    var _valid0 = _errs12 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs19 = errors;
      const _errs20 = errors;
      if (errors === _errs20) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
          let missing2;
          if (
            (data.saml === undefined && (missing2 = 'saml')) ||
            (data.login_url === undefined && (missing2 = 'login_url')) ||
            (data.disable_arkose === undefined && (missing2 = 'disable_arkose'))
          ) {
            const err9 = {
              instancePath,
              schemaPath: 'SamlCheckResponse.json/required',
              keyword: 'required',
              params: { missingProperty: missing2 },
              message: "must have required property '" + missing2 + "'",
            };
            if (vErrors === null) {
              vErrors = [err9];
            } else {
              vErrors.push(err9);
            }
            errors++;
          } else {
            if (data.saml !== undefined) {
              const _errs22 = errors;
              if (typeof data.saml !== 'boolean') {
                const err10 = {
                  instancePath: instancePath + '/saml',
                  schemaPath: 'SamlCheckResponse.json/properties/saml/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              var valid6 = _errs22 === errors;
            } else {
              var valid6 = true;
            }
            if (valid6) {
              if (data.login_url !== undefined) {
                const _errs24 = errors;
                if (typeof data.login_url !== 'string') {
                  const err11 = {
                    instancePath: instancePath + '/login_url',
                    schemaPath:
                      'SamlCheckResponse.json/properties/login_url/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                var valid6 = _errs24 === errors;
              } else {
                var valid6 = true;
              }
              if (valid6) {
                if (data.disable_arkose !== undefined) {
                  const _errs26 = errors;
                  if (typeof data.disable_arkose !== 'boolean') {
                    const err12 = {
                      instancePath: instancePath + '/disable_arkose',
                      schemaPath:
                        'SamlCheckResponse.json/properties/disable_arkose/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    };
                    if (vErrors === null) {
                      vErrors = [err12];
                    } else {
                      vErrors.push(err12);
                    }
                    errors++;
                  }
                  var valid6 = _errs26 === errors;
                } else {
                  var valid6 = true;
                }
              }
            }
          }
        } else {
          const err13 = {
            instancePath,
            schemaPath: 'SamlCheckResponse.json/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
      }
      var _valid0 = _errs19 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs28 = errors;
        if (
          !validate13(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
          })
        ) {
          vErrors =
            vErrors === null
              ? validate13.errors
              : vErrors.concat(validate13.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs28 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
          const _errs29 = errors;
          if (
            !validate15(data, {
              instancePath,
              parentData,
              parentDataProperty,
              rootData,
            })
          ) {
            vErrors =
              vErrors === null
                ? validate15.errors
                : vErrors.concat(validate15.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs29 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
            }
            const _errs30 = errors;
            if (
              !validate17(data, {
                instancePath,
                parentData,
                parentDataProperty,
                rootData,
              })
            ) {
              vErrors =
                vErrors === null
                  ? validate17.errors
                  : vErrors.concat(validate17.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs30 === errors;
            if (_valid0 && valid0) {
              valid0 = false;
              passing0 = [passing0, 6];
            } else {
              if (_valid0) {
                valid0 = true;
                passing0 = 6;
              }
              const _errs31 = errors;
              if (
                !validate19(data, {
                  instancePath,
                  parentData,
                  parentDataProperty,
                  rootData,
                })
              ) {
                vErrors =
                  vErrors === null
                    ? validate19.errors
                    : vErrors.concat(validate19.errors);
                errors = vErrors.length;
              }
              var _valid0 = _errs31 === errors;
              if (_valid0 && valid0) {
                valid0 = false;
                passing0 = [passing0, 7];
              } else {
                if (_valid0) {
                  valid0 = true;
                  passing0 = 7;
                }
                const _errs32 = errors;
                if (
                  !validate21(data, {
                    instancePath,
                    parentData,
                    parentDataProperty,
                    rootData,
                  })
                ) {
                  vErrors =
                    vErrors === null
                      ? validate21.errors
                      : vErrors.concat(validate21.errors);
                  errors = vErrors.length;
                }
                var _valid0 = _errs32 === errors;
                if (_valid0 && valid0) {
                  valid0 = false;
                  passing0 = [passing0, 8];
                } else {
                  if (_valid0) {
                    valid0 = true;
                    passing0 = 8;
                  }
                  const _errs33 = errors;
                  const _errs34 = errors;
                  if (errors === _errs34) {
                    if (
                      data &&
                      typeof data == 'object' &&
                      !Array.isArray(data)
                    ) {
                      let missing3;
                      if (
                        data.success === undefined &&
                        (missing3 = 'success')
                      ) {
                        const err14 = {
                          instancePath,
                          schemaPath: 'WebAppSpaListing.json/required',
                          keyword: 'required',
                          params: { missingProperty: missing3 },
                          message:
                            "must have required property '" + missing3 + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err14];
                        } else {
                          vErrors.push(err14);
                        }
                        errors++;
                      } else {
                        if (data.data !== undefined) {
                          const _errs36 = errors;
                          if (!Array.isArray(data.data)) {
                            const err15 = {
                              instancePath: instancePath + '/data',
                              schemaPath:
                                'WebAppSpaListing.json/properties/data/type',
                              keyword: 'type',
                              params: { type: 'array' },
                              message: 'must be array',
                            };
                            if (vErrors === null) {
                              vErrors = [err15];
                            } else {
                              vErrors.push(err15);
                            }
                            errors++;
                          }
                          var valid8 = _errs36 === errors;
                        } else {
                          var valid8 = true;
                        }
                        if (valid8) {
                          if (data.numPages !== undefined) {
                            let data9 = data.numPages;
                            const _errs38 = errors;
                            if (
                              !(
                                typeof data9 == 'number' &&
                                !(data9 % 1) &&
                                !isNaN(data9) &&
                                isFinite(data9)
                              )
                            ) {
                              const err16 = {
                                instancePath: instancePath + '/numPages',
                                schemaPath:
                                  'WebAppSpaListing.json/properties/numPages/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer',
                              };
                              if (vErrors === null) {
                                vErrors = [err16];
                              } else {
                                vErrors.push(err16);
                              }
                              errors++;
                            }
                            var valid8 = _errs38 === errors;
                          } else {
                            var valid8 = true;
                          }
                          if (valid8) {
                            if (data.numResults !== undefined) {
                              let data10 = data.numResults;
                              const _errs40 = errors;
                              if (
                                !(
                                  typeof data10 == 'number' &&
                                  !(data10 % 1) &&
                                  !isNaN(data10) &&
                                  isFinite(data10)
                                )
                              ) {
                                const err17 = {
                                  instancePath: instancePath + '/numResults',
                                  schemaPath:
                                    'WebAppSpaListing.json/properties/numResults/type',
                                  keyword: 'type',
                                  params: { type: 'integer' },
                                  message: 'must be integer',
                                };
                                if (vErrors === null) {
                                  vErrors = [err17];
                                } else {
                                  vErrors.push(err17);
                                }
                                errors++;
                              }
                              var valid8 = _errs40 === errors;
                            } else {
                              var valid8 = true;
                            }
                            if (valid8) {
                              if (data.numResultsTotal !== undefined) {
                                let data11 = data.numResultsTotal;
                                const _errs42 = errors;
                                if (
                                  !(
                                    typeof data11 == 'number' &&
                                    !(data11 % 1) &&
                                    !isNaN(data11) &&
                                    isFinite(data11)
                                  )
                                ) {
                                  const err18 = {
                                    instancePath:
                                      instancePath + '/numResultsTotal',
                                    schemaPath:
                                      'WebAppSpaListing.json/properties/numResultsTotal/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err18];
                                  } else {
                                    vErrors.push(err18);
                                  }
                                  errors++;
                                }
                                var valid8 = _errs42 === errors;
                              } else {
                                var valid8 = true;
                              }
                              if (valid8) {
                                if (data.pageSize !== undefined) {
                                  let data12 = data.pageSize;
                                  const _errs44 = errors;
                                  if (
                                    !(
                                      typeof data12 == 'number' &&
                                      !(data12 % 1) &&
                                      !isNaN(data12) &&
                                      isFinite(data12)
                                    )
                                  ) {
                                    const err19 = {
                                      instancePath: instancePath + '/pageSize',
                                      schemaPath:
                                        'WebAppSpaListing.json/properties/pageSize/type',
                                      keyword: 'type',
                                      params: { type: 'integer' },
                                      message: 'must be integer',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err19];
                                    } else {
                                      vErrors.push(err19);
                                    }
                                    errors++;
                                  }
                                  var valid8 = _errs44 === errors;
                                } else {
                                  var valid8 = true;
                                }
                                if (valid8) {
                                  if (data.success !== undefined) {
                                    const _errs46 = errors;
                                    if (typeof data.success !== 'boolean') {
                                      const err20 = {
                                        instancePath: instancePath + '/success',
                                        schemaPath:
                                          'WebAppSpaListing.json/properties/success/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err20];
                                      } else {
                                        vErrors.push(err20);
                                      }
                                      errors++;
                                    }
                                    var valid8 = _errs46 === errors;
                                  } else {
                                    var valid8 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      const err21 = {
                        instancePath,
                        schemaPath: 'WebAppSpaListing.json/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      };
                      if (vErrors === null) {
                        vErrors = [err21];
                      } else {
                        vErrors.push(err21);
                      }
                      errors++;
                    }
                  }
                  var _valid0 = _errs33 === errors;
                  if (_valid0 && valid0) {
                    valid0 = false;
                    passing0 = [passing0, 9];
                  } else {
                    if (_valid0) {
                      valid0 = true;
                      passing0 = 9;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err22 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err22];
    } else {
      vErrors.push(err22);
    }
    errors++;
    validate10.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate10.errors = vErrors;
  return errors === 0;
}
exports.validateAcceptTermsData = validate27;
function validate27(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="AcceptTermsData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.emailAddress === undefined && (missing0 = 'emailAddress')) {
        validate27.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.firstName !== undefined) {
          const _errs1 = errors;
          if (typeof data.firstName !== 'string') {
            validate27.errors = [
              {
                instancePath: instancePath + '/firstName',
                schemaPath: '#/properties/firstName/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.lastName !== undefined) {
            const _errs3 = errors;
            if (typeof data.lastName !== 'string') {
              validate27.errors = [
                {
                  instancePath: instancePath + '/lastName',
                  schemaPath: '#/properties/lastName/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.emailAddress !== undefined) {
              const _errs5 = errors;
              if (typeof data.emailAddress !== 'string') {
                validate27.errors = [
                  {
                    instancePath: instancePath + '/emailAddress',
                    schemaPath: '#/properties/emailAddress/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate27.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate27.errors = vErrors;
  return errors === 0;
}
exports.validateDropboxManagedCheckResponse = validate11;
exports.validateErrorShape = validate28;
function validate28(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="ErrorShape.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.message === undefined && (missing0 = 'message')) ||
        (data.code === undefined && (missing0 = 'code'))
      ) {
        validate28.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.code !== undefined) {
          const _errs1 = errors;
          if (typeof data.code !== 'string') {
            validate28.errors = [
              {
                instancePath: instancePath + '/code',
                schemaPath: '#/properties/code/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.message !== undefined) {
            const _errs3 = errors;
            if (typeof data.message !== 'string') {
              validate28.errors = [
                {
                  instancePath: instancePath + '/message',
                  schemaPath: '#/properties/message/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate28.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate28.errors = vErrors;
  return errors === 0;
}
exports.validateSamlCheckResponse = validate29;
function validate29(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="SamlCheckResponse.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.saml === undefined && (missing0 = 'saml')) ||
        (data.login_url === undefined && (missing0 = 'login_url')) ||
        (data.disable_arkose === undefined && (missing0 = 'disable_arkose'))
      ) {
        validate29.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.saml !== undefined) {
          const _errs1 = errors;
          if (typeof data.saml !== 'boolean') {
            validate29.errors = [
              {
                instancePath: instancePath + '/saml',
                schemaPath: '#/properties/saml/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.login_url !== undefined) {
            const _errs3 = errors;
            if (typeof data.login_url !== 'string') {
              validate29.errors = [
                {
                  instancePath: instancePath + '/login_url',
                  schemaPath: '#/properties/login_url/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.disable_arkose !== undefined) {
              const _errs5 = errors;
              if (typeof data.disable_arkose !== 'boolean') {
                validate29.errors = [
                  {
                    instancePath: instancePath + '/disable_arkose',
                    schemaPath: '#/properties/disable_arkose/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate29.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate29.errors = vErrors;
  return errors === 0;
}
exports.validateSignInResponse = validate13;
exports.validateSignUpData = validate15;
exports.validateSignUpResponse = validate17;
exports.validateWebAppAccount = validate19;
exports.validateSiteCode = validate30;
function validate30(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="SiteCode.json" */ let vErrors = null;
  let errors = 0;
  if (typeof data !== 'string') {
    validate30.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'string' },
        message: 'must be string',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (!func0(data, 'S')) {
    const err0 = {
      instancePath,
      schemaPath: '#/oneOf/0/const',
      keyword: 'const',
      params: { allowedValue: 'S' },
      message: 'must be equal to constant',
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (!func0(data, 'F')) {
    const err1 = {
      instancePath,
      schemaPath: '#/oneOf/1/const',
      keyword: 'const',
      params: { allowedValue: 'F' },
      message: 'must be equal to constant',
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (!func0(data, 'W')) {
      const err2 = {
        instancePath,
        schemaPath: '#/oneOf/2/const',
        keyword: 'const',
        params: { allowedValue: 'W' },
        message: 'must be equal to constant',
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err3 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
    validate30.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate30.errors = vErrors;
  return errors === 0;
}
exports.validateWebAppAccountSettings = validate21;
exports.validateTimezone = validate31;
function validate31(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Timezone.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.offset === undefined && (missing0 = 'offset')) ||
        (data.hasDST === undefined && (missing0 = 'hasDST')) ||
        (data.displayName === undefined && (missing0 = 'displayName'))
      ) {
        validate31.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.offset !== undefined) {
          let data0 = data.offset;
          const _errs1 = errors;
          if (!(typeof data0 == 'number' && isFinite(data0))) {
            validate31.errors = [
              {
                instancePath: instancePath + '/offset',
                schemaPath: '#/properties/offset/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.hasDST !== undefined) {
            const _errs3 = errors;
            if (typeof data.hasDST !== 'boolean') {
              validate31.errors = [
                {
                  instancePath: instancePath + '/hasDST',
                  schemaPath: '#/properties/hasDST/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.displayName !== undefined) {
              const _errs5 = errors;
              if (typeof data.displayName !== 'string') {
                validate31.errors = [
                  {
                    instancePath: instancePath + '/displayName',
                    schemaPath: '#/properties/displayName/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate31.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate31.errors = vErrors;
  return errors === 0;
}
exports.validateWebAappBillingSettings = validate24;
exports.validateWebAppSpaListing = validate32;
function validate32(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="WebAppSpaListing.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.success === undefined && (missing0 = 'success')) {
        validate32.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.data !== undefined) {
          const _errs1 = errors;
          if (!Array.isArray(data.data)) {
            validate32.errors = [
              {
                instancePath: instancePath + '/data',
                schemaPath: '#/properties/data/type',
                keyword: 'type',
                params: { type: 'array' },
                message: 'must be array',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.numPages !== undefined) {
            let data1 = data.numPages;
            const _errs3 = errors;
            if (
              !(
                typeof data1 == 'number' &&
                !(data1 % 1) &&
                !isNaN(data1) &&
                isFinite(data1)
              )
            ) {
              validate32.errors = [
                {
                  instancePath: instancePath + '/numPages',
                  schemaPath: '#/properties/numPages/type',
                  keyword: 'type',
                  params: { type: 'integer' },
                  message: 'must be integer',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.numResults !== undefined) {
              let data2 = data.numResults;
              const _errs5 = errors;
              if (
                !(
                  typeof data2 == 'number' &&
                  !(data2 % 1) &&
                  !isNaN(data2) &&
                  isFinite(data2)
                )
              ) {
                validate32.errors = [
                  {
                    instancePath: instancePath + '/numResults',
                    schemaPath: '#/properties/numResults/type',
                    keyword: 'type',
                    params: { type: 'integer' },
                    message: 'must be integer',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.numResultsTotal !== undefined) {
                let data3 = data.numResultsTotal;
                const _errs7 = errors;
                if (
                  !(
                    typeof data3 == 'number' &&
                    !(data3 % 1) &&
                    !isNaN(data3) &&
                    isFinite(data3)
                  )
                ) {
                  validate32.errors = [
                    {
                      instancePath: instancePath + '/numResultsTotal',
                      schemaPath: '#/properties/numResultsTotal/type',
                      keyword: 'type',
                      params: { type: 'integer' },
                      message: 'must be integer',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.pageSize !== undefined) {
                  let data4 = data.pageSize;
                  const _errs9 = errors;
                  if (
                    !(
                      typeof data4 == 'number' &&
                      !(data4 % 1) &&
                      !isNaN(data4) &&
                      isFinite(data4)
                    )
                  ) {
                    validate32.errors = [
                      {
                        instancePath: instancePath + '/pageSize',
                        schemaPath: '#/properties/pageSize/type',
                        keyword: 'type',
                        params: { type: 'integer' },
                        message: 'must be integer',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.success !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.success !== 'boolean') {
                      validate32.errors = [
                        {
                          instancePath: instancePath + '/success',
                          schemaPath: '#/properties/success/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate32.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate32.errors = vErrors;
  return errors === 0;
}
